(function(){
var STORE = !!window.CSB;
function AURL(n){ if (typeof n === "string") return "url(" + (PHS[n] || PHB) + ")"; return "url(" + (STORE ? CSB.atlas + n + ".webp" + (CSB.av ? "?v=" + CSB.av : "") : "a" + n + ".webp") + ")"; }
"use strict";
var D = null, SW = 1024;
var BASE_PRICE = {silver:26.99, rose:26.99, gold:29.99, black:27.99};
var BASE_NAME = {silver:"Silver", rose:"Rose gold", gold:"Gold", black:"Black"};
var SIZE_LBL = {18:"Wrist 14.5 – 16 cm (5.7 – 6.3 in)", 20:"Wrist 16.5 – 18 cm (6.5 – 7.1 in)", 22:"Wrist 18.5 – 22 cm (7.3 – 8.7 in)"};
var PLAIN_LINKS = 18, LINK_AR = 0.88;
var CREDIT_RATE = (window.CSB && CSB.credit != null) ? CSB.credit : 0.05, CREDIT_CAP = (window.CSB && CSB.creditCap) ? CSB.creditCap * (CSB.ratio || 1) : 0;
var TOOL_PRICE = (window.CSB && CSB.toolPrice != null) ? CSB.toolPrice : 7.99;
function creditFor(T){ var v = Math.round(T.paid * 100 * CREDIT_RATE) / 100; if (CREDIT_CAP > 0 && v > CREDIT_CAP) v = CREDIT_CAP; return v > 0 ? v : 0; }
var REDUCED = !!(window.matchMedia && matchMedia("(prefers-reduced-motion: reduce)").matches);
var GIFT_NOTE = ["Mom, Mama and Mother's Day designs.", "Best friend words and bestie designs.", "Zodiac signs, birthstones, years and party charms.", "Dogs, cats and paw prints.", "Flags, cities, landmarks, planes and globes.", "Couples, kisses and love-you charms."];
var S = {br:[], cur:0, sel:-1, q:"", scope:{t:"all"}, sub:-1, gift:0, metal:"all", sort:"best", page:1, per:0, pages:1, hearts:{}, asked:false, pop:-1, flyOn:false, lastC:0, recent:[]};
var B = null;
S.setc = 0; S.sset = -1;
function $(id){ return document.getElementById(id); }
function money(x){ var c = Math.round(x * 100); if (window.CS && typeof CS.formatMoney === "function"){ try { return CS.formatMoney(c); } catch(e){} } return "$" + (c / 100).toFixed(2); }
var FX = (window.Shopify && Shopify.currency && Number(Shopify.currency.rate)) || 1;
function fx(usd){ return Math.round(usd * FX * 100) / 100; }
function store(k, v){ try { if (v === undefined) return localStorage.getItem(k); localStorage.setItem(k, v); } catch(e){ return null; } }
try { var hs = JSON.parse(store("cs_hearts") || "{}"); if (hs && typeof hs === "object") S.hearts = hs; } catch(e){}
S.asked = store("cs_hearts_asked") === "1";
function newBracelet(base, size){ var b = {base: base || "silver", size: size || 20, slots: [], own: []}; for (var k=0;k<b.size;k++){ b.slots.push(null); b.own.push(-1); } return b; }
S.br.push(newBracelet()); B = S.br[0];
function setCur(i){ S.cur = i; B = S.br[i]; S.sel = -1; }
function allPieces(){ var a = []; S.br.forEach(function(b){ b.slots.forEach(function(p){ if (p) a.push(p); }); }); return a; }
function piecesOf(b){ var a = []; b.slots.forEach(function(p){ if (p) a.push(p); }); return a; }
function charmCount(){ return allPieces().length; }
function onCount(i, vi){ return allPieces().filter(function(p){ return p.i===i && (vi==null || p.vi===vi); }).length; }
function snapshot(){ return JSON.stringify({br: S.br, cur: S.cur, recent: S.recent}); }
function restore(s){ var o = JSON.parse(s); S.br = o.br; S.recent = o.recent || []; setCur(Math.min(o.cur, S.br.length-1)); update(); }
function remember(p){ S.recent = S.recent.filter(function(q){ return !(q.i === p.i && q.vi === p.vi); }); S.recent.unshift(p); if (S.recent.length > 12) S.recent.length = 12; }
function E(a){ return D.A[a]; }
var ATLIMG = {}, THUMBS = {};
function ASRC(n){ if (typeof n === "string") return PHS[n] || PHB; return STORE ? CSB.atlas + n + ".webp" + (CSB.av ? "?v=" + CSB.av : "") : "a" + n + ".webp"; }
function sheetLoad(n, cb){
var s = ATLIMG[n];
if (s && s.ok){ cb(s.img); return; }
if (!s){
s = ATLIMG[n] = {cbs: [], img: new Image()};
s.img.onload = function(){ s.ok = 1; var l = s.cbs; s.cbs = []; l.forEach(function(f){ try { f(s.img); } catch(e){} }); setTimeout(function(){ if (ATLIMG[n] === s) delete ATLIMG[n]; }, 3000); };
s.img.onerror = function(){ if (ATLIMG[n] === s) delete ATLIMG[n]; };
s.img.src = ASRC(n);
}
s.cbs.push(cb);
}
function thumbCanvas(a, box, pad, dy){
var r = Math.min(2, window.devicePixelRatio || 1), px = Math.round(box * r), key = a + ":" + box + ":" + pad + ":" + px;
var c = document.createElement("canvas"); c.width = c.height = px;
function copy(t){ var x = c.getContext("2d"); if (x) x.drawImage(t, 0, 0); }
if (THUMBS[key]){ copy(THUMBS[key]); return c; }
var e = E(a);
sheetLoad(e[0], function(img){
if (!THUMBS[key]){
var t = document.createElement("canvas"); t.width = t.height = px; var x = t.getContext("2d");
var f = img.naturalWidth / SW, inner = box * pad, k = Math.min(inner / e[3], inner / e[4]), w = e[3] * k, h = e[4] * k;
if (x){ x.imageSmoothingQuality = "high"; x.shadowColor = "rgba(40,30,15,.18)"; x.shadowBlur = 2 * r; x.shadowOffsetY = 2 * r; x.drawImage(img, e[1] * f, e[2] * f, e[3] * f, e[4] * f, (box - w) / 2 * r, ((box - h) / 2 + (dy || 0)) * r, w * r, h * r); }
THUMBS[key] = t;
}
copy(THUMBS[key]);
});
return c;
}
function paintXY(el, a, kx, ky){ var e = E(a), sh = D.sh && D.sh[e[0]]; el.style.backgroundImage = AURL(e[0]); el.style.backgroundSize = (SW*kx) + "px " + (sh ? (sh*ky) + "px" : "auto"); el.style.backgroundPosition = (-e[1]*kx) + "px " + (-e[2]*(sh ? ky : kx)) + "px"; el.style.width = (e[3]*kx) + "px"; el.style.height = (e[4]*(sh ? ky : kx)) + "px"; }
function paint(el, a, k){ var e = E(a); el.style.backgroundImage = AURL(e[0]); el.style.backgroundSize = (SW*k) + "px auto"; el.style.backgroundPosition = (-e[1]*k) + "px " + (-e[2]*k) + "px"; el.style.width = (e[3]*k) + "px"; el.style.height = (e[4]*k) + "px"; }
function fit(el, a, box, pad, dn){ var e = E(a), inner = box * (pad || 0.74), k = Math.min(inner/e[3], inner/e[4]), w = e[3]*k, h = e[4]*k, t = (box - h)/2; paint(el, a, k); if (dn) t = Math.min(Math.max(t, 28), box - h - 6); el.style.left = ((box - w)/2) + "px"; el.style.top = t + "px"; }
function aOf(i, vi){ var it = D.items[i]; return vi == null ? it.a : it.vv[vi][3]; }
function spanA(p){ var v = p.kind === 2 && D.chv && D.chv[p.a]; return v ? v[Math.max(1, Math.min(4, p.span)) - 1] : p.a; }
function makePiece(i, vi){ var a = aOf(i, vi), e = E(a); return {i:i, vi:vi, a:a, kind:e[9], span: e[9] === 2 ? Math.max(1, Math.min(4, e[10] || 2)) : (e[10] || 1)}; }
function blocked(p, s){ return p.kind === 3 ? [s, s+1] : p.kind === 2 ? [s, s + p.span] : [s]; }
function ownLinks(p, s){ return p.kind === 3 ? [s, s+1] : p.kind === 2 ? [s, s + p.span] : [s]; }
function linkCount(p){ return (p.kind === 3 || p.kind === 2) ? 2 : 1; }
function scaleFor(p, W){ var e = E(p.a); if (p.kind === 2) return W / e[7]; return W / (e[7] / (p.kind === 3 ? 2 : 1)); }
function chainParts(p, s, W, H, Hb){
var e = E(p.a), lx = e[5], ly = e[6], lw = e[7], lh = e[8], rx = e[11] > e[5] ? e[11] : e[5] + e[7] * 2, rw = e[12] || lw;
var kxL = W / lw, kxR = W / rw, kxM = (kxL + kxR) / 2, ky = Hb / lh, midW = Math.max(1, rx - lx - lw), gapPx = (p.span - 1) * W;
var y = (H - Hb)/2 - ly*ky, h = e[4]*ky, parts = [];
parts.push({x: s*W - lx*kxL, y: y, w: (lx + lw)*kxL, h: h, bx: e[1], by: e[2], kx: kxL, ky: ky, z: 3});
parts.push({x: (s + p.span)*W, y: y, w: (e[3] - rx)*kxR, h: h, bx: e[1] + rx, by: e[2], kx: kxR, ky: ky, z: 3});
var vis = gapPx > 0 ? gapPx : W, left = gapPx > 0 ? s*W + W : s*W + W/2, nat = midW*kxM, x0 = e[1] + lx + lw;
var cw = nat * 0.42, sw = (nat - cw) / 2;
if (vis >= nat * 0.6){
var sx = Math.max(0.3, (vis - cw) / 2 / sw), sideW = sw * sx;
parts.push({x: left, y: y, w: sw, h: h, bx: x0, by: e[2], kx: kxM, ky: ky, z: 0, sx: sx, mid: true});
parts.push({x: left + sideW, y: y, w: cw, h: h, bx: x0 + sw/kxM, by: e[2], kx: kxM, ky: ky, z: 0, sx: 1, mid: true});
parts.push({x: left + sideW + cw, y: y, w: sw, h: h, bx: x0 + (sw + cw)/kxM, by: e[2], kx: kxM, ky: ky, z: 0, sx: sx, mid: true});
} else {
parts.push({x: left, y: y, w: nat, h: h, bx: x0, by: e[2], kx: kxM, ky: ky, z: 0, sx: vis / nat, mid: true});
}
return parts;
}
function paintCrop(el, part){ var e = E(el._a), sh = D.sh && D.sh[e[0]], ky = sh ? part.ky : part.kx; el.style.backgroundImage = AURL(e[0]); el.style.backgroundSize = (SW*part.kx) + "px " + (sh ? (sh*ky) + "px" : "auto"); el.style.backgroundPosition = (-part.bx*part.kx) + "px " + (-part.by*ky) + "px"; el.style.width = part.w + "px"; el.style.height = part.h + "px"; }
var SALE = null;
function saleCmp(i, vi){ if (!SALE){ SALE = {}; (D.sale || []).forEach(function(x){ SALE[x[0] + ":" + x[1]] = x[2]; }); } return SALE[i + ":" + (vi == null ? -1 : vi)] || 0; }
function salePct(){ var m = 0; (D.sale || []).forEach(function(x){ var p = priceOf(x[0], x[1] < 0 ? null : x[1]); if (x[2] > p) m = Math.max(m, Math.floor((x[2] - p) / x[2] * 100)); }); return m; }
function priceOf(i, vi){ var it = D.items[i], v = vi != null && it.vv ? it.vv[vi] : null; return v && v[6] != null ? v[6] : it.p; }
function priceVaries(i){ var it = D.items[i]; return !!(it.vv && it.vv.some(function(v){ return v[6] != null; })); }
function designName(i, vi){ var it = D.items[i]; if (vi == null || !it.vv) return it.t; var v = it.vv[vi]; return (v[0] && v[0].length > 2 ? v[0] : v[1] || v[0]) || (it.t + " " + (vi+1)); }
function pieceName(p){ return designName(p.i, p.vi); }
function rowDrop(bb, W, H, Hb){ var d = 0; bb.slots.forEach(function(p){ if (!p) return; var e = E(spanA(p)), ky = D.sh ? Hb / e[8] : W*(p.kind === 3 ? 2 : 1) / e[7], below = (H - Hb)/2 - e[6]*ky + e[4]*ky - H; if (below > d) d = below; }); return d; }
function renderRow(el, W, b, opts){
opts = opts || {};
var n = b.size, H = W*LINK_AR, plain = D.plain[b.base], pe = E(plain), pk = W/pe[3], Hb = pe[4]*pk, top = 2, drop = 0;
function geo(p, s){ var a = spanA(p), e = E(a), units = p.kind === 3 ? 2 : 1, kx = W*units / e[7], ky = D.sh ? Hb / e[8] : kx; return {a:a, e:e, k:kx, kx:kx, ky:ky, x: s*W - e[5]*kx, y: (H - Hb)/2 - e[6]*ky}; }
var own = {};
b.slots.forEach(function(p, s){ if (!p) return; ownLinks(p, s).forEach(function(c){ own[c] = 1; }); var g = geo(p, s), ky = p.kind === 2 && D.sh ? Hb / g.e[8] : g.ky, below = (H - Hb)/2 - g.e[6]*ky + g.e[4]*ky - H; if (below > drop) drop = below; });
if (opts.even) S.br.forEach(function(bb){ var d = rowDrop(bb, W, H, Hb); if (d > drop) drop = d; });
var h = top + H + Math.max(0, drop) + 6;
el.innerHTML = ""; el.style.width = (n*W) + "px"; el.style.height = h + "px";
for (var c=0;c<n;c++){
if (own[c]) continue;
var lk = document.createElement("i"); lk.className = "lk"; paint(lk, plain, pk); lk.style.left = (c*W) + "px"; lk.style.top = (top + (H - pe[4]*pk)/2) + "px"; lk.style.zIndex = 1; el.appendChild(lk);
}
b.slots.forEach(function(p, s){
if (!p) return;
var popCls = (opts.pop && s === S.pop ? (S.flyOn ? " land" : " pop") : "");
if (p.kind === 2 && spanA(p) !== p.a){
var gc = geo(p, s), cc = document.createElement("i"); cc.className = "pc" + popCls + (opts.hits && S.sway === s ? " sway" : "");
paintXY(cc, gc.a, gc.kx, gc.ky); cc.style.left = gc.x + "px"; cc.style.top = (top + gc.y) + "px"; cc.style.zIndex = 3; el.appendChild(cc);
return;
}
if (p.kind === 2){
chainParts(p, s, W, H, Hb).forEach(function(part){ var pc = document.createElement("i"); pc.className = "pc" + (part.mid ? " mid" : popCls) + (part.mid && opts.hits && S.sway === s ? " sway" : ""); pc._a = p.a; paintCrop(pc, part); pc.style.left = part.x + "px"; pc.style.top = (top + part.y) + "px"; pc.style.zIndex = part.z; if (part.mid){ pc.style.transform = "scaleX(" + part.sx.toFixed(3) + ")"; pc.style.setProperty("--sx", part.sx.toFixed(3)); } el.appendChild(pc); });
return;
}
var g = geo(p, s), pc = document.createElement("i");
if (p.kind === 1 && opts.hits && S.sway === s && !REDUCED){
var ee = g.e, yk = (D.sh && D.sh[ee[0]]) ? g.ky : g.kx, cut = (ee[6] + ee[8]) * yk, piv = (ee[5] + ee[7]/2) * g.kx;
[0, 1].forEach(function(lo){
var q = document.createElement("i"); q.className = "pc" + popCls + (lo ? " swing" : "");
paintXY(q, p.a, g.kx, g.ky); q.style.left = g.x + "px"; q.style.top = (top + g.y) + "px"; q.style.zIndex = 3;
q.style.clipPath = lo ? "inset(" + (cut - 0.5).toFixed(1) + "px 0 0 0)" : "inset(0 0 calc(100% - " + cut.toFixed(1) + "px) 0)";
if (lo) q.style.transformOrigin = piv.toFixed(1) + "px " + cut.toFixed(1) + "px";
el.appendChild(q);
});
return;
}
pc.className = "pc" + popCls + (opts.hits && S.sway === s && p.kind === 1 ? " sway" : "");
paintXY(pc, p.a, g.kx, g.ky); pc.style.left = g.x + "px"; pc.style.top = (top + g.y) + "px"; pc.style.zIndex = p.kind === 1 ? 3 : 2;
el.appendChild(pc);
});
if (opts.hits){
for (var s2=0;s2<n;s2++){
(function(slot){
var btn = document.createElement("button"); btn.type = "button"; btn.className = "hit" + (S.sel === slot ? " sel" : "");
btn.style.left = (slot*W) + "px"; btn.style.top = top + "px"; btn.style.width = W + "px"; btn.style.height = H + "px"; btn.style.zIndex = 5;
var owner = b.own[slot], p = owner >= 0 ? b.slots[owner] : null;
btn.setAttribute("aria-label", "Link " + (slot+1) + (p ? ": " + pieceName(p) : ": plain link"));
btn.addEventListener("click", function(){ var o = B.own[slot], target = o >= 0 ? o : slot; S.sel = S.sel === target ? -1 : target; var tp = B.slots[target]; S.sway = tp && (tp.kind === 1 || tp.kind === 2) ? target : -1; renderStage(); S.sway = -1; });
el.appendChild(btn);
})(s2);
}
}
return h;
}
function Wpx(){ return parseFloat(getComputedStyle(document.documentElement).getPropertyValue("--W")) || 46; }
function renderTabs(){
var t = $("brTabs"), c = charmCount(); t.innerHTML = "";
S.br.forEach(function(b, i){
var n = piecesOf(b).length, btn = document.createElement("button"); btn.type = "button"; btn.className = "tab"; btn.setAttribute("role", "tab"); btn.setAttribute("aria-selected", i === S.cur);
btn.innerHTML = '<i class="' + b.base + '"></i>Bracelet ' + (i+1) + (n ? ' <span style="opacity:.75">· ' + n + '</span>' : "");
btn.addEventListener("click", function(){ var was = S.cur; setCur(i); renderStage(); renderMeter(); scrollToSlot(Math.floor(B.size/2) - 1, false); if (i !== was) stageIn(i - was); });
t.appendChild(btn);
});
var acts = $("brActs"); acts.innerHTML = "";
var freeNow = S.br.length < Math.min(3, Math.floor(c/10)) && S.br.length >= 1, add = document.createElement("button"); add.type = "button"; add.className = "rbtn" + (freeNow ? " free" : "");
add.innerHTML = SV.plus + (freeNow ? "<span>" + (S.br.length === 1 ? "2nd" : "3rd") + " bracelet free</span>" : ""); add.setAttribute("aria-label", freeNow ? "Add your free " + (S.br.length === 1 ? "second" : "third") + " bracelet" : "Add a bracelet");
add.addEventListener("click", function(){ if (STORE) store("csb_br_no", ""); S.br.push(newBracelet(B.base, B.size)); setCur(S.br.length-1); update(); scrollToSlot(Math.floor(B.size/2) - 1, false); stageIn(1); toast(freeNow ? "Bracelet " + S.br.length + " added. It's free with your charms" : "Bracelet " + S.br.length + " added. Tap a charm to fill it"); });
acts.appendChild(add);
if (c || S.br.length > 1){
var more = document.createElement("button"); more.type = "button"; more.className = "rbtn"; more.setAttribute("aria-label", "More options"); more.innerHTML = SV.more;
more.addEventListener("click", openMore); acts.appendChild(more);
}
var sel = t.querySelector('[aria-selected="true"]');
if (sel){ var L = sel.offsetLeft, R = L + sel.offsetWidth; if (L < t.scrollLeft) t.scrollLeft = L - 8; else if (R > t.scrollLeft + t.clientWidth) t.scrollLeft = R - t.clientWidth + 8; }
tabFade();
}
function tabFade(){ var t = $("brTabs"); t.classList.toggle("fade", t.scrollWidth - t.clientWidth - t.scrollLeft > 4); }
function startOver(){ var snap = snapshot(); allPieces().forEach(remember); S.br = [newBracelet(B.base, B.size)]; setCur(0); update(); toast("Cleared everything", {label:"Undo", fn:function(){ restore(snap); }}); }
function removeBracelet(i){ var snap = snapshot(); piecesOf(S.br[i]).forEach(remember); S.br.splice(i, 1); setCur(Math.min(S.cur, S.br.length-1)); update(); toast("Bracelet " + (i+1) + " removed", {label:"Undo", fn:function(){ restore(snap); }}); }
function openMore(){
var body = $("mBody"), c = charmCount(); body.innerHTML = ""; $("mTitle").textContent = "Your bracelets";
function row(label, svg, small, fn, danger){ var b = document.createElement("button"); b.type = "button"; b.className = danger ? "danger" : ""; b.innerHTML = svg + "<span>" + label + "</span>" + (small ? "<small>" + small + "</small>" : ""); b.addEventListener("click", function(){ closeSheet("mScrim"); setTimeout(fn, SHEET_MS); }); body.appendChild(b); }
row("Review every charm", EN_LINE.grid, c + " charm" + (c===1?"":"s") + " · " + S.br.length + " bracelet" + (S.br.length===1?"":"s"), openReview);
row("Preview and share", E3I.expand, "", e3OpenPreview); if (e3Looks().length) row("Saved designs (" + e3Looks().length + ")", E3I.bookmark, "", e3OpenList); row("Open your bag", EN_LINE.bag, "", function(){ openBag(); });
if (S.br.length > 1) row("Remove bracelet " + (S.cur+1), EN_LINE.minus, piecesOf(B).length ? "charms go to Recently removed" : "", function(){ removeBracelet(S.cur); });
if (c) row("Start over", EN_LINE.trash, "Undo is one tap away", startOver, true);
openSheet("mScrim");
}
function renderRecent(){
var box = $("recent"), row = $("recentRow"); box.hidden = !S.recent.length; row.innerHTML = "";
S.recent.forEach(function(p, k){
var b = document.createElement("button"); b.type = "button"; b.setAttribute("aria-label", "Put back " + pieceName(p));
var i = document.createElement("i"), bb = document.createElement("b"), em = document.createElement("em"); em.innerHTML = SV.plus; i.appendChild(bb); i.appendChild(em); b.appendChild(i);
var sp = document.createElement("span"); sp.textContent = pieceName(p); b.appendChild(sp);
b.addEventListener("click", function(){ S.recent.splice(k, 1); addPiece(makePiece(p.i, p.vi), bb); });
row.appendChild(b); fit(bb, p.a, 52, 0.8);
});
}
function renderStage(){
var wrap = $("stripWrap"), W = Wpx(), strip = $("strip");
renderTabs(); renderRecent();
renderRow(strip, W, B, {hits:true, pop:true, even:true});
var pad = Math.max(16, (wrap.clientWidth - W) / 2);
strip.style.marginLeft = pad + "px"; strip.style.marginRight = pad + "px";
var mw = $("map").parentNode.clientWidth || 340, mW = Math.min(18, mw / B.size);
renderRow($("map"), mW, B, {even:true});
var win = document.createElement("span"); win.className = "win"; $("map").appendChild(win); syncWin();
var mrow = $("miniRow"), boxW = (mrow.parentNode.clientWidth || 300), miniW = Math.min(16, boxW / B.size);
renderRow(mrow, miniW, B, {});
var ms = $("miniSub"); ms.hidden = S.br.length < 2; ms.textContent = "Bracelet " + (S.cur+1) + " of " + S.br.length;
var c = charmCount(), used = 0; B.slots.forEach(function(p){ if (p) used += linkCount(p); });
var short = B.size - (PLAIN_LINKS + used), hint = $("hint"); hint.className = "hint";
if (S.sel >= 0 && B.slots[S.sel]) hint.textContent = pieceName(B.slots[S.sel]) + " · tap a charm below to swap it";
else if (S.sel >= 0) hint.textContent = "Link " + (S.sel+1) + " selected · tap a charm below to put it here";
else if (!piecesOf(B).length) hint.textContent = c ? "This bracelet is empty. Tap a charm below to fill it" : "Tap a charm below and it clicks onto the bracelet";
else if (short > 0){ hint.className = "hint warn"; hint.textContent = "The bracelet comes with 18 plain links. Add " + short + " more charm" + (short>1?"s":"") + " to reach " + B.size + " links."; }
else hint.textContent = "Tap a link to move or remove it";
$("selbar").hidden = S.sel < 0;
$("rmSlot").hidden = $("mvL").hidden = $("mvR").hidden = !(S.sel >= 0 && B.slots[S.sel]);
$("mvRow").hidden = !(S.sel >= 0 && B.slots[S.sel]) || S.br.length < 2;
$("mvBrT").textContent = S.br.length === 2 ? "Move to bracelet " + (S.cur === 0 ? 2 : 1) : "Move to another bracelet";
var isChain = S.sel >= 0 && B.slots[S.sel] && B.slots[S.sel].kind === 2;
$("gapSep").hidden = $("gapIn").hidden = $("gapOut").hidden = !isChain;
if (isChain){ var gp = B.slots[S.sel].span - 1; hint.textContent = pieceName(B.slots[S.sel]) + " · " + (gp ? gp + " link" + (gp>1?"s":"") + " between the ends" : "ends side by side") + " · tap a charm below to swap it"; }
$("metalLbl").textContent = BASE_NAME[B.base]; $("sizeLbl").textContent = SIZE_LBL[B.size] + " · " + B.size + " links";
Array.prototype.forEach.call(document.querySelectorAll("[data-base]"), function(x){ x.setAttribute("aria-pressed", x.dataset.base === B.base); });
Array.prototype.forEach.call(document.querySelectorAll("[data-size]"), function(x){ x.setAttribute("aria-pressed", +x.dataset.size === B.size); });
S.pop = -1; S.flyOn = false;
}
function syncWin(){
var wrap = $("stripWrap"), map = $("map"), win = map.querySelector(".win"); if (!win) return;
var strip = $("strip"), total = strip.offsetWidth || 1, ml = parseFloat(strip.style.marginLeft) || 0;
var visL = Math.max(0, wrap.scrollLeft - ml), visR = Math.min(total, wrap.scrollLeft - ml + wrap.clientWidth), mwid = map.offsetWidth;
win.style.left = (visL/total*mwid - 2) + "px"; win.style.width = (Math.max(0, visR - visL)/total*mwid + 4) + "px";
}
function scrollToSlot(s, smooth){
var wrap = $("stripWrap"), W = Wpx(), strip = $("strip"), ml = parseFloat(strip.style.marginLeft) || 0, x = ml + s*W + W/2 - wrap.clientWidth/2;
if (!smooth || REDUCED){ var bh = wrap.style.scrollBehavior; wrap.style.scrollBehavior = "auto"; wrap.scrollLeft = x; wrap.style.scrollBehavior = bh; } else wrap.scrollLeft = x;
}
function stageIn(dir){
var s = $("strip"); if (!s || !s.animate) return;
var k = REDUCED ? [{opacity:.4}, {opacity:1}] : [{opacity:0, transform: dir ? "translateX(" + (dir > 0 ? 16 : -16) + "px)" : "translateY(5px)"}, {opacity:1, transform:"none"}];
s.animate(k, {duration: REDUCED ? 120 : 200, easing:"cubic-bezier(.2,.8,.2,1)"});
}
function slotPcs(a, b, mid){
var strip = $("strip"), hits = strip.querySelectorAll(".hit"), h1 = hits[a], h2 = hits[b], out = []; if (!h1 || !h2) return out;
var r1 = h1.getBoundingClientRect(), r2 = h2.getBoundingClientRect(), W = r1.width, lo = r1.left + W/2 - W*0.55, hi = r2.left + r2.width/2 + W*0.55;
Array.prototype.forEach.call(strip.querySelectorAll(mid ? ".pc" : ".pc:not(.mid)"), function(p){ var r = p.getBoundingClientRect(), c = r.left + r.width/2; if (r.width && c >= lo && c <= hi) out.push(p); });
return out;
}
function slideIn(slot, dx){
if (REDUCED || !dx) return;
slotPcs(slot, slot, false).forEach(function(pc){ if (pc.animate) pc.animate([{transform:"translateX(" + dx + "px)"}, {transform:"none"}], {duration:180, easing:"cubic-bezier(.2,.8,.2,1)"}); });
}
function liftOff(slot){
var p = B.slots[slot]; if (!p || REDUCED || !document.body.animate) return;
var chain = p.kind === 2, last = chain ? slot + p.span : slot;
slotPcs(slot, Math.min(last, B.size - 1), chain).forEach(function(pc){
var r = pc.getBoundingClientRect(); if (r.bottom < 0 || r.top > innerHeight) return;
var g = pc.cloneNode(false); g.className = "fly"; g.style.left = r.left + "px"; g.style.top = r.top + "px"; g.style.margin = "0"; g.style.backgroundRepeat = "no-repeat"; g.style.zIndex = "28"; g.style.animation = "none";
if (pc.classList.contains("mid")) g.style.transformOrigin = "left center";
document.body.appendChild(g);
var k = chain ? [{opacity:1}, {opacity:0}] : [{opacity:1, transform:"none"}, {opacity:0, transform:"translateY(-10px) scale(.9)"}];
var a = g.animate(k, {duration:200, easing:"ease-out", fill:"forwards"}); a.onfinish = function(){ g.remove(); };
});
}
function fillOrder(n){ var c = Math.floor(n/2) - 1, o = [c]; for (var d=1; o.length<n; d++){ if (c+d < n) o.push(c+d); if (c-d >= 0 && o.length<n) o.push(c-d); } return o; }
function canPlace(b, p, s){ var cv = blocked(p, s); for (var k=0;k<cv.length;k++){ if (cv[k] >= b.size || b.own[cv[k]] >= 0) return false; } return true; }
function setAt(b, p, s){ b.slots[s] = p; blocked(p, s).forEach(function(c){ b.own[c] = s; }); }
function clearAt(b, s){ var p = b.slots[s]; if (!p) return null; blocked(p, s).forEach(function(c){ if (c < b.size) b.own[c] = -1; }); b.slots[s] = null; return p; }
function placeIn(b, p){ var order = fillOrder(b.size); for (var k=0;k<order.length;k++){ if (canPlace(b, p, order[k])){ setAt(b, p, order[k]); return order[k]; } } return -1; }
function placeAny(p){
var s = placeIn(B, p); if (s >= 0) return {b:S.cur, s:s};
for (var i=0;i<S.br.length;i++){ if (i === S.cur) continue; s = placeIn(S.br[i], p); if (s >= 0) return {b:i, s:s}; }
var nb = newBracelet(B.base, B.size); S.br.push(nb); s = placeIn(nb, p); return {b:S.br.length-1, s:s, created:true};
}
function place(p){
if (S.sel >= 0){
var s = S.sel, need = blocked(p, s); S.sel = -1;
if (need[need.length-1] < B.size){
var displaced = [];
need.forEach(function(c){ var o = B.own[c]; if (o >= 0){ var old = clearAt(B, o); if (old) displaced.push(old); } });
setAt(B, p, s); displaced.forEach(function(q){ placeAny(q); });
return {b:S.cur, s:s};
}
}
return placeAny(p);
}
function addPiece(p, src){
var r = place(p), from = S.cur;
if (r.b !== S.cur) setCur(r.b);
S.pop = r.s; S.flyOn = fly(src, r.s, r.b === from);
update(); scrollToSlot(r.s, true);
var c = charmCount(), nm = pieceName(p), msg = "Added " + nm;
if (r.created) msg = "Bracelet " + r.b + " was full, so we started bracelet " + (r.b+1) + (Math.floor(c/10) > r.b ? ". It's free with your charms" : ". Free at " + Math.min(30, (r.b+1)*10) + " charms");
else if (c < 5) msg += " · " + (5-c) + " more for a free charm";
else if (c === 5) msg = "5 charms. This month's charm is free";
else if (c < 10) msg += " · " + (10-c) + " more for a free bracelet";
else if (c === 10) msg = "10 charms. The bracelet and the tool are free";
else if (c < 20){ var pm = phAddMsg(c); if (pm) msg = pm === 1 ? msg + " · " + ((PHC.need || 15) - c) + " more for a free photo charm" : pm; else msg += " · " + (20-c) + " more for a 2nd bracelet"; }
else if (c === 20) msg = "20 charms. A 2nd bracelet is free, tap + to add it";
else if (c < 30) msg += " · " + (30-c) + " more for a 3rd bracelet";
else if (c === 30) msg = "30 charms. A 3rd bracelet is free, tap + to add it";
dockSay(msg);
}
function startAdd(i, src){ var it = D.items[i], mv = metalVis(i); if (it.vv && (mv ? mv.length : it.vv.length) > 1){ openVariants(i, mv); return; } addPiece(makePiece(i, it.vv && it.vv.length ? (mv ? mv[0] : 0) : null), src); }
function isSingle(q){ return q && (q.kind === 0 || q.kind === 1); }
function relocate(b, p, from, to){
if (to < 0) return false;
var oldC = blocked(p, from), newC = blocked(p, to);
if (newC[newC.length-1] >= b.size || newC[0] < 0) return false;
var snap = JSON.stringify({slots: b.slots, own: b.own});
function undo(){ var o = JSON.parse(snap); b.slots = o.slots; b.own = o.own; return false; }
clearAt(b, from);
var vac = oldC.filter(function(c){ return newC.indexOf(c) < 0; });
var seen = {};
for (var k=0;k<newC.length;k++){
var c = newC[k], o = b.own[c]; if (o < 0 || seen[o]) continue; seen[o] = 1;
var q = b.slots[o];
if (isSingle(q)){
if (!vac.length) return undo();
clearAt(b, o); setAt(b, q, vac.shift());
} else if (q.kind === 2 && vac.length){
var v = vac.shift(), L = o, R = o + q.span, nL = c === L ? v : L, nR = c === R ? v : R;
if (nL > nR){ var t2 = nL; nL = nR; nR = t2; }
var span = nR - nL;
clearAt(b, o);
if (span >= 1 && span <= 4 && b.own[nL] < 0 && b.own[nR] < 0){ q.span = span; setAt(b, q, nL); }
else { setAt(b, q, o); var dirQ = v < c ? -1 : 1; if (!relocate(b, q, o, o + dirQ)) return undo(); }
} else if (q.kind === 3 && vac.length){
var dirW = vac[0] < c ? -1 : 1; if (!relocate(b, q, o, o + dirW)) return undo();
} else return undo();
}
for (var m=0;m<newC.length;m++){ if (b.own[newC[m]] >= 0) return undo(); }
setAt(b, p, to);
return true;
}
function moveTo(j){
var s = S.sel; if (s < 0 || !B.slots[s] || j === S.cur || !S.br[j]) return;
var snap = snapshot(), p = B.slots[s], t = placeIn(S.br[j], p);
if (t < 0){ toast("Bracelet " + (j+1) + " is full. Take a charm off it first"); return; }
clearAt(B, s); setCur(j); S.pop = t; S.flyOn = false;
update(); scrollToSlot(t, true);
toast("Moved " + pieceName(p) + " to bracelet " + (j+1), {label:"Undo", fn:function(){ restore(snap); }});
}
function pickBracelet(){
if (S.br.length === 2){ moveTo(S.cur === 0 ? 1 : 0); return; }
var body = $("mBody"); body.innerHTML = ""; $("mTitle").textContent = "Move " + pieceName(B.slots[S.sel]) + " to";
S.br.forEach(function(b, i){
if (i === S.cur) return;
var n = piecesOf(b).length;
var btn = document.createElement("button"); btn.type = "button";
btn.innerHTML = EN_LINE.grid + "<span>Bracelet " + (i+1) + "</span><small>" + n + " charm" + (n === 1 ? "" : "s") + "</small>";
btn.addEventListener("click", function(){ closeSheet("mScrim"); setTimeout(function(){ moveTo(i); }, SHEET_MS); });
body.appendChild(btn);
});
openSheet("mScrim");
}
function move(dir){
var s = S.sel; if (s < 0 || !B.slots[s]) return;
var p = B.slots[s], cells = blocked(p, s), edge = dir > 0 ? cells[cells.length-1] + 1 : s - 1;
if (edge < 0 || edge >= B.size){ toast("That's the end of the bracelet"); return; }
var to = s + dir;
if (relocate(B, p, s, to)){ S.sel = to; }
else if (relocate(B, p, s, s + 2*dir)){ S.sel = s + 2*dir; }
else { toast("That's the end of the bracelet"); }
renderStage(); scrollToSlot(S.sel, true);
if (S.sel !== s && p.kind !== 2){ var W0 = Wpx(); slideIn(S.sel, (s - S.sel) * W0); if (Math.abs(S.sel - s) === 1 && p.kind < 2 && isSingle(B.slots[s])) slideIn(s, (S.sel - s) * W0); }
}
function fly(src, slot, sameBracelet){
if (!src || REDUCED || !src.animate) return false;
var r = src.getBoundingClientRect(); if (!r.width) return false;
var target = null, hit = sameBracelet ? $("strip").querySelectorAll(".hit")[slot] : null;
if (hit){ var hr = hit.getBoundingClientRect(); if (hr.bottom > 70 && hr.top < innerHeight - 90 && hr.width) target = hr; }
if (!target){ var m = $("mini"); target = (m.classList.contains("on") ? $("miniRow") : $("dockSum")).getBoundingClientRect(); }
var g = src.cloneNode(true); g.className = "fly"; g.style.left = r.left + "px"; g.style.top = r.top + "px"; g.style.width = r.width + "px"; g.style.height = r.height + "px"; g.style.margin = "0";
document.body.appendChild(g);
var tx = target.left + target.width/2 - (r.left + r.width/2), ty = target.top + target.height/2 - (r.top + r.height/2), sc = Math.max(.15, Math.min(1, target.height*.9/r.height));
var an = g.animate([{transform:"translate(0,0) scale(1)", opacity:1}, {transform:"translate(" + tx*.55 + "px," + (ty*.55 - 46) + "px) scale(" + ((1+sc)/2) + ")", opacity:1, offset:.6}, {transform:"translate(" + tx + "px," + ty + "px) scale(" + sc + ")", opacity:.15}], {duration:320, easing:"cubic-bezier(.2,.7,.2,1)"});
an.onfinish = function(){ g.remove(); };
return true;
}
function vMark(pic, i, k){
var n = 0; S.br.forEach(function(b){ piecesOf(b).forEach(function(p){ if (p.i === i && p.vi === k) n++; }); });
var em = pic.querySelector("em"); if (!n){ if (em) pic.removeChild(em); return; }
if (!em){ em = document.createElement("em"); pic.appendChild(em); } em.textContent = "\u2713 " + n;
}
function openVariants(i, only, gname){
var it = D.items[i]; if (!only && it.zh) only = metalVis(i); var ks = only || it.vv.map(function(v, k){ return k; }), p0 = priceOf(i, ks[0]), vary = ks.some(function(k){ return priceOf(i, k) !== p0; }); $("vTitle").textContent = gname || it.t; $("vNote").textContent = ks.length + (S.metal !== "all" && mixed(it) && only ? " " + S.metal : "") + " designs" + (vary ? "" : " · " + money(p0) + " each"); var g = $("vGrid"); g.innerHTML = "";
it.vv.forEach(function(v, k){
if (only && only.indexOf(k) < 0) return;
var w = document.createElement("div"); w.className = "vit";
var b = document.createElement("button"); b.type = "button"; b.className = "vadd";
var pic = document.createElement("span"); pic.className = "pic"; var art = document.createElement("i"); art.className = "art"; pic.appendChild(art); b.appendChild(pic);
var nm = designName(i, k), sp = document.createElement("span"); sp.textContent = nm; b.appendChild(sp);
var vc = saleCmp(i, k), vn = priceOf(i, k);
if (vary || vc > vn){ var pp = document.createElement("span"); pp.className = "vp"; if (vc > vn){ var vs = document.createElement("s"); vs.textContent = money(vc); pp.appendChild(vs); pp.appendChild(document.createTextNode(" ")); } pp.appendChild(document.createTextNode(money(vn))); b.appendChild(pp); }
if (vc > vn){ var vo = document.createElement("span"); vo.className = "off"; vo.textContent = Math.floor((vc - vn) / vc * 100) + "% off"; pic.appendChild(vo); }
b.setAttribute("aria-label", "Add " + nm);
b.addEventListener("click", function(){ addPiece(makePiece(i, k), art); setTimeout(function(){ vMark(pic, i, k); }, 60); });
vMark(pic, i, k);
b._a = v[3]; w.appendChild(b);
var key = heartKey({i: i, vi: k}), h = document.createElement("button"); h.type = "button"; h.className = "heart";
var hp = function(){ h.setAttribute("aria-pressed", !!S.hearts[key]); h.setAttribute("aria-label", (S.hearts[key] ? "Remove " : "Save ") + nm); };
hp(); h.innerHTML = SV.heart;
h.addEventListener("click", function(e){ e.stopPropagation(); toggleHeart(key, nm); hp(); h.classList.remove("beat"); void h.offsetWidth; h.classList.add("beat"); if (S.scope.t === "saved"){ GT = {fade:1}; renderGrid(); } });
w.appendChild(h); g.appendChild(w);
});
openSheet("vScrim");
requestAnimationFrame(function(){ Array.prototype.forEach.call(g.children, function(w){ var b = w.firstChild, pic = b.firstChild; fit(pic.firstChild, b._a, pic.clientWidth || 100); imgFade(pic.firstChild, pic); }); });
}
var HIDX = {}, PH = [], VH = [];
var STOPW = Object.create(null); "a an the for with of and charm charms italian bracelet".split(" ").forEach(function(w){ STOPW[w] = 1; });
function normT(s){ s = String(s == null ? "" : s).toLowerCase(); if (s.normalize) s = s.normalize("NFD").replace(/[\u0300-\u036f]/g, ""); return s.replace(/&/g, " and ").replace(/['\u2019`]/g, "").replace(/[^a-z0-9]+/g, " ").trim(); }
function qWords(){ var w = normT(S.q).split(" "), out = []; for (var k=0;k<w.length;k++){ if (w[k] && !STOPW[w[k]] && out.indexOf(w[k]) < 0) out.push(w[k]); } return out; }
function subLabels(a){ return a.map(function(k){ return D.subs[k]; }).join(" "); }
function pHay(i){ if (PH[i] == null){ var it = D.items[i]; PH[i] = normT(it.t + " " + it.n + " " + subLabels(it.st) + " " + it.g.map(function(r){ return D.rail[r].l; }).join(" ")); } return PH[i]; }
function vHay(i, vi){ var c = VH[i] || (VH[i] = []); if (c[vi] == null){ var v = D.items[i].vv[vi]; c[vi] = normT(v[0] + " " + v[1] + " " + subLabels(v[2])); } return c[vi]; }
function hasAll(h, w){ for (var k=0;k<w.length;k++){ if (h.indexOf(w[k]) < 0) return false; } return true; }
var KWURL = (window.CSB && CSB.kw) || "csb-kw.json";
var KWRAW = null, KWX = null, KWST = 0, DG = [], NALL = null;
function nameAll(){ if (NALL == null){ var a = []; D.items.forEach(function(it, i){ a.push(pHay(i)); if (it.vv) it.vv.forEach(function(v, vi){ a.push(vHay(i, vi)); }); }); NALL = a.join("|"); } return NALL; }
function kwSpin(){ var q = $("q"); if (q && q.parentNode) q.parentNode.classList.toggle("kwld", KWST === 1 && !!q.value.trim()); }
function kwDone(d){
KWST = d && typeof d === "object" ? 2 : 3; KWRAW = KWST === 2 ? d : null; kwSpin();
if (!D || KWST !== 2) return;
try { kwBuild(); } catch(e){ KWX = null; return; }
if (qWords().length){ try { GT = {fade:1}; renderGrid(); } catch(e){} }
}
function kwLoad(){
if (KWST || !window.fetch) return; KWST = 1; kwSpin();
try { fetch(KWURL).then(function(r){ if (!r.ok) throw new Error("HTTP " + r.status); return r.json(); }).then(kwDone, function(){ kwDone(null); }); } catch(e){ kwDone(null); }
}
function kwBuild(){
var raw = KWRAW, map = Object.create(null), W = [], G = [], n = 0; KWRAW = null;
function add(id, g){
var s = id == null ? null : raw[String(id)]; if (typeof s !== "string") return;
var ws = normT(s).split(" "), seen = Object.create(null);
for (var k=0;k<ws.length;k++){ var w = ws[k]; if (!w || seen[w]) continue; seen[w] = 1; var x = map[w]; if (x === undefined){ x = map[w] = W.length; W.push(w); G.push([]); } G[x].push(g); }
}
D.items.forEach(function(it, i){ DG[i] = n; if (it.vv) it.vv.forEach(function(v){ add(v[5], n++); }); else add(it.id, n++); });
KWX = {n: n, w: W, g: G, c: Object.create(null), cn: 0};
}
function gidOf(i, vi){ return KWX && DG[i] != null ? DG[i] + (vi == null ? 0 : vi) : -1; }
function kwVar(q){
var v = Object.create(null); if (q.length < 3) return v;
if (/ies$/.test(q)) v[q.slice(0, -3) + "y"] = 1;
if (/es$/.test(q)) v[q.slice(0, -2)] = 1;
if (/[^s]s$/.test(q)) v[q.slice(0, -1)] = 1;
if (/[^aeiou]y$/.test(q)) v[q.slice(0, -1) + "ies"] = 1;
v[q + "s"] = v[q + "es"] = 1; return v;
}
function ed1(a, b){
var la = a.length, lb = b.length, t;
if (la > lb){ t = a; a = b; b = t; t = la; la = lb; lb = t; }
if (lb - la > 1) return false;
var i = 0; while (i < la && a.charCodeAt(i) === b.charCodeAt(i)) i++;
if (i === la) return true;
var d = lb - la, j;
if (!d && i + 1 < la && a.charCodeAt(i) === b.charCodeAt(i + 1) && a.charCodeAt(i + 1) === b.charCodeAt(i)){
for (j = i + 2; j < la; j++){ if (a.charCodeAt(j) !== b.charCodeAt(j)) break; }
if (j === la) return true;
}
for (j = d ? i : i + 1; j < la; j++){ if (a.charCodeAt(j) !== b.charCodeAt(j + d)) return false; }
return true;
}
function kwWord(q){
var X = KWX, hit = new Uint8Array(X.n), L = q.length, vs = kwVar(q), W = X.w, G = X.g, any = 0, k, j, g, wl;
for (k=0;k<W.length;k++){ if (W[k] === q || vs[W[k]]){ any = 1; g = G[k]; for (j=0;j<g.length;j++) hit[g[j]] = 2; } }
if (!any && L >= 4 && nameAll().indexOf(q) < 0){
for (k=0;k<W.length;k++){ wl = W[k].length; if (wl >= L - 1 && wl <= L + 1 && ed1(q, W[k])){ g = G[k]; for (j=0;j<g.length;j++) hit[g[j]] = 1; } }
}
return hit;
}
function kwMatch(words){
if (!KWX && KWRAW && D){ try { kwBuild(); } catch(e){ KWX = null; } }
if (!KWX || !words.length) return null;
return words.map(function(w){ var h = KWX.c[w]; if (!h){ if (++KWX.cn > 300){ KWX.c = Object.create(null); KWX.cn = 1; } h = KWX.c[w] = kwWord(w); } return h; });
}
var NWS = null;
function isNew(i){ if (!NWS){ NWS = {}; (D.nw || []).forEach(function(k){ NWS[k] = 1; }); } return !!NWS[i]; }
function inScope(it, i){ if (S.scope.t === "new") return isNew(i); return S.scope.t !== "rail" || it.g.indexOf(S.scope.r) >= 0; }
var VMET = {}, ZV = {}; /* ZV: designs hidden from the builder (duplicates waiting to be deleted in the store), "i:vi" */
function vMet(i, k){ var key = i + ":" + k; if (VMET[key] === undefined){ var v = D.items[i].vv[k], w = normT((v[0] || "") + " " + (v[1] || "")).split(" "); var hs = w.indexOf("silver") >= 0, hg = w.indexOf("gold") >= 0; VMET[key] = hs && hg ? "" : hs ? "silver" : hg ? "gold" : ""; /* two-tone (gold with silver edge) shows under both metals */ } return VMET[key]; }
function mixed(it){ return !!it.vv && it.c.indexOf("gold") >= 0 && it.c.indexOf("silver") >= 0; }
function metalVis(i){ var it = D.items[i]; if (!it.vv) return null; var mx = S.metal !== "all" && mixed(it); if (!mx && !it.zh) return null; var out = []; it.vv.forEach(function(v, k){ if (it.zh && ZV[i + ":" + k]) return; if (mx && vMet(i, k) !== S.metal) return; out.push(k); }); return out.length && out.length < it.vv.length ? out : null; }
function vMetalOk(i, vi){ if (vi != null && ZV[i + ":" + vi]) return false; if (vi == null || S.metal === "all") return true; var it = D.items[i]; if (!mixed(it)) return true; var m = vMet(i, vi); return !m || m === S.metal; }
function metalOk(it){ return !it.z && (S.metal === "all" || it.c.indexOf(S.metal) >= 0); }
function heartKey(r){ var it = D.items[r.i]; return r.vi == null ? it.h : it.h + "#" + r.vi; }
function savedRefs(){ return Object.keys(S.hearts).sort(function(a,b){ return S.hearts[b] - S.hearts[a]; }).map(function(k){ var p = k.split("#"), i = HIDX[p[0]]; if (i == null) return null; return [i, p.length > 1 ? +p[1] : -1]; }).filter(Boolean); }
function grpRows(i, mv, sc){
var g = D.grp && D.grp[i]; if (!g) return null; var out = [];
g.forEach(function(x){ var ks = x[1].filter(function(k){ return !ZV[i + ":" + k] && (!mv || mv.indexOf(k) >= 0); }); if (!ks.length) return; if (ks.length === 1) out.push({i:i, vi:ks[0], sc:sc || 0}); else out.push({i:i, vi:null, mv:ks, gn:x[0], sc:sc || 0}); });
return out.length ? out : null;
}
function list(){
var t = S.scope.t, words = qWords(), km = kwMatch(words), out = [];
var WP = words.map(function(w){ var p = [" " + w + " ", " " + w + "s ", " " + w + "es "], v = kwVar(w); for (var x in v) p.push(" " + x + " "); return p; });
function tier(h, g){
var sc = 0, hp = " " + h + " ";
for (var k=0;k<words.length;k++){
var P = WP[k], q = km && g >= 0 ? km[k][g] : 0;
for (var j=0;j<P.length;j++){ if (hp.indexOf(P[j]) >= 0){ q = 3; break; } }
if (!q && hp.indexOf(P[0].slice(0, -1)) >= 0) q = 1;
if (!q) return -1; sc += q;
}
return sc;
}
function refHit(i, vi){ var it = D.items[i]; return tier((vi == null ? "" : vHay(i, vi) + " ") + pHay(i), vi == null && it.vv ? -1 : gidOf(i, vi)); }
if (t === "foryou"){
foryouList().forEach(function(r){ var it = D.items[r.i], sc = 0; if (!metalOk(it) || !vMetalOk(r.i, r.vi)) return; if (words.length && (sc = refHit(r.i, r.vi)) < 0) return; out.push({i:r.i, vi:r.vi, sc:sc}); });
} else if (t === "edit" || t === "gift" || t === "saved" || t === "sets" || t === "sale"){
var refs = t === "edit" ? D.edit.d : t === "gift" ? D.gifts[S.gift].d : t === "sets" ? setsRefs() : t === "sale" ? (D.sale || []) : savedRefs();
refs.forEach(function(r){ var i = r[0], vi = r[1] < 0 ? null : r[1], it = D.items[i], sc = 0, mv = null; if (!metalOk(it) || !vMetalOk(i, vi)) return; if (words.length && (sc = refHit(i, vi)) < 0) return; if (vi == null && (mv = metalVis(i)) && mv.length === 1){ vi = mv[0]; mv = null; } var gr = vi == null && grpRows(i, mv, sc); if (gr){ gr.forEach(function(x){ out.push(x); }); return; } out.push({i:i, vi:vi, sc:sc, mv:mv}); });
} else {
var dl = S.sub >= 0 || words.length > 0;
var each = t === "new" ? function(fn){ (D.nw || []).forEach(function(k){ if (D.items[k]) fn(D.items[k], k); }); } : function(fn){ D.items.forEach(fn); };
each(function(it, i){
if (!inScope(it, i) || !metalOk(it)) return;
var mv = metalVis(i);
if (!dl){ var gr = grpRows(i, mv, 0); if (gr){ gr.forEach(function(x){ out.push(x); }); return; } if (mv && mv.length === 1) out.push({i:i, vi:mv[0]}); else out.push({i:i, vi:null, mv:mv}); return; }
var sc = 0;
if (!it.vv){ if ((S.sub < 0 || it.st.indexOf(S.sub) >= 0) && (!words.length || (sc = tier(pHay(i), gidOf(i, null))) >= 0)) out.push({i:i, vi:null, sc:sc}); return; }
if (S.sub < 0 && words.length && (sc = tier(pHay(i), -1)) >= 0){ var gw = grpRows(i, mv, sc); if (gw){ gw.forEach(function(x){ out.push(x); }); return; } if (mv && mv.length === 1) out.push({i:i, vi:mv[0], sc:sc}); else out.push({i:i, vi:null, mv:mv, sc:sc}); return; }
it.vv.forEach(function(v, vi){ var s2 = 0; if (S.sub >= 0 && v[2].indexOf(S.sub) < 0) return; if (mv && mv.indexOf(vi) < 0) return; if (words.length && (s2 = tier(vHay(i, vi) + (S.sub >= 0 ? " " + pHay(i) : ""), gidOf(i, vi))) < 0) return; out.push({i:i, vi:vi, sc:s2}); });
});
}
function pr(r){ return priceOf(r.i, r.vi); }
if (S.sort === "low") out.sort(function(a,b){ return pr(a) - pr(b); });
else if (S.sort === "high") out.sort(function(a,b){ return pr(b) - pr(a); });
else if (S.sort === "az") out.sort(function(a,b){ return designName(a.i, a.vi).localeCompare(designName(b.i, b.vi)); });
else if (words.length && S.sort === "best"){ var qn = normT(S.q).trim(); out.forEach(function(r, k){ r.k = k; if (qn && normT(r.gn || designName(r.i, r.vi)).trim() === qn) r.sc = (r.sc || 0) + 0.5; }); out.sort(function(a, b){ return ((b.sc || 0) - (a.sc || 0)) || (a.k - b.k); }); }
return out;
}
var EN_LINE = {
grid:'<svg class="ic" viewBox="0 0 24 24"><rect x="4" y="4" width="7" height="7" rx="1.5"/><rect x="13" y="4" width="7" height="7" rx="1.5"/><rect x="4" y="13" width="7" height="7" rx="1.5"/><rect x="13" y="13" width="7" height="7" rx="1.5"/></svg>',
bag:'<svg class="ic" viewBox="0 0 24 24"><path d="M6 8h12l-1 12H7L6 8z"/><path d="M9 8V6a3 3 0 0 1 6 0v2"/></svg>',
minus:'<svg class="ic" viewBox="0 0 24 24"><circle cx="12" cy="12" r="8.5"/><path d="M8 12h8"/></svg>',
trash:'<svg class="ic" viewBox="0 0 24 24"><path d="M5 7h14M10 7V5h4v2M7 7l1 13h8l1-13"/></svg>'
};
var EN = {
heart:'<svg class="ic" viewBox="0 0 24 24"><path d="M12 20.3S4.8 15.9 4.8 10.4A4.1 4.1 0 0 1 12 7.8a4.1 4.1 0 0 1 7.2 2.6c0 5.5-7.2 9.9-7.2 9.9z" fill="#B3243B" stroke="#7E1428"/></svg>',
spark:'<svg class="ic" viewBox="0 0 24 24"><path d="M12 3l2.1 6.4 6.4 2.1-6.4 2.1L12 20l-2.1-6.4L3.5 11.5l6.4-2.1z" fill="#17431F" stroke="#0E2C14"/></svg>',
gift:'<svg class="ic" viewBox="0 0 24 24"><rect x="4.5" y="10" width="15" height="10" rx="1" fill="#B08D45" stroke="#7A5A12"/><rect x="3.5" y="6.8" width="17" height="3.4" rx=".8" fill="#C99A35" stroke="#7A5A12"/><path d="M12 6.8V20" stroke="#FFF7E6" stroke-width="2.2"/><path d="M12 6.8c-2.2-3.4-6-3.2-5.6-1S10 6.8 12 6.8zm0 0c2.2-3.4 6-3.2 5.6-1S14 6.8 12 6.8z" fill="#FFF7E6" stroke="#7A5A12"/></svg>',
grid:'<svg class="ic" viewBox="0 0 24 24"><rect x="3.5" y="3.5" width="7.2" height="7.2" rx="1.8" fill="#2E2E2E" stroke="#151515"/><rect x="13.3" y="3.5" width="7.2" height="7.2" rx="1.8" fill="#2E2E2E" stroke="#151515"/><rect x="3.5" y="13.3" width="7.2" height="7.2" rx="1.8" fill="#2E2E2E" stroke="#151515"/><rect x="13.3" y="13.3" width="7.2" height="7.2" rx="1.8" fill="#2E2E2E" stroke="#151515"/></svg>',
lock:'<svg class="ic" viewBox="0 0 24 24"><rect x="5" y="10.5" width="14" height="10" rx="2" fill="#B08D45" stroke="#7A5A12"/><path d="M8 10.5V8a4 4 0 0 1 8 0v2.5" stroke="#7A5A12" stroke-width="1.8"/><circle cx="12" cy="15.5" r="1.4" fill="#FFF7E6"/></svg>',
truck:'<svg class="ic" viewBox="0 0 24 24"><path d="M3 7.5h11v9H3z" fill="#17431F" stroke="#0E2C14"/><path d="M14 10.5h4l3 3v3h-7z" fill="#2E6B3A" stroke="#0E2C14"/><circle cx="7" cy="17.5" r="1.8" fill="#2E2E2E" stroke="#151515"/><circle cx="17" cy="17.5" r="1.8" fill="#2E2E2E" stroke="#151515"/></svg>',
tool:'<svg class="ic" viewBox="0 0 24 24"><path d="M14 4l6 6-3 3-6-6z" fill="#B08D45" stroke="#7A5A12"/><path d="M11 7l-7 7v4h4l7-7z" fill="#C9CED3" stroke="#6B7177"/></svg>',
question:'<svg class="ic" viewBox="0 0 24 24"><circle cx="12" cy="12" r="8.5" fill="#B3243B" stroke="#7E1428"/><path d="M9.6 9.6a2.4 2.4 0 1 1 3.4 2.2c-.7.4-1 .9-1 1.7" stroke="#FFF" stroke-width="1.8" fill="none"/><circle cx="12" cy="16.6" r="1" fill="#FFF"/></svg>',
hive:'<svg class="ic" viewBox="0 0 24 24"><path d="M8.5 3.5l3.9 2.2v4.5L8.5 12.4 4.6 10.2V5.7z" fill="#B08D45" stroke="#7A5A12"/><path d="M15.5 7.5l3.9 2.2v4.5l-3.9 2.2-3.9-2.2V9.7z" fill="#17431F" stroke="#0E2C14"/><path d="M8.5 12.6l3.9 2.2v4.5L8.5 21.5l-3.9-2.2v-4.5z" fill="#B3243B" stroke="#7E1428"/></svg>'
};
EN.sale = '<svg class="ic" viewBox="0 0 24 24"><path d="M3.5 11.9V4.7c0-.7.5-1.2 1.2-1.2h7.2l8.4 8.4c.5.5.5 1.2 0 1.7l-7.2 7.2c-.5.5-1.2.5-1.7 0z" fill="#B3243B" stroke="#7E1428"/><circle cx="7.4" cy="7.4" r="1.3" fill="#FFF7E6"/><path d="M10.4 15.6l5-5" stroke="#FFF7E6" stroke-width="1.5" stroke-linecap="round"/><circle cx="10.8" cy="11" r="1.15" fill="#FFF7E6"/><circle cx="15" cy="15.2" r="1.15" fill="#FFF7E6"/></svg>';
EN.nw = '<svg class="ic" viewBox="0 0 24 24"><rect x="1.6" y="6.6" width="20.8" height="10.8" rx="2.6" fill="#17431F" stroke="#0E2C14"/><text x="12" y="14.55" text-anchor="middle" font-family="Arial,Helvetica,sans-serif" font-size="7.2" font-weight="700" letter-spacing=".35" fill="#FFF7E6" stroke="none">NEW</text></svg>';
EN.sets = '<svg class="ic" viewBox="0 0 24 24"><rect x="1.8" y="7.5" width="6.6" height="9" rx="1.3" fill="#C9CED3" stroke="#6B7177"/><rect x="8.7" y="7.5" width="6.6" height="9" rx="1.3" fill="#C99A35" stroke="#7A5A12"/><rect x="15.6" y="7.5" width="6.6" height="9" rx="1.3" fill="#B3243B" stroke="#7E1428"/></svg>';
var WHO = [["me","Me",{}],["mom","Mom",{f:["mom"],s:["mom"]}],["dad","Dad",{f:["dad"],s:["dad"]}],["bestie","Bestie",{f:["bestie"],s:["friend_word"]}],["partner","Partner",{f:["partner"],s:["couple_romance","lips_kiss","love_word"]}],["sister","Sister",{f:["sister"],s:["sibling"]}],["kid","Kid",{f:["kid"],s:["baby_kids","cartoon_character"]}],["grandma","Grandma",{f:["grandma"],s:["grandparent"]}],["nurse","Nurse",{f:["nurse"],s:["medical_nurse"]}],["teacher","Teacher",{f:["teacher"],s:["teacher_job","book_school"]}]];
var LOVES = [["Cats",["cat"]],["Dogs",["dog"]],["Butterflies",["butterfly_bug"]],["Sea life",["sea_life"]],["Birds",["bird"]],["Paws & pets",["paw_print","critter","horse_farm","wild_animal"]],["Flowers",["flower","rose","leaf_plant"]],["Stars",["star_galaxy"]],["Sun & moon",["sun_moon"]],["Zodiac",["zodiac"]],["Birthstones",["birthstone_month"]],["Letters",["letter"]],["Years & numbers",["year_date","number"]],["Hearts",["heart"]],["Love",["love_word","couple_romance","lips_kiss"]],["Travel",["travel_globe_plane","landmark_city"]],["Flags",["flag"]],["Beach",["beach_ocean"]],["Nature",["landscape_scene","weather_snow"]],["Coffee",["coffee_drink"]],["Sweets & fruit",["sweet_treat","fruit"]],["Food",["savory_food"]],["Cocktails",["cocktail_wine"]],["Music",["music"]],["Art",["art_creative"]],["Books",["book_school"]],["Sports",["ball_sport","other_sport"]],["Games",["video_game_tech","cards_dice_games"]],["Cars & boats",["car_moto","boat"]],["Faith",["faith_cross","angel_wings","peace_yinyang"]],["Luck",["evil_eye_luck"]],["Magic",["fairy_magic"]],["Cartoons",["cartoon_character"]],["Halloween",["halloween_spooky","skull_gothic"]],["Christmas",["christmas_winter"]],["Party",["party_celebration"]],["Sassy words",["sassy_word"]],["Good vibes",["motivational_word"]],["Family",["family_word","mom","dad","grandparent","sibling"]],["Friends",["friend_word"]],["Baby",["baby_kids"]],["Fashion",["fashion_beauty","bow_ribbon"]],["Crowns & luxe",["crown_royal","money_luxury"]],["Jobs",["medical_nurse","teacher_job","police_fire_military","other_job"]]];
var LOOK = [["Gold",{c:"gold",sw:"linear-gradient(140deg,#FFF1C4,#C99A35 60%,#F1D68A)"}],["Silver",{c:"silver",sw:"linear-gradient(140deg,#FBFBFC,#C4C9CE 60%,#E9ECEF)"}],["Pink",{c:"pink",sw:"#F2A7BC"}],["Red",{c:"red",sw:"#C8323F"}],["Blue",{c:"blue",sw:"#4F7FC4"}],["Green",{c:"green",sw:"#4F8A5B"}],["Purple",{c:"purple",sw:"#8E6BB8"}],["Black",{c:"black",sw:"#2A2A2E"}],["White",{c:"white",sw:"#F4F2EE"}],["Bling",{s:["rhinestone_bling"]}],["Dangles",{s:["dangle"]}],["Minimal",{s:["plain_metal"]}],["Cute",{v:"cute"}],["Elegant",{v:"elegant"}],["Funny",{v:"funny"}],["Edgy",{v:"edgy"}],["Spiritual",{v:"spiritual"}],["Bold",{v:"bold"}]];
var HUB = {who:"me", loves:{}, look:{}}, IDX = {};
var SV = {
tick:'<svg class="ic" viewBox="0 0 24 24"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>',
heart:'<svg class="ic" viewBox="0 0 24 24"><path d="M12 20s-7-4.4-7-10a4 4 0 0 1 7-2.6A4 4 0 0 1 19 10c0 5.6-7 10-7 10z"/></svg>',
gift:'<svg class="ic" viewBox="0 0 24 24"><rect x="4" y="9" width="16" height="11" rx="1"/><path d="M3.5 9h17M12 9v11M12 9c-2-4-6-4-6-1.5S10 9 12 9zm0 0c2-4 6-4 6-1.5S14 9 12 9z"/></svg>',
plus:'<svg class="ic" viewBox="0 0 24 24"><path d="M12 6v12M6 12h12"/></svg>',
more:'<svg class="ic" viewBox="0 0 24 24"><circle cx="6" cy="12" r="1.2" fill="currentColor"/><circle cx="12" cy="12" r="1.2" fill="currentColor"/><circle cx="18" cy="12" r="1.2" fill="currentColor"/></svg>',
up:'<svg class="ic" viewBox="0 0 24 24"><path d="M12 19V6M6 12l6-6 6 6"/></svg>',
minus:'<svg class="ic" viewBox="0 0 24 24"><path d="M6 12h12"/></svg>',
spark:'<svg class="ic" viewBox="0 0 24 24"><path d="M12 3.5l1.8 5.2 5.2 1.8-5.2 1.8L12 17.5l-1.8-5.2L5 10.5l5.2-1.8z"/><path d="M18.5 15.5l.7 1.8 1.8.7-1.8.7-.7 1.8-.7-1.8-1.8-.7 1.8-.7z"/></svg>',
tool:'<svg class="ic" viewBox="0 0 24 24"><path d="M14 4l6 6-3 3-6-6zM11 7l-7 7v4h4l7-7"/></svg>',
lock:'<svg class="ic" viewBox="0 0 24 24"><rect x="5" y="11" width="14" height="9" rx="1.5"/><path d="M8 11V8a4 4 0 0 1 8 0v3"/></svg>',
truck:'<svg class="ic" viewBox="0 0 24 24"><path d="M3 7h11v9H3zM14 10h4l3 3v3h-7z"/><circle cx="7" cy="17.5" r="1.5"/><circle cx="17" cy="17.5" r="1.5"/></svg>',
coin:'<svg class="ic" viewBox="0 0 24 24"><circle cx="12" cy="12" r="8"/><path d="M12 8v8M9.5 10.5c0-1 1-1.5 2.5-1.5s2.5.6 2.5 1.5-1 1.3-2.5 1.5-2.5.6-2.5 1.5 1 1.5 2.5 1.5 2.5-.6 2.5-1.5"/></svg>'
};
function railTile(cls, label, pressed, onClick, o){
var b = document.createElement("button"); b.type = "button"; b.className = "rtile" + (cls ? " " + cls : ""); b.setAttribute("aria-pressed", pressed);
var i = document.createElement("i");
if (o.a != null){ var bb = document.createElement("b"); i.appendChild(bb); b._paint = function(sz){ fit(bb, o.a, sz, o.pad || 0.8); }; }
if (o.svg) i.insertAdjacentHTML("beforeend", o.svg);
b.appendChild(i);
if (o.dot){ var d = document.createElement("span"); d.className = "dot"; d.setAttribute("aria-hidden", "true"); b.appendChild(d); }
var sp = document.createElement("span"); sp.textContent = label; b.appendChild(sp);
if (o.count != null){ var em = document.createElement("em"); em.textContent = o.count.toLocaleString(); b.appendChild(em); }
b.setAttribute("aria-label", label + (o.count != null ? ", " + o.count + " charms" : ""));
b.addEventListener("click", onClick); return b;
}
function specials(isP, after){
var L = D.plain.silver;
return [
railTile("fy", "For you", isP("foryou"), function(){ after(); openHub(); }, {a: L, svg: EN.hive, pad: 0.8}),
railTile("", "All", isP("all"), function(){ setScope("all"); after(); }, {a: D.allA, pad: 0.76}),
railTile("nw", "New", isP("new"), function(){ setScope("new"); after(); }, {a: L, svg: EN.nw, pad: 0.8}),
railTile("sl", "Sale", isP("sale"), function(){ setScope("sale"); after(); }, {a: L, svg: EN.sale, pad: 0.8}),
railTile("wk", "This week", isP("edit"), function(){ setScope("edit"); after(); }, {a: L, svg: EN.spark, pad: 0.8, dot: true}),
railTile("st", "Sets", isP("sets"), function(){ setScope("sets"); after(); }, {a: L, svg: EN.sets, pad: 0.8}),
railTile("gf", "Gift guide", isP("gift"), function(){ setScope("gift"); after(); }, {a: L, svg: EN.gift, pad: 0.8})
];
}
function paintAll(c, sz){ Array.prototype.forEach.call(c.querySelectorAll(".rtile"), function(b){ if (b._paint) b._paint(sz); }); }
function railOn(c){
if (!c || !c.w) return true;
var d = new Date(), md = (d.getMonth() + 1) * 100 + d.getDate(), a = c.w[0], b = c.w[1];
return a <= b ? (md >= a && md <= b) : (md >= a || md <= b);
}
function renderRail(){
var r = $("rail"); r.innerHTML = "";
specials(function(t){ return S.scope.t === t; }, function(){}).forEach(function(b){ r.appendChild(b); });
D.rail.forEach(function(c, k){ if (!railOn(c) && !(S.scope.t === "rail" && S.scope.r === k)) return; r.appendChild(railTile("", c.l, S.scope.t === "rail" && S.scope.r === k, function(){ setScope("rail", k); }, {a: c.a, pad: 0.76})); });
paintAll(r, 56);
var on = r.querySelector('[aria-pressed="true"]');
if (on){ var L = on.offsetLeft - r.offsetLeft, R = L + on.offsetWidth; if (L < r.scrollLeft || R > r.scrollLeft + r.clientWidth) r.scrollLeft = Math.max(0, L - 24); }
}
var SUBC = {}, STYLE = {"Dangles":1, "Plain metal":1, "Rhinestones":1, "Chains":1};
function subCounts(){
var key = S.scope.t + ":" + (S.scope.r == null ? "" : S.scope.r); if (SUBC[key]) return SUBC[key];
var cnt = {}, total = 0;
function add(a){ total++; a.forEach(function(s){ cnt[s] = (cnt[s] || 0) + 1; }); }
D.items.forEach(function(it, i){ if (it.z || !inScope(it, i)) return; if (it.vv) it.vv.forEach(function(v, k){ if (!ZV[i + ":" + k]) add(v[2]); }); else add(it.st); });
return (SUBC[key] = Object.keys(cnt).map(function(k){ return [+k, cnt[k]]; }).filter(function(x){ return x[1] >= 3 && x[1] <= total*0.85 && !STYLE[D.subs[x[0]]]; }).sort(function(a,b){ return b[1]-a[1]; }).slice(0, 12));
}
function chip(label, count, pressed, fn){ var b = document.createElement("button"); b.type = "button"; b.setAttribute("aria-pressed", pressed); b.appendChild(document.createTextNode(label)); if (count != null){ var c = document.createElement("b"); c.textContent = count; b.appendChild(c); } b.addEventListener("click", fn); return b; }
function renderSubs(){
var el = $("subs"), t = S.scope.t; el.innerHTML = "";
if (t === "sets"){
if (!WEEK){ el.hidden = true; return; } el.hidden = false;
WEEK.forEach(function(c, k){ el.appendChild(chip(c.l, null, S.setc === k, function(){ S.setc = k; S.sset = -1; S.page = 1; renderPicker(true); })); });
return;
}
if (t === "edit" || t === "saved" || t === "foryou" || t === "sale"){ el.hidden = true; return; } el.hidden = false;
if (t === "gift"){ D.gifts.forEach(function(g, k){ el.appendChild(chip(g.l, null, S.gift === k, function(){ S.gift = k; S.page = 1; renderPicker(true); })); }); return; }
el.appendChild(chip(t === "rail" ? "All " + D.rail[S.scope.r].l : "Everything", null, S.sub < 0, function(){ S.sub = -1; S.page = 1; renderPicker(true); }));
subCounts().forEach(function(x){ el.appendChild(chip(D.subs[x[0]], x[1], S.sub === x[0], function(){ S.sub = x[0]; S.page = 1; renderPicker(true); })); });
}
function renderBanner(){
var b = $("banner"), t = S.scope.t; b.innerHTML = ""; b.hidden = !(t === "edit" || t === "gift" || t === "foryou" || t === "sets" || t === "sale" || t === "new"); if (b.hidden) return;
if (t === "new"){
var mn = document.createElement("span"); mn.className = "micro"; mn.textContent = "New"; b.appendChild(mn);
var hn = document.createElement("h3"); hn.textContent = "Just added"; b.appendChild(hn);
var dz = 0; (D.nw || []).forEach(function(k){ var it2 = D.items[k]; if (it2) dz += it2.vv ? it2.vv.length : 1; });
var pn = document.createElement("p"); pn.textContent = (D.nw || []).length.toLocaleString() + " new charms, " + dz.toLocaleString() + " designs. Newest first."; b.appendChild(pn); return;
}
if (t === "sets"){ setsBanner(b); return; }
if (t === "sale"){
var ms = document.createElement("span"); ms.className = "micro"; ms.textContent = "Sale"; b.appendChild(ms);
var hs = document.createElement("h3"); hs.textContent = "Charms on sale"; b.appendChild(hs);
var n = (D.sale || []).length, pc = salePct(), ps2 = document.createElement("p");
ps2.textContent = n ? n.toLocaleString() + " designs, up to " + pc + "% off. The price on each card is the sale price." : "Nothing is on sale right now.";
b.appendChild(ps2); return;
}
if (t === "foryou"){
var m0 = document.createElement("span"); m0.className = "micro"; m0.textContent = "Picked for you"; b.appendChild(m0);
var h0 = document.createElement("h3"); h0.textContent = "Your picks"; b.appendChild(h0);
var parts = hubSummary(), pills = document.createElement("div"); pills.className = "pills";
(parts.length ? parts : ["Popular right now"]).forEach(function(t2){ var pl = document.createElement("span"); pl.className = "pill"; pl.textContent = t2; pills.appendChild(pl); }); b.appendChild(pills);
var row = document.createElement("div"); row.style.cssText = "display:flex;gap:8px;margin-top:10px;flex-wrap:wrap";
var b1 = document.createElement("button"); b1.type = "button"; b1.className = "btn"; b1.textContent = "Make me a bracelet"; b1.addEventListener("click", buildFromPicks);
var b2 = document.createElement("button"); b2.type = "button"; b2.className = "btn ghost"; b2.textContent = "Change picks"; b2.addEventListener("click", openHub);
row.appendChild(b1); row.appendChild(b2); b.appendChild(row); return;
}
var m = document.createElement("span"); m.className = "micro"; m.textContent = t === "edit" ? "This week's edit" : "Gift guide"; b.appendChild(m);
var h = document.createElement("h3"); h.textContent = t === "edit" ? D.edit.t : D.gifts[S.gift].l; b.appendChild(h);
var p = document.createElement("p"); p.textContent = t === "edit" ? D.edit.b : (GIFT_NOTE[S.gift] || ""); b.appendChild(p);
if (t === "edit"){
var btn = document.createElement("button"); btn.type = "button"; btn.className = "btn ghost"; btn.style.marginTop = "8px"; btn.textContent = "Try the whole look · " + D.edit.d.length + " charms";
btn.addEventListener("click", function(){
var free = 0; B.own.forEach(function(o){ if (o < 0) free++; });
var where = B, startedNew = false;
if (free < D.edit.d.length){ var nb = newBracelet(B.base, B.size); S.br.push(nb); setCur(S.br.length-1); where = nb; startedNew = true; }
D.edit.d.forEach(function(r){ var p = makePiece(r[0], r[1] < 0 ? null : r[1]); if (placeIn(where, p) < 0) placeAny(p); });
update(); stageIn(0); toast(startedNew ? "The look is on bracelet " + (S.cur+1) : "Added the " + D.edit.t + " look. Tap any link to swap it");
toStage();
});
b.appendChild(btn);
}
}
function setScope(t, r){ S.scope = {t:t, r:r}; S.sub = -1; S.page = 1; renderPicker(true); }
function renderPicker(jump){
if (jump && !GT) GT = {fade:1};
renderRail(); renderSubs(); renderBanner(); renderGrid();
if (jump){ var y = $("pk").getBoundingClientRect().top + window.scrollY - 60; if (window.scrollY > y + 40) window.scrollTo({top: y}); }
}
var NMC = null;
function fitNames(root){
var els = root.querySelectorAll(".n"); if (!els.length) return;
var cs = getComputedStyle(els[0]); if (!NMC) NMC = document.createElement("canvas").getContext("2d");
NMC.font = cs.fontStyle + " " + cs.fontWeight + " " + cs.fontSize + " " + cs.fontFamily;
var ls = parseFloat(cs.letterSpacing) || 0, W = function(t){ return NMC.measureText(t).width + ls * t.length; };
Array.prototype.forEach.call(els, function(el){
var full = el.getAttribute("data-full") || el.textContent, w = el.clientWidth;
if (!w) return;
el.setAttribute("data-full", full);
if (W(full) <= w - 1){ if (el.textContent !== full){ el.textContent = full; el.removeAttribute("aria-label"); } return; }
var m = full.match(/^(.+?)(\s+\/\s+.+|\s+in\s+(?:rose\s+gold|silver|gold|black|rose)|\s+\S+)$/i);
if (!m) return;
var head = m[1], tail = " " + m[2].replace(/^\s+/, ""), lo = 0, hi = head.length;
while (lo < hi){ var mid = (lo + hi + 1) >> 1; if (W(head.slice(0, mid).replace(/\s+$/, "") + "…" + tail) <= w - 1) lo = mid; else hi = mid - 1; }
if (lo < 4) return;
el.textContent = head.slice(0, lo).replace(/\s+$/, "") + "…" + tail; el.setAttribute("aria-label", full);
});
}
function saveView(){ try { sessionStorage.setItem("csb_view", JSON.stringify({q: S.q, t: S.scope.t, r: S.scope.r, h: S.scope.t === "rail" && D && D.rail[S.scope.r] ? D.rail[S.scope.r].h : null, sub: S.sub})); } catch(e){} }
function restoreView(){
try {
var v = JSON.parse(sessionStorage.getItem("csb_view") || "null"); if (!v) return;
if (v.q){ S.q = String(v.q).slice(0, 80); $("q").value = S.q; kwLoad(); kwSpin(); }
if (v.t === "rail" && v.h && D.rail[v.r] && D.rail[v.r].h === v.h){ S.scope = {t: "rail", r: v.r}; if (typeof v.sub === "number") S.sub = v.sub; }
else if (v.t === "new" && D.nw && D.nw.length){ S.scope = {t: "new"}; if (typeof v.sub === "number") S.sub = v.sub; }
loadPage();
} catch(e){}
}
var PGI = {l:'<svg class="ic" viewBox="0 0 24 24" aria-hidden="true"><path d="M15 6l-6 6 6 6"/></svg>', r:'<svg class="ic" viewBox="0 0 24 24" aria-hidden="true"><path d="M9 6l6 6-6 6"/></svg>'};
function perPage(){
var v = getComputedStyle($("grid")).gridTemplateColumns || "", m = v.match(/repeat\(\s*(\d+)/);
var n = m ? +m[1] : v.split(/\s+/).filter(function(x){ return /px$/.test(x); }).length;
return Math.max(1, n || 3) * 8;
}
function barsBottom(){ var st = $("stick"), t = parseFloat(getComputedStyle(st).top); if (isNaN(t)) t = 52; if (typeof stk !== "undefined" && stk.hid) return t + ($("stickTab").offsetHeight || 34) + 12; return t + st.offsetHeight; }
function firstVisible(){
var bb = barsBottom(), cs = $("grid").children;
for (var k=0;k<cs.length;k++){ if (!cs[k].hasAttribute("data-k")) continue; var r = cs[k].getBoundingClientRect(); if (r.top >= innerHeight) break; if (r.bottom > bb) return cs[k]; }
return null;
}
function pageKey(){ var t = S.scope.t; return t + ":" + (S.scope.r == null ? "" : S.scope.r) + ":" + (t === "gift" ? "g" + S.gift : t === "sets" ? "s" + S.setc + "." + S.sset : S.sub); }
function savePage(){ try { var m = JSON.parse(sessionStorage.getItem("csb_pages") || "{}") || {}; m[pageKey()] = S.page; sessionStorage.setItem("csb_pages", JSON.stringify(m)); } catch(e){} }
function loadPage(){ try { var m = JSON.parse(sessionStorage.getItem("csb_pages") || "{}"), p = m ? Number(m[pageKey()]) : 0; if (p >= 1) S.page = Math.floor(p); } catch(e){} }
function pageList(cur, n, sib){
var a = [], k, slots = 2*sib + 5;
if (n <= slots){ for (k=1;k<=n;k++) a.push(k); return a; }
if (cur <= sib + 3){ for (k=1;k<=2*sib+3;k++) a.push(k); a.push(-1, n); return a; }
if (cur >= n - sib - 2){ a.push(1, -1); for (k=n-2*sib-2;k<=n;k++) a.push(k); return a; }
a.push(1, -1); for (k=cur-sib;k<=cur+sib;k++) a.push(k); a.push(-1, n); return a;
}
function pgBtn(html, k, label, dis, cls){ var b = document.createElement("button"); b.type = "button"; b.className = "pgb" + (cls ? " " + cls : ""); b.innerHTML = html; b.setAttribute("aria-label", label); if (dis) b.disabled = true; else b.setAttribute("data-p", k); return b; }
function fillPager(nav, cur, n, sib){
nav.innerHTML = "";
nav.appendChild(pgBtn(PGI.l, cur - 1, "Previous page", cur <= 1, "pv"));
pageList(cur, n, sib).forEach(function(k){
if (k < 0){ var e = document.createElement("span"); e.className = "pgel"; e.textContent = "…"; e.setAttribute("aria-hidden", "true"); nav.appendChild(e); return; }
var b = pgBtn(String(k), k, "Page " + k, false, ""); if (k === cur) b.setAttribute("aria-current", "page"); nav.appendChild(b);
});
nav.appendChild(pgBtn(PGI.r, cur + 1, "Next page", cur >= n, "pv"));
}
function pgOver(nav){ var l = nav.lastElementChild; return !!l && l.getBoundingClientRect().right > nav.getBoundingClientRect().right + 0.5; }
function renderPagers(total, start){
var top = $("pgTop"), bot = $("pgBot"), n = S.pages;
top.hidden = bot.hidden = n < 2; if (n < 2) return;
$("pgRng").textContent = (start + 1).toLocaleString() + "–" + Math.min(total, start + S.per).toLocaleString() + " of " + total.toLocaleString();
top.classList.remove("tight");
[$("pgNavT"), $("pgNavB")].forEach(function(nav){
fillPager(nav, S.page, n, 1);
if (pgOver(nav)){ fillPager(nav, S.page, n, 0); if (nav.id === "pgNavT" && pgOver(nav)) top.classList.add("tight"); }
});
}
function goPage(n, nav, from){
if (!(n >= 1 && n <= S.pages) || n === S.page){ if (from) swpBack(from); return; }
var foc = !!(nav && nav.contains(document.activeElement));
GT = {dir: n > S.page ? 1 : -1, from: from || 0};
S.page = n; S.per = perPage(); renderGrid();
var bb = barsBottom();
if ($("grid").getBoundingClientRect().top < bb){ var y = $("pgTop").getBoundingClientRect().top + window.pageYOffset - bb - 6; window.scrollTo({top: Math.max(0, y), behavior: REDUCED ? "auto" : "smooth"}); }
if (foc){ var cur = nav.querySelector('[aria-current="page"]'); if (cur) cur.focus({preventScroll:true}); }
}
function hScroll(el, stop){
for (; el && el !== stop.parentNode; el = el.parentNode){
if (el.nodeType !== 1) continue;
if (el.scrollWidth > el.clientWidth + 1){ var ox = getComputedStyle(el).overflowX; if (ox === "auto" || ox === "scroll") return true; }
}
return false;
}
var GT = null, GA = null, gridSig = "", IMGC = {};
function gridSettle(){
var st = GA; GA = null;
if (st){ st.a.forEach(function(a){ try { a.cancel(); } catch(e){} }); if (st.gh && st.gh.parentNode) st.gh.parentNode.removeChild(st.gh); }
var g = $("grid"); if (g && g.style.transform) g.style.transform = "";
}
function gridGhost(g){
var gh = document.createElement("div"); gh.className = "grid gghost done"; gh.setAttribute("aria-hidden", "true"); gh.inert = true;
gh.style.left = g.offsetLeft + "px"; gh.style.top = g.offsetTop + "px"; gh.style.width = g.offsetWidth + "px";
while (g.firstChild) gh.appendChild(g.firstChild);
g.parentNode.insertBefore(gh, g.nextSibling);
return gh;
}
function gridAnim(g, gh, gt){
if (!g.animate || !gh.animate){ if (gh.parentNode) gh.parentNode.removeChild(gh); return; }
var d = gt.dir || 0, x0 = gt.from || 0, outK, inK, outT, inT;
if (d && !REDUCED){ outK = [{transform:"translateX(" + x0 + "px)", opacity:1}, {transform:"translateX(" + (x0 - 28*d) + "px)", opacity:0}]; inK = [{transform:"translateX(" + (28*d) + "px)", opacity:0}, {transform:"none", opacity:1}]; outT = 150; inT = 200; }
else if (REDUCED){ outK = [{opacity:1}, {opacity:0}]; inK = [{opacity:0}, {opacity:1}]; outT = 100; inT = 120; }
else { outK = [{opacity:1}, {opacity:0}]; inK = [{transform:"translateY(6px)", opacity:0}, {transform:"none", opacity:1}]; outT = 100; inT = 160; }
var st = GA = {gh: gh, a: []};
var ao = gh.animate(outK, {duration: outT, easing: "ease-out", fill: "forwards"}), ai = g.animate(inK, {duration: inT, easing: "cubic-bezier(.2,.8,.2,1)"});
st.a.push(ao, ai);
ao.onfinish = function(){ if (gh.parentNode) gh.parentNode.removeChild(gh); st.gh = null; };
ai.onfinish = function(){ if (GA === st) GA = null; };
}
function swpBack(x){
var g = $("grid"); g.style.transform = "";
if (!x || REDUCED || !g.animate) return;
var a = g.animate([{transform:"translateX(" + x + "px)"}, {transform:"none"}], {duration:200, easing:"cubic-bezier(.2,.8,.2,1)"}), st = GA = {gh: null, a: [a]};
a.onfinish = function(){ if (GA === st) GA = null; };
}
function imgFade(el, box){
var m = /url\(["']?([^"')]+)["']?\)/.exec(el.style.backgroundImage || ""); if (!m || !box) return;
var u = m[1], c = IMGC[u];
if (!c){
c = IMGC[u] = {ok: false, q: []};
var im = new Image(), done = function(){ c.ok = true; var q = c.q; c.q = []; q.forEach(function(f){ f(); }); };
im.onload = im.onerror = done; im.src = u;
if (im.complete && im.naturalWidth){ im.onload = im.onerror = null; c.ok = true; }
}
if (c.ok){ box.classList.remove("ld"); return; }
box.classList.add("ld"); c.q.push(function(){ box.classList.remove("ld"); });
}
function renderGrid(){
saveView();
var gt = GT; GT = null; gridSettle();
var lst = list(), g = $("grid"), per = perPage(), anchor = -1;
if (S.per && per !== S.per){ var fv = firstVisible(); anchor = fv ? +fv.getAttribute("data-k") : -1; S.page = Math.floor((anchor >= 0 ? anchor : (S.page - 1) * S.per) / per) + 1; }
S.per = per; S.pages = Math.max(1, Math.ceil(lst.length / per)); S.page = Math.max(1, Math.min(S.pages, S.page || 1)); savePage();
var start = (S.page - 1) * per;
var sig = lst.length + "|" + lst.slice(start, start + per).map(function(r){ return r.i + ":" + r.vi; }).join(","), ghost = null;
if (gt && (gt.dir || sig !== gridSig) && g.firstElementChild && g.firstElementChild.classList.contains("card") && g.offsetWidth) ghost = gridGhost(g);
gridSig = sig;
g.innerHTML = ""; g.classList.add("done");
var dl = S.sub >= 0 || S.q.trim() || (S.scope.t !== "all" && S.scope.t !== "rail" && S.scope.t !== "new");
$("count").textContent = lst.length.toLocaleString() + (dl ? " design" : " charm") + (lst.length === 1 ? "" : "s");
$("empty").hidden = lst.length > 0;
$("empty").textContent = S.scope.t === "saved" && !S.q ? "No saved charms yet. Tap the heart on any charm to save it." : S.scope.t === "sets" && !WEEK ? "" : "Nothing matches that. Try another word.";
if (!lst.length && S.q.trim() && S.scope.t !== "all"){
var sv = S.scope, ss = S.sub, na; S.scope = {t:"all"}; S.sub = -1; try { na = list().length; } finally { S.scope = sv; S.sub = ss; }
if (na){ var em = $("empty"); em.textContent = "Nothing here for that. "; var ab = document.createElement("button"); ab.type = "button"; ab.className = "lnk"; ab.style.color = "var(--ink)"; ab.textContent = "See " + na.toLocaleString() + " in all charms"; ab.addEventListener("click", function(){ setScope("all"); }); em.appendChild(ab); }
}
var frag = document.createDocumentFragment();
lst.slice(start, start + per).forEach(function(r, k){
var it = D.items[r.i], nm = r.gn || designName(r.i, r.vi), key = heartKey(r);
var card = document.createElement("div"); card.className = "card"; card.setAttribute("data-k", start + k); card.setAttribute("data-i", r.i); if (r.vi != null) card.setAttribute("data-vi", r.vi);
var pic = document.createElement("div"); pic.className = "pic";
var art = document.createElement("i"); art.className = "art"; pic.appendChild(art);
var tap = document.createElement("button"); tap.type = "button"; tap.className = "tap"; tap.setAttribute("aria-label", "Try " + nm + " on the bracelet");
var go = function(){ if (r.vi != null) addPiece(makePiece(r.i, r.vi), art); else if (r.mv) openVariants(r.i, r.mv, r.gn); else startAdd(r.i, art); };
tap.addEventListener("click", go); pic.appendChild(tap);
var h = document.createElement("button"); h.type = "button"; h.className = "heart"; h.setAttribute("aria-pressed", !!S.hearts[key]); h.setAttribute("aria-label", (S.hearts[key] ? "Remove " : "Save ") + nm); h.innerHTML = SV.heart;
h.addEventListener("click", function(){ toggleHeart(key, nm); h.setAttribute("aria-pressed", !!S.hearts[key]); h.setAttribute("aria-label", (S.hearts[key] ? "Remove " : "Save ") + nm); h.classList.remove("beat"); void h.offsetWidth; h.classList.add("beat"); if (S.scope.t === "saved") setTimeout(function(){ GT = {fade:1}; renderGrid(); }, 300); });
if (r.vi == null && it.vv){ var dn = document.createElement("span"); dn.className = "dn"; dn.textContent = (r.mv ? r.mv.length : it.vv.length) + " designs"; pic.appendChild(dn); art._dn = 1; }
var oc = onCount(r.i, r.vi); if (oc){ var o = document.createElement("span"); o.className = "onb"; o.innerHTML = SV.tick + "In bag" + (oc > 1 ? " ×" + oc : ""); pic.appendChild(o); }
card.appendChild(pic);
var n = document.createElement("div"); n.className = "n"; n.textContent = nm; n.title = r.vi != null ? nm + " · " + it.t : nm; card.appendChild(n);
var pr = document.createElement("div"); pr.className = "pr"; var ps = document.createElement("span"); var mvp = r.mv ? r.mv.map(function(k){ return priceOf(r.i, k); }) : null, mlo = mvp ? Math.min.apply(null, mvp) : 0; if (r.vi == null && (mvp ? Math.max.apply(null, mvp) > mlo : priceVaries(r.i))){ var fr = document.createElement("small"); fr.className = "fr"; fr.textContent = "From"; ps.appendChild(fr); } var cmp = saleCmp(r.i, r.vi), now = mvp ? mlo : priceOf(r.i, r.vi); if (cmp > now){ var so = document.createElement("s"); so.textContent = money(cmp); ps.appendChild(so); ps.className = "sl"; } ps.appendChild(document.createTextNode(money(now))); pr.appendChild(ps);
var acts = document.createElement("div"); acts.className = "acts"; acts.appendChild(h);
var ad = document.createElement("button"); ad.type = "button"; ad.className = "add"; ad.setAttribute("aria-label", "Add " + nm); ad.innerHTML = SV.plus; ad.addEventListener("click", go); acts.appendChild(ad);
if (cmp > now){ var ob = document.createElement("span"); ob.className = "off"; ob.textContent = Math.floor((cmp - now) / cmp * 100) + "% off"; pic.appendChild(ob); }
pr.appendChild(acts); card.appendChild(pr); art._a = r.mv ? aOf(r.i, r.mv[0]) : aOf(r.i, r.vi); frag.appendChild(card);
});
g.appendChild(frag);
var news = Array.prototype.slice.call(g.children);
requestAnimationFrame(function(){ news.forEach(function(card){ var el = card.querySelector(".art"); if (!el) return; var w = el.parentNode.clientWidth || 100; fit(el, el._a, w, el._dn ? Math.min(0.74, (w - 34) / w) : 0, el._dn); imgFade(el, el.parentNode); }); fitNames(g); });
renderPagers(lst.length, start);
if (ghost) gridAnim(g, ghost, gt);
if (anchor >= 0 && !document.body.classList.contains("lock")){ var ac = g.querySelector('[data-k="' + anchor + '"]'); if (ac){ var rt = ac.getBoundingClientRect(), bb = barsBottom(); if (rt.top < bb || rt.bottom > innerHeight) window.scrollTo(0, Math.max(0, window.pageYOffset + rt.top - bb - 8)); } }
}
function renderAllCats(){
var body = $("cBody"); body.innerHTML = ""; var after = function(){ closeSheet("cScrim"); };
var top = document.createElement("div"); top.className = "cgrid";
specials(function(t){ return S.scope.t === t; }, after).forEach(function(b){ top.appendChild(b); }); body.appendChild(top);
var counts = D.rail.map(function(){ return 0; }); D.items.forEach(function(it){ if (it.z) return; it.g.forEach(function(r){ counts[r]++; }); });
D.groups.forEach(function(gr){
var on = gr[1].filter(function(k){ return railOn(D.rail[k]); }); if (!on.length) return;
var w = document.createElement("div"); w.className = "cgrp"; var h = document.createElement("h4"); h.className = "micro"; h.textContent = gr[0]; w.appendChild(h);
var grid = document.createElement("div"); grid.className = "cgrid";
on.forEach(function(k){ grid.appendChild(railTile("", D.rail[k].l, S.scope.t === "rail" && S.scope.r === k, function(){ setScope("rail", k); after(); }, {a: D.rail[k].a, pad: 0.76, count: counts[k]})); });
w.appendChild(grid); body.appendChild(w);
});
paintAll(body, 56);
}
var SETS = null, SETP = null, WEEK = null, VREF = null;
function setsLoad(){
if (SETS) return Promise.resolve(SETS);
if (SETP) return SETP;
var url = (window.CSB && CSB.sets) || "sets.json";
SETP = fetch(url).then(function(r){ if (!r.ok) throw new Error("HTTP " + r.status); return r.json(); })
.then(function(d){ SETS = d; WEEK = setsWeek(d); return d; }, function(e){ SETP = null; throw e; });
return SETP;
}
function vref(v){
if (!VREF){ VREF = {}; D.items.forEach(function(it, i){ if (it.vv) it.vv.forEach(function(x, vi){ if (x[5]) VREF[x[5]] = [i, vi]; }); else if (it.id) VREF[it.id] = [i, null]; }); }
return VREF[v];
}
function setsWeek(d){
var now = new Date(), st = d.start.split("-"), t0 = Date.UTC(+st[0], +st[1] - 1, +st[2]);
var today = Date.UTC(now.getFullYear(), now.getMonth(), now.getDate()), w = Math.floor((today - t0) / 864e5 / 7);
var md = ("0" + (now.getMonth() + 1)).slice(-2) + "-" + ("0" + now.getDate()).slice(-2);
function mod(a, n){ return ((a % n) + n) % n; }
function open(win){ return !!win && (win[0] <= win[1] ? md >= win[0] && md <= win[1] : md >= win[0] || md <= win[1]); }
function live(c){ var sets = c.sets.filter(function(s){ return s.ids.every(function(v){ return !!vref(v); }); }); return sets.length ? {k: c.k, l: c.l, b: c.b, sets: sets} : null; }
var out = [], skip = {};
var bd = d.bday[String(d.ages[mod(w, d.ages.length)])]; if (bd) out.push(live({k: "birthday", l: bd.l, b: bd.b, sets: bd.sets}));
d.concepts.forEach(function(c){ if (c.win && open(c.win)){ out.push(live(c)); (c.skip || []).forEach(function(k){ skip[k] = 1; }); } });
d.zodiac.forEach(function(z){ if (open(z.win)) out.push(live(z)); });
var ev = d.concepts.filter(function(c){ return !c.win && !skip[c.k]; }), K = Math.min(d.per || 6, ev.length), s0 = mod(w * K, ev.length);
for (var j = 0; j < K; j++) out.push(live(ev[(s0 + j) % ev.length]));
return out.filter(Boolean);
}
function setRefs(set){ return set.ids.map(vref).filter(Boolean); }
function setsRefs(){
if (!WEEK || !WEEK.length) return [];
var c = WEEK[Math.min(S.setc, WEEK.length - 1)], seen = {}, out = [];
(S.sset >= 0 && c.sets[S.sset] ? [c.sets[S.sset]] : c.sets).forEach(function(s){ setRefs(s).forEach(function(r){ var k = r[0] + ":" + r[1]; if (seen[k]) return; seen[k] = 1; out.push([r[0], r[1] == null ? -1 : r[1]]); }); });
return out;
}
function setTotal(set){ return Math.round(setRefs(set).reduce(function(a, r){ return a + priceOf(r[0], r[1]); }, 0) * 100) / 100; }
function toSets(){ var el = $("banner"); if (!el) return; var y = el.getBoundingClientRect().top + window.scrollY - barsBottom() - 8; window.scrollTo({top: Math.max(0, y), behavior: REDUCED ? "auto" : "smooth"}); }
function useSet(set){
var refs = setRefs(set); if (!refs.length) return;
var where = B, fresh = !piecesOf(B).length;
if (fresh){ B.base = set.m; }
else { var nb = newBracelet(set.m, B.size); S.br.push(nb); setCur(S.br.length - 1); where = nb; }
var ps = refs.map(function(r){ return makePiece(r[0], r[1]); }), need = ps.reduce(function(a, p){ return a + blocked(p, 0).length; }, 0), s0 = Math.max(0, Math.floor((where.size - need) / 2));
ps.forEach(function(p){ if (canPlace(where, p, s0)){ setAt(where, p, s0); s0 += blocked(p, s0).length; } else if (placeIn(where, p) < 0) placeAny(p); });
update(); stageIn(0); scrollToSlot(Math.floor(where.size / 2) - 1, false);
toast(fresh ? "The " + set.t + " set is on your bracelet. Tap any charm to swap it" : "The " + set.t + " set is on bracelet " + (S.cur + 1) + ", with " + BASE_NAME[set.m].toLowerCase() + " links");
toStage();
}
var setIO = null;
function setsBanner(b){
var m = document.createElement("span"); m.className = "micro"; m.textContent = "Sets · new every Monday"; b.appendChild(m);
if (!WEEK){
var h0 = document.createElement("h3"); h0.textContent = "Bracelet sets"; b.appendChild(h0);
var p0 = document.createElement("p"); p0.textContent = "Loading this week's sets…"; b.appendChild(p0);
setsLoad().then(function(){ if (S.scope.t === "sets") renderPicker(false); }, function(){
p0.textContent = "The sets could not load. Check your connection and try again.";
var rb = document.createElement("button"); rb.type = "button"; rb.className = "btn ghost"; rb.style.marginTop = "8px"; rb.textContent = "Try again";
rb.addEventListener("click", function(){ renderPicker(false); }); b.appendChild(rb);
});
return;
}
if (!WEEK.length){ var pe = document.createElement("p"); pe.textContent = "No sets this week."; b.appendChild(pe); return; }
if (S.setc >= WEEK.length) S.setc = 0;
var c = WEEK[S.setc];
var h = document.createElement("h3"); h.textContent = c.l; b.appendChild(h);
var p = document.createElement("p"); p.textContent = c.b + " Every set uses one metal, so the links match."; b.appendChild(p);
var wrap = document.createElement("div"); wrap.className = "sets"; b.appendChild(wrap);
var rows = [];
c.sets.forEach(function(set, k){
var refs = setRefs(set), card = document.createElement("div"); card.className = "setc" + (S.sset === k ? " on" : "");
var hd = document.createElement("div"); hd.className = "sth";
var nm = document.createElement("b"); nm.textContent = set.t; hd.appendChild(nm);
var meta = document.createElement("small"); meta.textContent = BASE_NAME[set.m] + " · " + refs.length + " charms · " + money(setTotal(set)); hd.appendChild(meta);
card.appendChild(hd);
var rw = document.createElement("div"); rw.className = "strow"; var row = document.createElement("div"); row.className = "row"; rw.appendChild(row); card.appendChild(rw);
rows.push({el: row, box: rw, set: set, refs: refs});
var ft = document.createElement("div"); ft.className = "stf";
var use = document.createElement("button"); use.type = "button"; use.className = "btn"; use.textContent = "Use this set";
use.addEventListener("click", function(){ useSet(set); }); ft.appendChild(use);
var see = document.createElement("button"); see.type = "button"; see.className = "lnk"; see.textContent = S.sset === k ? "Show all " + c.sets.length + " sets' charms" : "See these charms";
see.addEventListener("click", function(){ S.sset = S.sset === k ? -1 : k; S.page = 1; renderPicker(false); var g = $("grid"); if (g && S.sset >= 0){ var y = g.getBoundingClientRect().top + window.scrollY - barsBottom() - 50; window.scrollTo({top: Math.max(0, y), behavior: REDUCED ? "auto" : "smooth"}); } });
ft.appendChild(see); card.appendChild(ft);
wrap.appendChild(card);
});
function draw(r){
var n = r.refs.length; if (!n || r.el._done) return; r.el._done = 1;
var w = Math.min(36, Math.floor((r.box.clientWidth - 4) / n)), tb = newBracelet(r.set.m, n);
r.refs.forEach(function(x, s){ setAt(tb, makePiece(x[0], x[1]), s); });
renderRow(r.el, w, tb, {});
}
if ("IntersectionObserver" in window){
if (setIO) setIO.disconnect();
setIO = new IntersectionObserver(function(en){ en.forEach(function(e){ if (!e.isIntersecting) return; rows.forEach(function(r){ if (r.box === e.target) draw(r); }); setIO.unobserve(e.target); }); }, {rootMargin: "200px 0px"});
rows.forEach(function(r){ setIO.observe(r.box); });
} else rows.forEach(draw);
}
window.addEventListener("hashchange", function(){ if (!D) return; if (location.hash === "#sets"){ setScope("sets"); setTimeout(toSets, 120); } else if (location.hash === "#sale"){ setScope("sale"); setTimeout(toSets, 120); } else if (location.hash === "#new"){ setScope("new"); setTimeout(toSets, 120); } });
function buildIdx(){ IDX.s = {}; D.subkeys.forEach(function(k, i){ IDX.s[k] = i; }); IDX.c = {}; D.cols.forEach(function(k, i){ IDX.c[k] = i; }); IDX.f = {}; D.fors.forEach(function(k, i){ IDX.f[k] = i; }); IDX.v = {}; D.vibes.forEach(function(k, i){ IDX.v[k] = i; }); }
function eachDesign(fn){ for (var i=0;i<D.items.length;i++){ var it = D.items[i]; if (it.z) continue; if (it.vv){ for (var vi=0;vi<it.vv.length;vi++){ var v = it.vv[vi]; if (ZV[i + ":" + vi]) continue; if (fn(i, vi, v[2], v[4] || [[],[],[],-1], v[3]) === false) return; } } else if (fn(i, null, it.st, it.x || [[],[],[],-1], it.a) === false) return; } }
function anyIn(arr, keys, map){ for (var k=0;k<keys.length;k++){ if (arr.indexOf(map[keys[k]]) >= 0) return true; } return false; }
function whoSpec(){ for (var k=0;k<WHO.length;k++){ if (WHO[k][0] === HUB.who) return WHO[k][2]; } return {}; }
function scoreOf(subs, x){
var sc = 0, lovesOn = Object.keys(HUB.loves), loveHit = false, w = whoSpec(), whoOn = HUB.who !== "me", whoHit = false, lookOn = Object.keys(HUB.look), lookHit = false;
lovesOn.forEach(function(li){ if (anyIn(subs, LOVES[li][1], IDX.s)){ sc += 3; loveHit = true; } });
if (whoOn){ if (w.f && anyIn(x[2], w.f, IDX.f)){ sc += 3; whoHit = true; } if (w.s && anyIn(subs, w.s, IDX.s)){ sc += 2; whoHit = true; } }
lookOn.forEach(function(li){ var sp = LOOK[li][1]; if (sp.c && x[0].indexOf(IDX.c[sp.c]) >= 0){ sc += 1.5; lookHit = true; } if (sp.s && anyIn(subs, sp.s, IDX.s)){ sc += 2; lookHit = true; } if (sp.v && x[3] === IDX.v[sp.v]){ sc += 1.5; lookHit = true; } });
if (lovesOn.length && !loveHit) return 0;
if (!lovesOn.length && whoOn && !whoHit) return 0;
if (!lovesOn.length && !whoOn && lookOn.length && !lookHit) return 0;
return (lovesOn.length || whoOn || lookOn.length) ? sc : 1;
}
function foryouList(){
var out = [];
eachDesign(function(i, vi, subs, x){ var sc = scoreOf(subs, x); if (sc > 0) out.push({i:i, vi:vi, sc:sc}); });
out.sort(function(a, b){ return b.sc - a.sc || D.items[b.i].u - D.items[a.i].u; });
return out;
}
var REP = {}, REPA = {}, REPU = {};
function repFor(spec){
var key = JSON.stringify(spec); if (REP[key] != null) return REP[key];
var cand = [];
eachDesign(function(i, vi, subs, x, a){
var ok = (spec.s && anyIn(subs, spec.s, IDX.s)) || (spec.c && x[0].indexOf(IDX.c[spec.c]) >= 0) || (spec.v && x[3] === IDX.v[spec.v]) || (spec.f && anyIn(x[2], spec.f, IDX.f));
if (!ok || a == null || a < 0 || REPU[a]) return;
cand.push(a); if (cand.length >= 10) return false;
});
var pick = -1;
for (var k = 0; k < cand.length; k++){ if (REPA[E(cand[k])[0]]){ pick = cand[k]; break; } }
if (pick < 0 && cand.length) pick = cand[0];
if (pick >= 0){ REPA[E(pick)[0]] = 1; REPU[pick] = 1; }
return (REP[key] = pick);
}
function bubble(label, pressed, fn, o){
var b = document.createElement("button"); b.type = "button"; b.className = "bub"; b.setAttribute("aria-pressed", pressed);
var i = document.createElement("i");
if (o.sw){ var em = document.createElement("em"); em.style.background = o.sw; i.appendChild(em); }
else if (o.a >= 0){ b._paint = function(){ i.appendChild(thumbCanvas(o.a, 44, 0.95, -2)); }; }
else if (o.svg) i.innerHTML = o.svg;
b.appendChild(i); var sp = document.createElement("span"); sp.textContent = label; b.appendChild(sp);
b.addEventListener("click", fn); return b;
}
function hive(buttons){
var wrap = document.createElement("div"); wrap.className = "hive"; var k = 0, big = true;
while (k < buttons.length){ var n = big ? 4 : 3, row = document.createElement("div"); row.className = "hrow"; buttons.slice(k, k+n).forEach(function(b){ row.appendChild(b); }); wrap.appendChild(row); k += n; big = !big; }
return wrap;
}
var hubIO = null;
function renderHub(){
var body = $("fBody"); body.innerHTML = "";
function sec(title, hint, el){ var s = document.createElement("section"); s.className = "hsec"; var h = document.createElement("h4"); h.textContent = title; var sm = document.createElement("small"); sm.textContent = hint; h.appendChild(sm); s.appendChild(h); s.appendChild(el); body.appendChild(s); }
sec("Who is it for?", "pick one", hive(WHO.map(function(w){ var spec = w[2]; return bubble(w[1], HUB.who === w[0], function(){ HUB.who = w[0]; renderHub(); }, w[0] === "me" ? {svg: EN.heart} : {a: repFor(spec)}); })));
sec("What do they love?", "tap all that fit", hive(LOVES.map(function(l, li){ return bubble(l[0], !!HUB.loves[li], function(){ if (HUB.loves[li]) delete HUB.loves[li]; else HUB.loves[li] = 1; renderHub(); }, {a: repFor({s: l[1]})}); })));
sec("The look", "optional", hive(LOOK.map(function(l, li){ var sp = l[1]; return bubble(l[0], !!HUB.look[li], function(){ if (HUB.look[li]) delete HUB.look[li]; else HUB.look[li] = 1; renderHub(); }, sp.sw ? {sw: sp.sw} : {a: repFor(sp)}); })));
var bubs = body.querySelectorAll(".bub");
if ("IntersectionObserver" in window){
if (hubIO) hubIO.disconnect();
hubIO = new IntersectionObserver(function(en){ en.forEach(function(e){ if (!e.isIntersecting) return; var bb = e.target; if (bb._paint){ bb._paint(); bb._paint = null; } hubIO.unobserve(bb); }); }, {rootMargin: "240px 0px"});
Array.prototype.forEach.call(bubs, function(bb){ if (bb._paint) hubIO.observe(bb); });
} else Array.prototype.forEach.call(bubs, function(bb){ if (bb._paint) bb._paint(); });
var n = foryouList().length, any = HUB.who !== "me" || Object.keys(HUB.loves).length || Object.keys(HUB.look).length;
$("fShow").textContent = any ? "Show " + n.toLocaleString() + " picks" : "Show popular picks";
}
function hubSummary(){
var parts = []; if (HUB.who !== "me") WHO.forEach(function(w){ if (w[0] === HUB.who) parts.push("For " + w[1]); });
Object.keys(HUB.loves).forEach(function(li){ parts.push(LOVES[li][0]); }); Object.keys(HUB.look).forEach(function(li){ parts.push(LOOK[li][0]); });
return parts;
}
function openHub(){ renderHub(); openSheet("fScrim"); }
function buildFromPicks(){
var lst = foryouList(), per = {}, picks = [];
for (var k=0;k<lst.length && picks.length<10;k++){ var r = lst[k]; if ((per[r.i] || 0) >= 2) continue; per[r.i] = (per[r.i] || 0) + 1; picks.push(r); }
if (!picks.length){ toast("Nothing matched. Try fewer taps"); return; }
var where = B, startedNew = false;
var lk = Object.keys(HUB.look).map(function(li){ return LOOK[li][1].c; }), metal = null;
if (lk.indexOf("gold") >= 0 && lk.indexOf("silver") < 0) metal = "gold"; else if (lk.indexOf("silver") >= 0 && lk.indexOf("gold") < 0) metal = "silver";
if (piecesOf(B).length){ var nb = newBracelet(metal || B.base, B.size); S.br.push(nb); setCur(S.br.length-1); where = nb; startedNew = true; }
else if (metal) B.base = metal;
picks.forEach(function(r){ var p = makePiece(r.i, r.vi); if (placeIn(where, p) < 0) placeAny(p); });
var on = metal ? " on a " + BASE_NAME[metal].toLowerCase() + " bracelet" : "";
update(); stageIn(0); toast(startedNew ? picks.length + " picks are on bracelet " + (S.cur+1) + (metal ? ", in " + BASE_NAME[metal].toLowerCase() : "") + ". Swap any you don't love" : picks.length + " picks" + (on || " on your bracelet") + ". Swap any you don't love");
toStage();
}
function renderReview(){
var body = $("rBody"); body.innerHTML = ""; var c = charmCount();
$("rNote").textContent = c + " charm" + (c===1?"":"s") + " on " + S.br.length + " bracelet" + (S.br.length>1?"s":"") + ". Tap a charm to jump to it.";
S.br.forEach(function(b, bi){
var sec = document.createElement("section"); sec.className = "rvsec";
var h = document.createElement("div"); h.className = "rvh"; h.innerHTML = "<span>Bracelet " + (bi+1) + " · " + BASE_NAME[b.base] + "</span><small>" + piecesOf(b).length + " charms · " + b.size + " links</small>"; sec.appendChild(h);
var g = document.createElement("div"); g.className = "rvgrid";
for (var slot=0; slot<b.size; slot++){
(function(slot){
var o = b.own[slot], p = o >= 0 ? b.slots[o] : null, btn = document.createElement("button"); btn.type = "button";
if (p && o === slot){ var bb = document.createElement("b"); btn.appendChild(bb); btn._a = p.a; btn.setAttribute("aria-label", pieceName(p)); }
else if (p){ btn.className = "pl"; btn.setAttribute("aria-label", pieceName(p) + " continues"); }
else { btn.className = "pl"; var pb = document.createElement("b"); btn.appendChild(pb); btn._a = D.plain[b.base]; btn.setAttribute("aria-label", "Plain link " + (slot+1)); }
btn.addEventListener("click", function(){ setCur(bi); S.sel = o >= 0 ? o : slot; closeSheet("rScrim"); renderStage(); renderMeter(); scrollToSlot(slot, false); toStage(); });
g.appendChild(btn);
})(slot);
}
sec.appendChild(g); body.appendChild(sec);
});
requestAnimationFrame(function(){ Array.prototype.forEach.call(body.querySelectorAll(".rvgrid button"), function(btn){ if (btn._a != null && btn.firstChild) fit(btn.firstChild, btn._a, btn.clientWidth || 30, 0.86); }); });
}
function openReview(){ renderReview(); openSheet("rScrim"); }
function toggleHeart(key, name){
if (S.hearts[key]) { delete S.hearts[key]; toast("Removed from your hearts"); }
else { S.hearts[key] = Date.now(); if (!S.asked) { S.asked = true; store("cs_hearts_asked", "1"); openSheet("hScrim"); } else toast("Saved " + name); }
store("cs_hearts", JSON.stringify(S.hearts)); updateCounts();
if (STORE) heartToTheme(key, name);
}
function tierPct(c){ c = Math.max(0, Math.min(30, c)); return c <= 5 ? c/5*25 : c <= 10 ? 25 + (c-5)/5*25 : c <= 20 ? 50 + (c-10)/10*25 : 75 + (c-20)/10*25; }
var FREE_SHIP = fx(40);
function totals(){
var c = charmCount(), charms = 0; allPieces().forEach(function(p){ charms += priceOf(p.i, p.vi); });
var prices = S.br.map(function(b){ return BASE_PRICE[b.base]; }).sort(function(a,b){ return a-b; });
var freeN = Math.min(prices.length, Math.min(3, Math.floor(c/10))), brFree = 0, brPaid = 0;
prices.forEach(function(x, i){ if (i < freeN) brFree += x; else brPaid += x; });
var items = c + bagExtras(c, freeN);
if (STORE) brPaid = 0;
var paid = charms + brPaid, shipNeed = paid >= FREE_SHIP ? 0 : FREE_SHIP - paid, ship = !shipNeed ? 0 : shipFee(paid);
return {c:c, charms:charms, brFree:brFree, brPaid:brPaid, freeN:freeN, nbr:prices.length, paid:paid, ship:ship, total:paid + ship, tool:prices.length > 0 && (c >= 10 || brPaid > 0), tools:1, second:c >= 20, items:items, shipNeed:shipNeed, cotm:c >= 5 && store("cs_cotm_no") !== "1", cotmOff:c >= 5 && store("cs_cotm_no") === "1"};
}
function shipFee(paid){ return paid < fx(10) ? fx(6) : paid < fx(20) ? fx(5) : paid < fx(30) ? fx(4.5) : fx(4); }
function bagExtras(c, freeN){ return 0; }
function nextGoal(c){ if (phPhase(c)) return PHC.need || 15; return c < 5 ? 5 : c < 10 ? 10 : c < 20 ? 20 : 30; }
function nextText(c, T){
if (c < 5) return (5-c) + " more for a free charm";
if (c < 10) return (10-c) + " more and the bracelet is free";
if (phPhase(c)) return ((PHC.need || 15) - c) + " more for a free photo charm";
if (c < 20) return (20-c) + " more for a 2nd free bracelet";
if (c < 30) return (30-c) + " more for a 3rd free bracelet";
return "Every reward unlocked";
}
function updateCounts(){ var n = Object.keys(S.hearts).length, hc = $("heartCount"); hc.hidden = !n; hc.textContent = n; var c = charmCount(), bc = $("bagCount"); bc.hidden = !c; bc.textContent = c; }
function bumpIt(el){ el.classList.remove("bump"); void el.offsetWidth; el.classList.add("bump"); }
function renderMeter(){
var T = totals(), c = T.c, goal = nextGoal(c);
$("cNum").textContent = c; $("miniNum").textContent = c; $("cOf").textContent = c >= 30 ? "" : " / " + goal; $("miniOf").textContent = c >= 30 ? "" : " / " + goal;
if (c !== S.lastC){ bumpIt($("cNum")); bumpIt($("miniNum")); S.lastC = c; }
$("cLbl").textContent = phPhase(c) ? "to a free photo charm" : c < 5 ? "to a free charm" : c < 10 ? "to a free bracelet" : c < 20 ? "to a 2nd bracelet" : c < 30 ? "to a 3rd bracelet" : "all unlocked";
var t15 = $("tk15"); if (t15){ t15.hidden = !(PHC && PHC.gift); t15.className = "ph" + (e1Base() >= (PHC && PHC.need || 15) ? " got" : ""); }
$("progFill").style.width = tierPct(c) + "%";
$("tk5").className = c >= 5 ? "got" : ""; $("tk10").className = c >= 10 ? "got" : ""; $("tk20").className = c >= 20 ? "got" : ""; $("tk30").className = c >= 30 ? "got" : "";
var cr = creditFor(T); $("dockSum").innerHTML = ""; $("dockSum").appendChild(document.createTextNode(c ? (S.br.length > 1 ? S.br.length + " bracelets · " : "") + c + " charm" + (c>1?"s":"") + " · " + money(T.paid) : "No charms yet"));
var kc = window.CS && CS.cfg && CS.cfg.credit, bal = kc && kc.bal > 0 ? kc.bal / 100 : 0;
if ((c && cr) || bal){ var crow = document.createElement("span"); crow.className = "crow";
if (c && cr){ var cb = document.createElement("span"); cb.className = "credit"; cb.innerHTML = SV.coin + "+" + money(cr) + " credit"; cb.title = "Store credit back on this order, for your next one"; crow.appendChild(cb); }
if (bal){ var cw = document.createElement("span"); cw.className = "credit wal"; cw.textContent = money(bal) + " to use"; cw.title = "Store credit in your account, used at checkout"; crow.appendChild(cw); }
$("dockSum").appendChild(crow); }
var nx = nextText(c, T), fb = Math.min(3, Math.floor(c/10));
if (fb > S.br.length && c >= 20) nx = "A " + (S.br.length === 1 ? "2nd" : "3rd") + " bracelet is free. Tap + to add it";
else if (c >= 10 && T.shipNeed) nx += " · " + money(T.shipNeed) + " to free shipping";
$("dockNext").textContent = nx;
$("basePrice").textContent = T.freeN >= S.br.length ? "Free with your charms" : money(BASE_PRICE[B.base]) + " · free at " + Math.min(30, (T.freeN + 1) * 10) + " charms";
}
function removeOne(i, vi){
for (var bi = S.br.length-1; bi >= 0; bi--){
var b = S.br[bi], mid = Math.floor(b.size/2) - 1, best = -1;
b.slots.forEach(function(p, s){ if (p && p.i === i && p.vi === vi && (best < 0 || Math.abs(s-mid) > Math.abs(best-mid))) best = s; });
if (best >= 0){ remember(clearAt(b, best)); return; }
}
}
function renderBag(){
var T = totals(), c = T.c, L = $("bLines"); L.innerHTML = "";
$("bCount").textContent = c ? "(" + c + " charm" + (c>1?"s":"") + (S.br.length > 1 ? ", " + S.br.length + " bracelets" : "") + ")" : "";
$("bMsg").textContent = nextText(c, T) + (T.shipNeed && c ? " · " + money(T.shipNeed) + " to free shipping" : "");
$("bFill").style.width = tierPct(c) + "%";
[5, 10, 20, 30].forEach(function(g){ $("b" + g).className = $("l" + g).className = c >= g ? "got" : ""; });
function el(tag, cls, html){ var e = document.createElement(tag); if (cls) e.className = cls; if (html != null) e.innerHTML = html; return e; }
function line(o){
var d = el("div", "bline" + (o.locked ? " locked" : "")), th = el("span", "th");
if (o.a != null){ var b = el("b"); th.appendChild(b); fit(b, o.a, 64, 0.8); }
else if (o.img){ th.innerHTML = '<img src="' + o.img + '" alt="">'; }
else if (o.icon){ var lb = el("b"); th.appendChild(lb); fit(lb, D.plain.silver, 64, 0.84); th.insertAdjacentHTML("beforeend", o.icon); }
d.appendChild(th);
var nm = el("div", "nm"); nm.appendChild(document.createTextNode(o.name)); if (o.sub){ var sm = el("small"); sm.innerHTML = o.sub; nm.appendChild(sm); }
if (o.qty){
var ctl = el("div", "ctl"), st = el("div", "step"), mi = el("button", "", SV.minus), q = el("span"), pl = el("button", "", SV.plus);
mi.type = pl.type = "button"; mi.setAttribute("aria-label", "One less " + o.name); pl.setAttribute("aria-label", "One more " + o.name); q.textContent = o.qty;
mi.addEventListener("click", function(){ removeOne(o.i, o.vi); update(); renderBag(); });
pl.addEventListener("click", function(){ placeAny(makePiece(o.i, o.vi)); update(); renderBag(); });
st.appendChild(mi); st.appendChild(q); st.appendChild(pl); ctl.appendChild(st);
var rm = el("button", "lnk"); rm.type = "button"; rm.textContent = "Remove"; rm.addEventListener("click", function(){ for (var k=0;k<o.qty;k++) removeOne(o.i, o.vi); update(); renderBag(); });
ctl.appendChild(rm); nm.appendChild(ctl);
}
if (o.actions){ var ct = el("div", "ctl"); o.actions.forEach(function(a){ var bt = el("button", "lnk"); bt.type = "button"; bt.textContent = a[0]; bt.addEventListener("click", a[1]); ct.appendChild(bt); }); nm.appendChild(ct); }
d.appendChild(nm);
var pr = el("div", "pr");
if (o.free != null) pr.innerHTML = '<span class="free">Free</span>' + (o.free ? "<s>" + o.free + "</s>" : ""); else pr.textContent = o.price || "";
d.appendChild(pr);
if (o.row){ var w = el("div", "bwrap"), r = el("div", "row"); r.style.display = "block"; w.appendChild(r); d.appendChild(w); o.row(r); }
L.appendChild(d);
}
var sortedIdx = S.br.map(function(b, i){ return i; }).sort(function(x, y){ return BASE_PRICE[S.br[x].base] - BASE_PRICE[S.br[y].base]; });
var freeSet = {}; sortedIdx.slice(0, T.freeN).forEach(function(i, k){ freeSet[i] = (k + 1) * 10; });
S.br.forEach(function(b, i){
var n = piecesOf(b).length, acts = [["Edit", function(){ setCur(i); closeBag(); renderStage(); renderMeter(); toStage(); }]];
if (S.br.length > 1) acts.push(["Remove bracelet", function(){ removeBracelet(i); renderBag(); }]);
line({a: D.plain[b.base], name: "Bracelet " + (i+1) + " · " + BASE_NAME[b.base], sub: b.size + " links · " + SIZE_LBL[b.size].replace("Wrist ", "") + " · " + n + " charm" + (n===1?"":"s") + (freeSet[i] ? " · <span style='color:#17431F'>unlocked at " + freeSet[i] + " charms</span>" : ""),
free: freeSet[i] ? money(BASE_PRICE[b.base]) : null, price: money(BASE_PRICE[b.base]), actions: acts,
row: function(r){ requestAnimationFrame(function(){ renderRow(r, Math.min(18, (r.parentNode.clientWidth || 340) / b.size), b, {}); }); }});
});
var grouped = {}, order = []; allPieces().forEach(function(p){ var k = p.i + ":" + p.vi; if (!grouped[k]){ grouped[k] = {p:p, n:0}; order.push(k); } grouped[k].n++; });
order.forEach(function(k){ var g = grouped[k], it = D.items[g.p.i]; line({a: g.p.a, name: g.p.vi != null ? designName(g.p.i, g.p.vi) : it.t, sub: g.p.vi != null ? it.t : "", price: money(priceOf(g.p.i, g.p.vi)*g.n), qty: g.n, i: g.p.i, vi: g.p.vi}); });
line({img: T.tool ? (STORE ? CSB.tool : "tool.webp") : null, icon: T.tool ? null : EN.lock, name: "Charm tool", sub: T.tool ? "Free with your bracelet" : "Free with any bracelet", free: T.tool ? money(TOOL_PRICE) : null, price: T.tool ? "" : money(TOOL_PRICE), locked: !T.tool});
if (!T.cotmOff) line({icon: T.cotm ? EN.question : EN.lock, name: "This month's charm", sub: T.cotm ? "Free with 5 charms" : "Free at 5 charms · " + (5-c) + " to go", free: T.cotm ? "" : null, price: "", locked: !T.cotm});
line({icon: T.ship ? EN.lock : EN.truck, name: "Shipping", sub: T.ship ? "Free from " + money(FREE_SHIP) + " · " + money(T.shipNeed) + " to go" : "Free from " + money(FREE_SHIP), free: T.ship ? null : "", price: T.ship ? money(T.ship) : "", locked: !!T.ship});
if (S.br.length < 2) line({a: T.second ? D.plain[B.base] : null, icon: T.second ? null : EN.lock, name: "Second bracelet", sub: T.second ? "Free now, any metal" : "Free at 20 charms · " + (20-c) + " to go", free: T.second ? money(BASE_PRICE[B.base]) : null, price: T.second ? "" : money(BASE_PRICE[B.base]), locked: !T.second,
actions: T.second ? [["Add it", function(){ S.br.push(newBracelet(B.base, B.size)); update(); renderBag(); toast("Bracelet 2 added. It's free"); }]] : null});
line({icon: EN.question, name: "Surprise charm", sub: "We pick one for every order", free: ""});
$("fCharms").textContent = money(T.charms);
$("fBrLbl").textContent = T.nbr > 1 ? T.nbr + " bracelets" : "Bracelet";
$("fBracelet").innerHTML = T.brPaid ? money(T.brPaid) + (T.brFree ? ' <span style="color:var(--green)">(' + T.freeN + ' free)</span>' : "") : '<span style="color:var(--green)">Free</span>';
$("fShip").textContent = T.ship ? money(T.ship) : "Free";
$("bTotal").textContent = money(T.total);
var cr2 = creditFor(T); $("fCreditLn").hidden = !cr2; $("fCredit").textContent = "+" + money(cr2) + " for your next order"; $("fCreditPct").textContent = Math.round(CREDIT_RATE*100) + "%";
}
var E1_GOALS0 = [{g:5, r:"Free charm of the month", l:"This month's charm free"}, {g:10, r:"Free bracelet + tool", l:"Classic bracelet and charm tool free"}, {g:(window.CSB && CSB.photo && CSB.photo.need) || 15, ph:1, r:"Free photo charm", l:"A photo charm with your photo or words, free"}, {g:20, r:"Free 2nd bracelet", l:"A second bracelet free"}, {g:30, r:"Free 3rd bracelet", l:"A third bracelet free"}];
var E1_GOALS = E1_GOALS0.filter(function(G){ return !G.ph || (window.CSB && CSB.photo && CSB.photo.gift); });
var e1Prev = null, e1ListOpen = false;
var E1_CHEV = '<svg class="ic" viewBox="0 0 24 24" aria-hidden="true"><path d="M6 9l6 6 6-6"/></svg>';
function e1El(tag, cls, txt){ var e = document.createElement(tag); if (cls) e.className = cls; if (txt != null) e.textContent = txt; return e; }
function e1BuildCards(){
var box = $("e1Cards"); if (!box) return null;
if (box.children.length === E1_GOALS.length) return box;
box.innerHTML = "";
E1_GOALS.forEach(function(G){
var b = e1El("button", "e1-card" + (G.ph ? " ph" : "")); b.type = "button";
var hd = e1El("span", "e1-hd"); hd.appendChild(e1El("b", "", String(G.g))); hd.appendChild(e1El("span", "micro", "charms")); b.appendChild(hd);
b.appendChild(e1El("span", "e1-rw", G.r));
var st = e1El("span", "e1-st"), sl = e1El("span", "e1-sl"), bar = e1El("span", "e1-bar"); bar.hidden = true; bar.appendChild(e1El("i")); st.appendChild(sl); st.appendChild(bar); b.appendChild(st);
b.addEventListener("click", function(){ if (G.ph && b.classList.contains("got") && !phOnBr()){ phOpen(null); return; } e1OpenSheet(); });
box.appendChild(b);
});
return box;
}
function e1Cards(){
var box = e1BuildCards(); if (!box) return;
var c = charmCount(), now = [], fresh = [];
E1_GOALS.forEach(function(G, k){
var b = box.children[k]; if (!b) return;
var cc = G.ph ? e1Base() : c, prevG = k ? E1_GOALS[k-1].g : 0, got = cc >= G.g, next = !got && c >= prevG, left = G.g - cc;
var sl = b.querySelector(".e1-sl"), bar = b.querySelector(".e1-bar"), html = got ? SV.tick + (G.ph && !phOnBr() ? "Make yours" : "Unlocked") : left + " more";
now.push(got);
b.classList.toggle("got", got); b.classList.toggle("nx", next); b.classList.toggle("lt", !got && !next);
if (sl && sl._h !== html){ sl._h = html; sl.innerHTML = html; }
if (bar){ bar.hidden = !next; if (next && bar.firstChild) bar.firstChild.style.width = Math.max(0, Math.min(100, (cc - prevG) / (G.g - prevG) * 100)).toFixed(1) + "%"; }
b.setAttribute("aria-label", G.g + " charms: " + G.l + ". " + (got ? "Reached" : left + " more to go"));
if (got && e1Prev && !e1Prev[k] && !REDUCED) fresh.push(b);
});
e1Prev = D ? now : null;
e1Scroll(box);
fresh.forEach(function(b){ b.classList.remove("e1-new"); void b.offsetWidth; b.classList.add("e1-new"); setTimeout(function(){ b.classList.remove("e1-new"); }, 600); });
}
function e1Edges(box){ var m = box.scrollWidth - box.clientWidth; box.classList.toggle("ml", box.scrollLeft > 2); box.classList.toggle("mr", m > 2 && box.scrollLeft < m - 2); }
function e1Scroll(box){
if (!box._e1){ box._e1 = 1; box.addEventListener("scroll", function(){ e1Edges(box); }, {passive: true}); window.addEventListener("resize", function(){ box._nx = null; e1Scroll(box); }); }
var cards = box.children, nx = -1;
for (var i = 0; i < cards.length; i++) if (!cards[i].classList.contains("got")){ nx = i; break; }
if (nx < 0) nx = cards.length - 1;
if (box._nx !== nx && box.scrollWidth > box.clientWidth + 2 && cards[nx]){
var t = cards[Math.max(0, nx - 1)], pad = parseFloat(getComputedStyle(box).paddingLeft) || 0;
var left = box.scrollLeft + t.getBoundingClientRect().left - box.getBoundingClientRect().left - pad;
var end = cards[nx].getBoundingClientRect().right - box.getBoundingClientRect().right + box.scrollLeft + pad;
left = Math.max(0, Math.min(left, box.scrollWidth - box.clientWidth), end > left ? end : 0);
try { box.scrollTo({left: left, behavior: box._nx == null || REDUCED ? "auto" : "smooth"}); } catch(x){ box.scrollLeft = left; }
}
box._nx = nx; e1Edges(box);
}
function e1Line(body, o){
var d = e1El("div", "e1-ln" + (o.off ? " off" : "")), th = e1El("span", "e1-th"); th.setAttribute("aria-hidden", "true");
if (o.a != null && D){ var bb = e1El("b"); th.appendChild(bb); try { fit(bb, o.a, 44, o.pad || 0.8); } catch(e){} }
else if (o.svg) th.innerHTML = o.svg;
else if (o.img){ var im = document.createElement("img"); im.src = o.img; im.alt = ""; im.loading = "lazy"; th.appendChild(im); }
d.appendChild(th);
var nm = e1El("div", "e1-nm", o.name);
if (o.sub){ var sm = e1El("small", "", o.sub); if (o.check){ sm.insertAdjacentHTML("afterbegin", SV.tick); if (sm.firstChild && sm.firstChild.setAttribute) sm.firstChild.setAttribute("aria-hidden", "true"); } nm.appendChild(sm); }
if (o.bar != null){ var gb = e1El("span", "e1-bar e1-gb"), gi = e1El("i"); gb.setAttribute("aria-hidden", "true"); gi.style.width = Math.max(0, Math.min(100, o.bar)).toFixed(1) + "%"; gb.appendChild(gi); nm.appendChild(gb); }
d.appendChild(nm);
var pr = e1El("div", "e1-pr" + (o.free || o.lock ? " fr" : ""));
if (o.free){ if (o.was){ var s = e1El("s"); s.appendChild(e1El("span", "sr", "Was ")); s.appendChild(document.createTextNode(o.was)); pr.appendChild(s); } pr.appendChild(e1El("span", "e1-fr e1-pill", "Free")); }
else if (o.lock){ if (o.was) pr.appendChild(e1El("span", "e1-worth", "Worth " + o.was)); }
else if (o.price) pr.textContent = o.price;
d.appendChild(pr);
body.appendChild(d);
return d;
}
function e1Sheet(){
var body = $("e1Body"); if (!body) return;
var T = totals(), c = T.c, isStore = !!window.CSB, foc = !!(document.activeElement && document.activeElement.id === "e1Tg");
body.innerHTML = "";
var pcs = allPieces();
if (!c || !pcs.length){ e1Line(body, {a: D ? D.plain[B.base] : null, pad: 0.84, name: "No charms yet", off: true}); }
else {
var ln = e1Line(body, {a: pcs[0].a, name: "Charms × " + c, price: money(T.charms)});
var tg = e1El("button", "e1-tg", e1ListOpen ? "Hide list" : "See list"); tg.type = "button"; tg.id = "e1Tg"; tg.setAttribute("aria-expanded", e1ListOpen ? "true" : "false"); tg.insertAdjacentHTML("beforeend", E1_CHEV);
ln.querySelector(".e1-nm").appendChild(tg);
var rb = e1El("div", "e1-rowbox"), r = e1El("div", "row"); r.style.display = "block"; rb.appendChild(r); ln.appendChild(rb);
requestAnimationFrame(function(){ try { if (D && document.body.contains(r)) renderRow(r, Math.min(16, (rb.clientWidth || 300) / B.size), B, {}); } catch(e){} });
if (e1ListOpen){
var ul = e1El("ul", "e1-list"), gp = {}, ord = []; ul.id = "e1List"; tg.setAttribute("aria-controls", "e1List");
pcs.forEach(function(p){ var k = p.i + ":" + p.vi; if (!gp[k]){ gp[k] = {p:p, n:0}; ord.push(k); } gp[k].n++; });
ord.forEach(function(k){ var g = gp[k], li = e1El("li"); li.appendChild(e1El("span", "", designName(g.p.i, g.p.vi) + (g.n > 1 ? " × " + g.n : ""))); li.appendChild(e1El("span", "", money(priceOf(g.p.i, g.p.vi) * g.n))); ul.appendChild(li); });
ln.appendChild(ul);
}
}
var order = S.br.map(function(b, i){ return i; }).sort(function(x, y){ return BASE_PRICE[S.br[x].base] - BASE_PRICE[S.br[y].base]; }), rank = {};
order.forEach(function(i, k){ rank[i] = k; });
S.br.forEach(function(b, i){
var k = rank[i], free = k < T.freeN, at = (k + 1) * 10, pr = money(BASE_PRICE[b.base]);
var sub = (S.br.length > 1 ? "Bracelet " + (i+1) + " · " : "") + b.size + " links";
if (!free && k < 3) sub += " · Free at " + at + " charms" + (isStore ? " · " + Math.max(0, at - c) + " to go" : "");
e1Line(body, {a: D ? D.plain[b.base] : null, pad: 0.84, name: "Classic bracelet · " + BASE_NAME[b.base], sub: sub, free: free, was: free ? pr : null, price: free || isStore ? "" : pr, off: !free && isStore});
});
var gx = e1El("div", "e1-gbox"), ghd = e1El("p", "e1-ghd", "Free with your order");
ghd.id = "e1GHd"; gx.setAttribute("role", "group"); gx.setAttribute("aria-labelledby", "e1GHd"); gx.appendChild(ghd); body.appendChild(gx);
var lx = e1El("div", "e1-gbox lock"), lhd = e1El("p", "e1-ghd", "Unlock next");
lhd.id = "e1LHd"; lx.setAttribute("role", "group"); lx.setAttribute("aria-labelledby", "e1LHd"); lx.appendChild(lhd);
var ccfg = window.CS && window.CS.cfg && window.CS.cfg.cotm, cImg = ccfg && ccfg.image ? String(ccfg.image) : null, cVal = money(ccfg && ccfg.value ? ccfg.value / 100 : 4.49), cLeft = Math.max(0, 5 - c);
e1Line(T.tool ? gx : lx, {svg: SV.tool, name: "Charm tool", sub: T.tool ? (isStore ? "Added to your bag" : "Comes with your bracelet") : "Add a bracelet", check: T.tool, free: T.tool, lock: !T.tool, was: money(TOOL_PRICE)});
if (!T.cotmOff) e1Line(T.cotm ? gx : lx, {img: cImg, svg: cImg ? null : SV.gift, name: "This month's charm", sub: T.cotm ? (isStore ? "Added to your bag" : "Added in the bag, no code needed") : "Add " + cLeft + " more charm" + (cLeft === 1 ? "" : "s"), check: T.cotm, bar: T.cotm ? null : c / 5 * 100, free: T.cotm, lock: !T.cotm, was: cVal});
e1Line(gx, {svg: SV.gift, name: "Surprise charm", sub: "We pick one for every order", free: true});
if (STORE) phSheetLine(gx, lx);
if (lx.children.length > 1) body.appendChild(lx);
var shipWas = 0;
if (!T.ship && c){ shipWas = shipFee(T.paid); e1Line(body, {svg: SV.truck, name: "Shipping", sub: "Free on this order", check: true, free: true, was: money(shipWas)}); }
else if (T.ship) e1Line(body, {svg: SV.truck, name: "Shipping", sub: "Add " + money(T.shipNeed) + " more for free shipping", bar: (1 - T.shipNeed / FREE_SHIP) * 100, price: money(T.ship)});
else e1Line(body, {svg: SV.truck, name: "Shipping", sub: "Free from " + money(FREE_SHIP), free: true});
var save = Math.round(((T.freeN ? T.brFree : 0) + (T.tool ? TOOL_PRICE : 0) + shipWas) * 100) / 100;
if (save > 0.004){ var sv = e1El("div", "e1-save"); sv.innerHTML = SV.tick; sv.appendChild(e1El("span", "", "You save")); sv.appendChild(e1El("b", "", money(save))); body.appendChild(sv); }
var rt = null; try { if (typeof window.CSB_TOTAL === "function") rt = window.CSB_TOTAL(); } catch(e){ rt = null; }
var tot = (typeof rt === "number" && isFinite(rt)) ? rt + T.ship : T.total, te = $("e1Total");
if (te) te.textContent = money(tot);
var ec = $("e1Cred"), ecr = creditFor({paid: (typeof rt === "number" && isFinite(rt)) ? rt : T.paid});
if (ec){ ec.hidden = !(c && ecr); if (c && ecr) ec.innerHTML = SV.coin + '<span>Store credit back <i>' + Math.round(CREDIT_RATE * 1000) / 10 + '%</i></span><b>+' + money(ecr) + ' for next time</b>'; }
if (foc && $("e1Tg")) $("e1Tg").focus({preventScroll:true});
}
function e1OpenSheet(){
var sc = $("e1Scrim"); if (!sc) return;
if (!sc.hidden && sc.classList.contains("on")) return;
openSheet("e1Scrim");
try { e1Sheet(); } catch(e){}
}
var e2L = {sig: null, looks: [], drawn: ""}, e2D = null, e2LP = null, e2Fired = false, e2Swallow = 0;
function e2Pick(d){
var seen = {}, out = [], n = d ? d.length : 0;
for (var k = 0; k < n && out.length < 5; k++){
var r = d[k]; if (!r) continue;
var i = r[0], it = D.items[i]; if (!it || seen[i]) continue;
var vi = null;
if (it.vv && it.vv.length) vi = (r[1] >= 0 && it.vv[r[1]]) ? r[1] : 0;
try { if (!E(aOf(i, vi))) continue; } catch(e){ continue; }
seen[i] = 1; out.push([i, vi]);
}
return out;
}
function e2LookData(){
var src = [], out = [];
if (D.edit && D.edit.d) src.push({t: D.edit.t, tag: "This week", d: D.edit.d});
(D.gifts || []).forEach(function(g){ if (g && g.d) src.push({t: g.l, tag: "", d: g.d}); });
for (var k = 0; k < src.length && out.length < 6; k++){
var p = e2Pick(src[k].d); if (p.length < 5) continue;
var sum = 0; p.forEach(function(x){ sum += priceOf(x[0], x[1]); });
out.push({t: src[k].t, tag: src[k].tag, p: p, sum: sum, row: null});
}
return out;
}
function e2BuildLooks(){
var list = $("e2LookList"); if (!list) return; list.innerHTML = "";
e2L.looks.forEach(function(L){
var card = document.createElement("div"); card.className = "e2-look";
var hd = document.createElement("div"); hd.className = "e2-lkh";
var tw = document.createElement("div"), h = document.createElement("h3"); h.textContent = L.t; tw.appendChild(h);
var m = document.createElement("span"); m.className = "e2-lkm"; m.textContent = L.p.length + " charms · " + money(L.sum); tw.appendChild(m); hd.appendChild(tw);
if (L.tag){ var tg = document.createElement("span"); tg.className = "e2-tag"; tg.textContent = L.tag; hd.appendChild(tg); }
card.appendChild(hd);
var pic = document.createElement("div"); pic.className = "e2-lkp"; pic.setAttribute("aria-hidden", "true");
var row = document.createElement("div"); row.className = "row"; pic.appendChild(row); card.appendChild(pic); L.row = row;
var b = document.createElement("button"); b.type = "button"; b.className = "btn ghost wide"; b.textContent = "Start with this";
b.setAttribute("aria-label", "Start with the " + L.t + " look, " + L.p.length + " charms");
b.addEventListener("click", function(){ e2Start(L, 0); });
card.appendChild(b); list.appendChild(card);
});
}
function e2DrawLooks(){
var L0 = e2L.looks[0]; if (!L0 || !L0.row || !L0.row.parentNode) return;
var w = L0.row.parentNode.clientWidth - 16; if (w < 40) return;
var key = B.base + ":" + B.size + ":" + Math.round(w); if (key === e2L.drawn) return; e2L.drawn = key;
var W = Math.min(22, w / B.size);
e2L.looks.forEach(function(L){ try { var t = newBracelet(B.base, B.size); L.p.forEach(function(x){ placeIn(t, makePiece(x[0], x[1])); }); renderRow(L.row, W, t, {}); } catch(e){} });
}
function e2RenderLooks(){
var box = $("e2Looks"); if (!box || !D || !B) return;
var show = charmCount() === 0;
if (show){
var sig = (D.edit ? D.edit.t + ":" + (D.edit.d ? D.edit.d.length : 0) : "") + "|" + (D.gifts ? D.gifts.length : 0);
if (sig !== e2L.sig){ var lk = e2LookData(); e2L.sig = sig; e2L.looks = lk; e2L.drawn = ""; e2BuildLooks(); }
show = e2L.looks.length > 0;
}
box.hidden = !show;
if (show) e2DrawLooks();
}
function e2Start(L, tries){
if (window.CSB && !window.CSB_READY){
toast("One moment", {busy: true});
if (tries < 20) setTimeout(function(){ e2Start(L, tries + 1); }, 600); else toast("Your bag is still loading. Try again in a moment");
return;
}
var snap = snapshot(), n = 0; S.sel = -1;
L.p.forEach(function(x){ try { if (placeIn(B, makePiece(x[0], x[1])) >= 0) n++; } catch(e){} });
if (!n){ toast("This bracelet is full. Take a charm off first"); return; }
update(); stageIn(0); toStage();
toast("Added " + n + " charm" + (n === 1 ? "" : "s") + ". Swap any of them.", {label: "Undo", fn: function(){ restore(snap); update(); }});
}
function e2Names(){
var g = $("grid"); if (!g) return;
Array.prototype.forEach.call(g.querySelectorAll(".card .n"), function(n){ n.setAttribute("role", "button"); n.setAttribute("tabindex", "0"); n.setAttribute("aria-haspopup", "dialog"); });
}
function e2HRef(){ return {i: e2D.i, vi: e2D.picked ? e2D.vi : e2D.cvi}; }
function e2HeartSync(){
var r = e2HRef(), on = !!S.hearts[heartKey(r)], h = $("e2Heart");
h.setAttribute("aria-pressed", on); h.setAttribute("aria-label", (on ? "Remove " : "Save ") + designName(r.i, r.vi));
}
function e2HeartTap(){
if (!e2D || !D) return;
var r = e2HRef(), h = $("e2Heart");
toggleHeart(heartKey(r), designName(r.i, r.vi)); e2HeartSync();
h.classList.remove("beat"); void h.offsetWidth; h.classList.add("beat");
try { renderGrid(); } catch(e){}
}
function e2NoteText(){
var c = charmCount() + 1;
if (c > 30) return "";
if (c === 5) return "This one makes 5. This month's charm is free.";
if (c === 10) return "This one makes 10. The bracelet and charm tool are free.";
if (c === 20 || c === 30) return "This one makes " + c + ". Another bracelet is free.";
return "After this one, " + nextText(c);
}
function e2BuildSw(){
var w = $("e2Sws"), it = D.items[e2D.i]; w.innerHTML = "";
if (!(it.vv && it.vv.length > 1)) return;
it.vv.forEach(function(v, k){
if (ZV[e2D.i + ":" + k] && k !== e2D.vi) return;
var b = document.createElement("button"); b.type = "button"; b.className = "e2-sw"; b.setAttribute("aria-pressed", k === e2D.vi); b.setAttribute("aria-label", designName(e2D.i, k));
var art = document.createElement("b"); b.appendChild(art);
try { fit(art, v[3], 48, 0.86); } catch(e){}
b.addEventListener("click", function(){ if (!e2D) return; e2D.vi = k; e2D.picked = true; e2Fill(); });
w.appendChild(b);
});
}
function e2Fill(){
if (!e2D || !D) return;
var i = e2D.i, vi = e2D.vi, it = D.items[i], nm = designName(i, vi), box = $("e2Big");
$("e2Name").textContent = nm;
$("e2Price").textContent = money(priceOf(i, vi));
try { fit($("e2Art"), aOf(i, vi), (box && box.clientWidth) || 132, 0.86); if (box) imgFade($("e2Art"), box); } catch(e){}
var multi = !!(it.vv && it.vv.length > 1); $("e2Des").hidden = !multi;
if (multi){ $("e2DName").textContent = nm; Array.prototype.forEach.call($("e2Sws").children, function(b, k){ b.setAttribute("aria-pressed", k === vi); }); }
$("e2Add").setAttribute("aria-label", "Add " + nm + " to the bracelet");
e2HeartSync();
var nt = e2NoteText(), no = $("e2Note"); no.textContent = nt; no.hidden = !nt;
}
function e2Open(i, cvi){
if (!D || !D.items[i] || !$("e2Scrim")) return;
var it = D.items[i], vi = cvi;
if (vi == null && it.vv && it.vv.length) vi = 0;
if (vi != null && !(it.vv && it.vv[vi])) vi = null;
e2D = {i: i, vi: vi, cvi: cvi, picked: false};
e2BuildSw();
openSheet("e2Scrim");
e2Fill();
var sw = $("e2Sws"), on = sw.querySelector('[aria-pressed="true"]'); sw.scrollLeft = on ? Math.max(0, on.offsetLeft - 60) : 0;
}
function e2OpenCard(card){
if (!D || !card) return;
var ia = card.getAttribute("data-i"), va = card.getAttribute("data-vi"); if (ia == null) return;
var i = +ia; if (isNaN(i)) return;
e2Open(i, va == null ? null : +va);
}
function e2CardArt(){
if (!e2D) return null;
var g = $("grid"); if (!g) return null;
var c = g.querySelector('.card[data-i="' + e2D.i + '"]' + (e2D.cvi != null ? '[data-vi="' + e2D.cvi + '"]' : ':not([data-vi])'));
return c ? c.querySelector(".art") : null;
}
function e2Place(i, vi, art, tries){
if (window.CSB && !window.CSB_READY){
toast("One moment", {busy: true});
if (tries < 20) setTimeout(function(){ e2Place(i, vi, art, tries + 1); }, 600); else toast("Your bag is still loading. Try again in a moment");
return;
}
if (tries) hideToast();
addPiece(makePiece(i, vi), art && document.body.contains(art) ? art : null);
}
function e2AddNow(){
if (!e2D || !D) return;
var i = e2D.i, vi = e2D.vi, art = e2CardArt();
closeSheet("e2Scrim");
e2Place(i, vi, art, 0);
}
var E3I = {
expand:'<svg class="ic" viewBox="0 0 24 24"><path d="M14 4.5h5.5V10M10 19.5H4.5V14M19.5 4.5l-6 6M4.5 19.5l6-6"/></svg>',
bookmark:'<svg class="ic" viewBox="0 0 24 24"><path d="M7 4h10v16l-5-3.8L7 20z"/></svg>',
link:'<svg class="ic" viewBox="0 0 24 24"><path d="M10.5 13.5a3.5 3.5 0 0 0 5 0l3-3a3.5 3.5 0 0 0-5-5l-1.2 1.2"/><path d="M13.5 10.5a3.5 3.5 0 0 0-5 0l-3 3a3.5 3.5 0 0 0 5 5l1.2-1.2"/></svg>'
};
var e3Mode = "own", e3Shared = null, e3From = "", e3Zoom = "whole", e3UseT = null, e3UseN = 0, e3LooksN = 0, e3LinkDone = false, e3RT = null;
var E3_LETTER = {silver:"s", gold:"g", rose:"r", black:"b"}, E3_BASE = {s:"silver", g:"gold", r:"rose", b:"black"};
function e3Has(o, k){ return o != null && Object.prototype.hasOwnProperty.call(o, k); }
function e3IsOpen(){ var s = $("e3Scrim"); return !!s && !s.hidden && !timers.e3Scrim; }
function e3B(){ return e3Mode === "shared" ? e3Shared : B; }
function e3Plural(n, w){ return n + " " + w + (n === 1 ? "" : "s"); }
function e3Looks(){
try {
var a = JSON.parse(store("csb_looks") || "[]"); if (!Array.isArray(a)) return [];
return a.filter(function(x){ return x && e3Has(BASE_NAME, x.base) && e3Has(SIZE_LBL, x.size) && Array.isArray(x.p) && x.p.length; }).slice(0, 12);
} catch(e){ return []; }
}
function e3Write(a){ var r = store("csb_looks", JSON.stringify(a.slice(0, 12))); e3LooksN = Math.min(12, a.length); return r !== null; }
function e3Design(b){ var p = []; b.slots.forEach(function(pc, s){ if (pc && b.own[s] === s && !D.items[pc.i].ph) p.push([s, D.items[pc.i].h, pc.vi == null ? null : pc.vi]); }); return {at: Date.now(), base: b.base, size: b.size, p: p}; }
function e3Sig(d){ return d.base + "|" + d.size + "|" + JSON.stringify(d.p); }
function e3Code(b){ var out = [E3_LETTER[b.base] + b.size]; e3Design(b).p.forEach(function(x){ out.push(x[0] + "-" + x[1] + (x[2] != null ? "~" + x[2] : "")); }); return out.join("."); }
function e3Build(base, size, ents){
size = +size;
if (!D || !e3Has(BASE_NAME, base) || !e3Has(SIZE_LBL, size) || !Array.isArray(ents) || !ents.length) return null;
var b = newBracelet(base, size), n = 0;
ents.filter(function(x){ return Array.isArray(x); }).slice(0, 22).sort(function(x, y){ return (+x[0]) - (+y[0]); }).forEach(function(x){
try {
var s = +x[0], h = String(x[1] == null ? "" : x[1]), vi = x[2] == null ? null : +x[2];
if (!(s >= 0 && s < size) || Math.floor(s) !== s || !e3Has(HIDX, h)) return;
var i = HIDX[h], it = D.items[i]; if (!it) return;
if (it.vv && it.vv.length){ if (vi == null){ if (it.vv.length !== 1) return; vi = 0; } else if (Math.floor(vi) !== vi || !it.vv[vi]) return; }
else vi = null;
if (it.z || (vi != null && ZV[i + ":" + vi])) return;
var p = makePiece(i, vi);
if (window.CSB && typeof vidOf === "function" && vidOf(p) == null) return;
if (canPlace(b, p, s)) setAt(b, p, s); else if (placeIn(b, p) < 0) return;
n++;
} catch(e){}
});
return n ? b : null;
}
function e3Parse(code){
try {
var parts = String(code || "").slice(0, 4000).split("."), mm = /^([sgrb])(\d{2})$/.exec(parts.shift() || "");
if (!mm) return null;
var ents = [];
parts.forEach(function(x){
if (ents.length >= 22) return;
var d = x.indexOf("-"); if (d < 1) return;
var sl = x.slice(0, d), rest = x.slice(d + 1), t = rest.indexOf("~"), h = t >= 0 ? rest.slice(0, t) : rest, v = t >= 0 ? rest.slice(t + 1) : null;
if (!/^\d{1,2}$/.test(sl) || !/^[a-z0-9][a-z0-9_-]*$/i.test(h)) return;
if (v != null && !/^\d{1,3}$/.test(v)) return;
ents.push([+sl, h, v == null ? null : +v]);
});
return e3Build(E3_BASE[mm[1]], +mm[2], ents);
} catch(e){ return null; }
}
function e3PvSync(){
var row = $("e3Pv"), pb = $("e3PvBtn"), sb = $("e3SvBtn"), qs = $("e3QsBtn"); if (!row || !pb || !sb) return;
var has = !!(D && B && piecesOf(B).length), n = e3LooksN;
pb.hidden = !has; sb.hidden = has || !n;
if (qs){ qs.hidden = !has; e3SaveState(qs); }
if (!has && n) $("e3SvT").textContent = "Saved designs (" + n + ")";
row.hidden = S.sel >= 0 || (!has && !n);
}
function e3SegSync(){ Array.prototype.forEach.call(document.querySelectorAll("[data-e3z]"), function(x){ x.setAttribute("aria-pressed", x.getAttribute("data-e3z") === e3Zoom); }); }
function e3Pic(first){
var b = e3B(), sc = $("e3Scroll"), row = $("e3Row"); if (!D || !b || !sc || !row || e3Mode === "list") return;
var closer = e3Zoom === "closer";
sc.classList.toggle("e3-closer", closer); sc.tabIndex = closer ? 0 : -1;
var cw = sc.clientWidth || 320, W = closer ? 64 : Math.max(8, Math.min(48, (cw - 24) / b.size));
renderRow(row, W, b, {});
var m = closer ? Math.max(12, (cw - W) / 2) : 0;
row.style.marginLeft = closer ? m + "px" : ""; row.style.marginRight = closer ? m + "px" : "";
if (closer){ for (var c=0;c<b.size;c++){ var sn = document.createElement("i"); sn.className = "e3-snap"; sn.style.left = (c*W) + "px"; sn.style.width = W + "px"; row.appendChild(sn); } }
var sw = $("e3Swipe"); if (sw) sw.hidden = !closer;
if (first){ var s0 = 0; for (var k=0;k<b.size;k++){ if (b.slots[k]){ s0 = k; break; } } sc.scrollLeft = closer ? s0 * W : 0; }
}
function e3Sum(){
var box = $("e3Sum"), b = e3B(); if (!box || !D || !b || e3Mode === "list") return;
box.innerHTML = "";
function ln(l, r, cls, free){ var d = document.createElement("div"); d.className = "e3-ln" + (cls ? " " + cls : ""); var a = document.createElement("span"), z = document.createElement("span"); a.textContent = l; z.textContent = r; if (free) z.className = "e3-free"; d.appendChild(a); d.appendChild(z); box.appendChild(d); }
var cap = document.createElement("span"); cap.className = "micro";
cap.textContent = e3Mode === "shared" ? "This bracelet" : (S.br.length > 1 ? "Your order, all " + S.br.length + " bracelets" : "Your order"); box.appendChild(cap);
if (e3Mode === "shared"){
var sum = 0, n = 0; piecesOf(b).forEach(function(p){ sum += priceOf(p.i, p.vi); n++; });
ln(e3Plural(n, "charm"), money(sum), "e3-tot");
var nt = document.createElement("p"); nt.className = "e3-note"; nt.textContent = "Rewards happen in the bag, no code needed. At 10 charms the bracelet and the charm tool are free."; box.appendChild(nt);
return;
}
var T = totals(), bl = T.freeN > 1 ? T.freeN + " bracelets + charm tool" : "Classic bracelet + charm tool";
ln(e3Plural(T.c, "charm"), money(T.charms));
if (T.freeN >= 1){ ln(bl, "Free", "", true); if (T.brPaid > 0) ln(T.nbr - T.freeN > 1 ? "Other bracelets" : "Other bracelet", money(T.brPaid)); }
else if (T.brPaid > 0) ln(bl, money(T.brPaid));
else ln(bl, "Free at 10 charms");
if (T.cotm) ln("This month's charm", "Free", "", true);
ln("Shipping", T.ship ? money(T.ship) : "Free", "", !T.ship);
var bt = null; try { bt = typeof window.CSB_TOTAL === "function" ? window.CSB_TOTAL() : null; } catch(e){ bt = null; }
var tot = (bt != null && isFinite(bt) ? bt : T.paid) + T.ship;
ln("Total", money(tot), "e3-tot");
var go = $("e3Go"); if (go) go.textContent = "Go to bag · " + money(tot);
}
function e3Render(){
if (!D) return;
var list = e3Mode === "list", shared = e3Mode === "shared", foot = $("e3Foot");
$("e3Title").textContent = list ? "Saved designs" : shared ? "Shared bracelet" : "Preview";
$("e3BackT").textContent = e3Mode === "own" ? "Edit" : "Back";
$("e3View").hidden = list; $("e3List").hidden = !list; $("e3Copy").hidden = true;
foot.innerHTML = ""; foot.hidden = list;
if (list){ e3RenderList(); return; }
var b = e3B(); if (!b) return;
e3SegSync(); e3Pic(true);
var n = piecesOf(b).length, plain = 0; b.own.forEach(function(o){ if (o < 0) plain++; });
var wh = $("e3Which"); wh.hidden = shared || S.br.length < 2; wh.textContent = "Bracelet " + (S.cur+1) + " of " + S.br.length;
$("e3Name").textContent = BASE_NAME[b.base] + " bracelet";
$("e3Facts").textContent = e3Plural(n, "charm") + ", " + e3Plural(plain, "plain link") + " · " + b.size + " links, " + SIZE_LBL[b.size].replace(/^Wrist /, "wrist ").replace(/\s*\(.*\)\s*$/, "");
$("e3Row").setAttribute("aria-label", BASE_NAME[b.base] + " bracelet with " + e3Plural(n, "charm"));
function btn(cls, html, fn, id){ var x = document.createElement("button"); x.type = "button"; x.className = cls; x.innerHTML = html; if (id) x.id = id; x.addEventListener("click", fn); return x; }
if (shared){
foot.appendChild(btn("btn wide", "Use this design", e3UseClick, "e3UseBtn"));
foot.appendChild(btn("btn ghost wide", "Not now", e3Close));
} else {
var two = document.createElement("div"); two.className = "e3-two";
var sv = btn("btn ghost", E3I.bookmark + "<span>Save</span>", e3Save, "e3SaveBtn");
two.appendChild(sv);
e3SaveState(sv);
two.appendChild(btn("btn ghost", E3I.link + "<span>Share link</span>", e3Share));
foot.appendChild(two);
foot.appendChild(btn("btn wide", "Go to bag", e3GoBag, "e3Go"));
}
e3Sum();
}
function e3RenderList(){
var box = $("e3List"), looks = e3Looks(); if (!box) return; box.innerHTML = ""; e3LooksN = looks.length;
if (!looks.length){ var em = document.createElement("p"); em.className = "e3-empty"; em.textContent = "No saved designs yet. Open Preview on a bracelet and tap Save."; box.appendChild(em); return; }
var nt = document.createElement("p"); nt.className = "e3-lnote"; nt.textContent = "Saved on this device. Open one to look closer or use it."; box.appendChild(nt);
var wrap = document.createElement("div"); wrap.className = "e3-cards"; box.appendChild(wrap);
looks.forEach(function(d){
var b = null; try { b = e3Build(d.base, d.size, d.p); } catch(e){ b = null; }
var card = document.createElement("div"); card.className = "e3-card";
var pic = document.createElement("div"); pic.className = "e3-cpic"; var row = document.createElement("div"); row.className = "row"; pic.appendChild(row); card.appendChild(pic);
var info = document.createElement("div"); info.className = "e3-cinfo";
var tx = document.createElement("div"), t1 = document.createElement("b"), t2 = document.createElement("small");
t1.textContent = BASE_NAME[d.base] + " · " + (b ? e3Plural(piecesOf(b).length, "charm") : "no charms we still carry");
var dt = ""; try { var dd = new Date(d.at); if (d.at && !isNaN(dd.getTime())) dt = dd.toLocaleDateString(); } catch(e){ dt = ""; }
t2.textContent = dt ? "Saved " + dt : "Saved on this device";
tx.appendChild(t1); tx.appendChild(t2); info.appendChild(tx);
if (b){ var op = document.createElement("button"); op.type = "button"; op.className = "rbtn"; op.textContent = "Open"; op.setAttribute("aria-label", "Open " + t1.textContent + (dt ? ", saved " + dt : "")); op.addEventListener("click", function(){ e3OpenSaved(b); }); info.appendChild(op); }
var del = document.createElement("button"); del.type = "button"; del.className = "rbtn e3-del"; del.textContent = "Delete"; del.setAttribute("aria-label", "Delete " + t1.textContent + (dt ? ", saved " + dt : ""));
del.addEventListener("click", function(){ e3Del(d); }); info.appendChild(del);
card.appendChild(info); wrap.appendChild(card);
if (b){ try { var w = (pic.clientWidth || 320) - 20; renderRow(row, Math.max(6, Math.min(18, w / b.size)), b, {}); } catch(e){} }
});
}
function e3Del(d){
var all = e3Looks(), k = -1, sig = e3Sig(d);
for (var j=0;j<all.length;j++){ if (all[j].at === d.at && e3Sig(all[j]) === sig){ k = j; break; } }
if (k < 0) return;
var gone = all.splice(k, 1)[0]; e3Write(all); e3Render(); e3PvSync();
var bk = $("e3Back"); if (bk) bk.focus({preventScroll:true});
toast("Design deleted", {label:"Undo", fn:function(){ var a = e3Looks(); a.splice(Math.min(k, a.length), 0, gone); e3Write(a); if (e3IsOpen() && e3Mode === "list") e3Render(); e3PvSync(); }});
}
function e3SaveState(bt){
try {
bt = bt || document.getElementById("e3SaveBtn");
if (!bt) return;
var on = false;
if (D && B && piecesOf(B).length){
var sig = e3Sig(e3Design(B)), all = e3Looks();
for (var k=0;k<all.length;k++){ if (e3Sig(all[k]) === sig){ on = true; break; } }
}
if (on) bt.classList.add("on"); else bt.classList.remove("on");
bt.setAttribute("aria-pressed", on ? "true" : "false");
var s = bt.querySelector("span");
if (s) s.textContent = on ? "Saved" : "Save";
} catch(e){}
}
function e3Save(){
try {
if (!D || !B || !piecesOf(B).length){ toast("Add a charm first"); return; }
var d = e3Design(B), sig = e3Sig(d), all = e3Looks();
for (var k=0;k<all.length;k++){ if (e3Sig(all[k]) === sig){ e3SaveState(); toast("Already saved on this device.", {label:"View", fn:e3OpenList}); return; } }
all.unshift(d);
if (!e3Write(all)){ toast("This browser won't let us save here"); return; }
e3PvSync();
e3SaveState();
toast("Saved on this device.", {label:"View", fn:e3OpenList});
} catch(e){ toast("That didn't save. Try again"); }
}
function e3ShowLink(url){
var box = $("e3Copy"), inp = $("e3Link"); if (!box || !inp) return;
box.hidden = false; inp.value = url;
try { inp.focus(); inp.select(); inp.setSelectionRange(0, url.length); } catch(e){}
}
function e3Share(){
var b = e3B();
if (!D || !b || !piecesOf(b).length){ toast("Add a charm first"); return; }
var n = piecesOf(b).length, url = location.origin + location.pathname + "?look=" + encodeURIComponent(e3Code(b));
var data = {title: "My Cacilia Sauer bracelet", url: url};
function copy(){
var ok = false;
try { if (navigator.clipboard && navigator.clipboard.writeText){ ok = true; navigator.clipboard.writeText(url).then(function(){ toast("Link copied"); }, function(){ e3ShowLink(url); }); } } catch(e){ ok = false; }
if (!ok) e3ShowLink(url);
}
if (navigator.share){
try { navigator.share(data).then(function(){}, function(err){ if (err && err.name === "AbortError") return; copy(); }); return; } catch(e){}
}
copy();
}
function e3Show(){ openSheet("e3Scrim"); e3Render(); var bd = $("e3Body"); if (bd) bd.scrollTop = 0; }
function e3Close(){ clearTimeout(e3UseT); e3UseT = null; closeSheet("e3Scrim"); }
function e3OpenPreview(){
if (!D) return;
if (!piecesOf(B).length){ for (var k=0;k<S.br.length;k++){ if (piecesOf(S.br[k]).length){ setCur(k); renderStage(); renderMeter(); break; } } }
e3Mode = "own"; e3Shared = null; e3From = ""; e3Zoom = "whole"; e3Show();
}
function e3OpenList(){ if (!D) return; e3Mode = "list"; e3Shared = null; e3From = ""; e3Show(); }
function e3OpenSaved(b){
if (!b){ toast("That design has no charms we still carry"); return; }
e3Shared = b; e3Mode = "shared"; e3From = "list"; e3Zoom = "whole"; e3Render();
var bd = $("e3Body"); if (bd) bd.scrollTop = 0;
var bk = $("e3Back"); if (bk) bk.focus({preventScroll:true});
}
function e3BackFn(){
if (e3Mode === "shared" && e3From === "list"){ e3Mode = "list"; e3Shared = null; e3From = ""; e3Render(); var bd = $("e3Body"); if (bd) bd.scrollTop = 0; }
else e3Close();
}
function e3GoBag(){ e3Close(); setTimeout(function(){ openBag(); }, SHEET_MS); }
function e3UseClick(){ e3UseN = 0; e3Use(); }
function e3Use(){
clearTimeout(e3UseT); e3UseT = null;
var sb = e3Shared; if (!D || !sb || e3Mode !== "shared" || !e3IsOpen()) return;
if (window.CSB && !window.CSB_READY){
if (++e3UseN > 25){ toast("Your bag is still loading. Try again in a moment"); return; }
toast("One moment", {busy: true}); e3UseT = setTimeout(e3Use, 600); return;
}
var snap = snapshot(), had = charmCount() > 0;
if (had && S.br.length < 3){ S.br.push(newBracelet(sb.base, sb.size)); setCur(S.br.length - 1); }
else if (had) piecesOf(B).forEach(remember);
var slots = sb.slots.map(function(p){ if (!p) return null; var q = makePiece(p.i, p.vi); q.span = p.span; return q; });
B.base = sb.base; B.size = sb.size; B.slots = slots; B.own = sb.own.slice(); S.sel = -1; S.pop = -1;
update(); scrollToSlot(Math.floor(B.size/2) - 1, false);
e3Close();
setTimeout(function(){ try { toStage(); } catch(e){} }, SHEET_MS + 30);
toast("Added to your builder", {label:"Undo", fn:function(){ restore(snap); update(); }});
}
function e3FromLink(){
var m = /[?&]look=([^&#]*)/.exec(location.search || ""); if (!m) return;
var code = ""; try { code = decodeURIComponent(m[1].replace(/\+/g, " ")); } catch(e){ code = ""; }
try { var u = new URL(location.href); u.searchParams.delete("look"); history.replaceState(history.state, "", u.toString()); }
catch(e){ try { var q = location.search.replace(/([?&])look=[^&#]*&?/, "$1").replace(/[?&]$/, ""); history.replaceState(history.state, "", location.pathname + q + location.hash); } catch(e2){} }
var b = e3Parse(code);
if (!b){ toast("That link has no charms we still carry"); return; }
e3Shared = b; e3Mode = "shared"; e3From = ""; e3Zoom = "whole"; e3Show();
}
function e3AfterMeter(){
if (!D) return;
if (!e3LinkDone){ e3LinkDone = true; setTimeout(function(){ try { e3FromLink(); } catch(e){} }, 250); }
if (e3IsOpen() && e3Mode === "own") e3Sum();
e3PvSync();
}
function update(){ renderStage(); renderMeter(); updateCounts(); renderGrid(); if (STORE){ scheduleSync(); snapSoon(); } }
var locks = 0, lockY = 0;
function lock(){ if (locks++ === 0){ document.documentElement.classList.add("lock"); document.body.classList.add("lock"); } }
function unlock(){ if (locks > 0 && --locks === 0){ document.documentElement.classList.remove("lock"); document.body.classList.remove("lock"); } }
var SHEET_MS = REDUCED ? 0 : 260;
var timers = {}, lastFocus = null, SHEETS = ["vScrim","hScrim","cScrim","fScrim","rScrim","mScrim"];
function show(ids){
var key = ids[0], pending = !!timers[key];
if (pending){ clearTimeout(timers[key]); timers[key] = 0; } else if (!$(key).hidden) return;
ids.forEach(function(id){ $(id).hidden = false; });
if (!pending) lock();
void document.body.offsetWidth;
requestAnimationFrame(function(){ ids.forEach(function(id){ $(id).classList.add("on"); }); });
}
function hide(ids, after){
var el0 = $(ids[0]); if (el0.hidden || timers[ids[0]]) return;
ids.forEach(function(id){ $(id).classList.remove("on"); });
timers[ids[0]] = setTimeout(function(){ timers[ids[0]] = 0; ids.forEach(function(id){ $(id).hidden = true; }); unlock(); if (after) after(); }, SHEET_MS);
}
function openSheet(id){ lastFocus = document.activeElement; show([id]); var f = $(id).querySelector("button, input"); if (f) f.focus({preventScroll:true}); }
function closeSheet(id){ hide([id], function(){ if (lastFocus && lastFocus.focus && document.body.contains(lastFocus)) lastFocus.focus({preventScroll:true}); }); }
function openBag(){ renderBag(); lastFocus = document.activeElement; show(["bScrim", "bDrawer"]); $("bClose").focus({preventScroll:true}); }
function closeBag(){ hide(["bScrim", "bDrawer"], function(){ if (lastFocus && lastFocus.focus && document.body.contains(lastFocus)) lastFocus.focus({preventScroll:true}); }); }
SHEETS.forEach(function(id){ $(id).addEventListener("click", function(e){ if (e.target.id === id) closeSheet(id); }); });
document.addEventListener("keydown", function(e){ if (e.key === "Escape"){ SHEETS.forEach(function(id){ if (!$(id).hidden) closeSheet(id); }); if (!$("bDrawer").hidden) closeBag(); } });
var tt = null;
function hideToast(){ $("toast").classList.remove("on"); }
var dsT = null;
function dockSay(m){
var d = $("dockMsg"); if (!d){ toast(m); return; }
d.textContent = m; d.parentNode.classList.add("say"); clearTimeout(dsT);
dsT = setTimeout(function(){ d.parentNode.classList.remove("say"); }, 2600);
}
function toStage(){
var el = $("stage"), head = window.CSB ? (parseFloat(getComputedStyle(document.documentElement).getPropertyValue("--cs-head")) || 53) : 52;
var y = el.getBoundingClientRect().top + window.pageYOffset - head - 12;
window.scrollTo({top: Math.max(0, y), behavior: REDUCED ? "auto" : "smooth"});
}
function toast(m, act){
var t = $("toast"), a = $("toastAct"); $("toastMsg").textContent = m;
var busy = !!(act && act.busy); if (busy) act = null; t.classList.toggle("busy", busy);
if (act){ a.hidden = false; a.textContent = act.label; a.onclick = function(){ act.fn(); hideToast(); }; } else { a.hidden = true; a.onclick = null; }
t.classList.add("on"); clearTimeout(tt); tt = setTimeout(hideToast, act ? 4500 : 1900);
}
var lastOn = null;
function onScroll(force){
var st = $("stage").getBoundingClientRect(), wide = window.innerWidth >= 900, on = !wide && st.bottom < 70, mini = $("mini");
if (on === lastOn && force !== true) return;
lastOn = on;
mini.classList.toggle("on", on); $("stick").style.top = STORE ? "calc(var(--cs-head,53px) + " + (on ? mini.offsetHeight - 1 : 0) + "px)" : (52 + (on ? mini.offsetHeight : 0)) + "px"; $("stickTab").style.top = $("stick").style.top;
}
var stk = {hid: false, lastY: window.pageYOffset, acc: 0, openY: -1};
function stickTop(){ var t = parseFloat(getComputedStyle($("stick")).top); return isNaN(t) ? 52 : t; }
function stickLabel(){
var on = $("rail").querySelector('[aria-pressed="true"] span'), t = on ? on.textContent.trim() : "";
var sb = S.sub >= 0 ? $("subs").querySelector('[aria-pressed="true"]') : null;
if (sb){ var sn = sb.firstChild && sb.firstChild.nodeType === 3 ? sb.firstChild.textContent : sb.textContent; sn = sn.trim(); if (sn) t = t ? t + " · " + sn : sn; }
return t || "Categories";
}
function stickHide(on){
if (on === stk.hid) return; stk.hid = on;
var st = $("stick"), tb = $("stickTab");
st.classList.toggle("hid", on); tb.setAttribute("aria-expanded", on ? "false" : "true");
if (on){ $("stickTabLbl").textContent = stickLabel(); tb.style.top = st.style.top || "52px"; }
tb.classList.toggle("on", on); tb.setAttribute("aria-hidden", on ? "false" : "true"); tb.tabIndex = on ? 0 : -1;
}
function stickCheck(){
var y = window.pageYOffset, dy = y - stk.lastY; stk.lastY = y;
if (window.innerWidth >= 900){ stk.acc = 0; stickHide(false); return; }
var top = stickTop(), above = $("q").parentNode.getBoundingClientRect(), pk = $("stick").parentNode.getBoundingClientRect();
var cnt = $("count"), ct = cnt && cnt.parentNode ? cnt.parentNode.getBoundingClientRect().top : above.bottom;
var pinned = above.bottom <= top + 1 && ct <= top + 1 && pk.bottom > top + 220;
if (!pinned){ stk.acc = 0; stk.openY = -1; stickHide(false); return; }
if (dy > 0) stk.acc = Math.max(0, stk.acc) + dy; else if (dy < 0) stk.acc = Math.min(0, stk.acc) + dy;
if (!stk.hid && stk.acc > 40 && (stk.openY < 0 || y - stk.openY > 80)) stickHide(true);
}
function stickOpen(){ stk.openY = window.pageYOffset; stk.acc = 0; stickHide(false); }
Array.prototype.forEach.call(document.querySelectorAll("[data-base]"), function(b){ b.addEventListener("click", function(){ var ch = B.base !== b.dataset.base; B.base = b.dataset.base; renderStage(); renderMeter(); if (STORE){ store("csb_br_no", ""); scheduleSync(); snapSoon(); } if (ch) stageIn(0); }); });
Array.prototype.forEach.call(document.querySelectorAll("[data-size]"), function(b){ b.addEventListener("click", function(){
var n = +b.dataset.size; if (n === B.size) return;
var mid = Math.floor(B.size/2) - 1, ps = []; B.slots.forEach(function(p, s){ if (p) ps.push([Math.abs(s - mid), p]); }); ps.sort(function(a,b){ return a[0]-b[0]; });
var nb = newBracelet(B.base, n); S.br[S.cur] = nb; B = nb; S.sel = -1;
var moved = 0; ps.forEach(function(x){ if (placeIn(nb, x[1]) < 0){ placeAny(x[1]); moved++; } });
update(); scrollToSlot(Math.floor(n/2) - 1, false); stageIn(0);
if (moved) toast(moved + " charm" + (moved>1?"s":"") + " didn't fit, so " + (moved>1?"they":"it") + " moved to another bracelet");
}); });
function chainGap(delta){
var s = S.sel; if (s < 0 || !B.slots[s] || B.slots[s].kind !== 2) return;
var p = B.slots[s], ns = Math.max(1, Math.min(4, p.span + delta)); if (ns === p.span){ toast(delta > 0 ? "3 links between is the most" : "The ends are already side by side"); return; }
var oldR = s + p.span, newR = s + ns;
if (newR >= B.size){ toast("That's the end of the bracelet"); return; }
var snap = JSON.stringify({slots: B.slots, own: B.own});
clearAt(B, s);
var o = B.own[newR];
if (o >= 0){ var q = B.slots[o]; if (isSingle(q)){ clearAt(B, o); setAt(B, q, oldR); } else { var r = JSON.parse(snap); B.slots = r.slots; B.own = r.own; toast("Move the charm next to the chain first"); renderStage(); return; } }
p.span = ns; setAt(B, p, s);
renderStage();
}
$("gapIn").addEventListener("click", function(){ chainGap(-1); });
$("gapOut").addEventListener("click", function(){ chainGap(1); });
$("mvL").addEventListener("click", function(){ move(-1); });
$("mvR").addEventListener("click", function(){ move(1); });
$("mvBr").addEventListener("click", pickBracelet);
$("rmSlot").addEventListener("click", function(){ if (S.sel < 0 || !B.slots[S.sel]) return; liftOff(S.sel); var snap = snapshot(), p = clearAt(B, S.sel); remember(p); S.sel = -1; update(); toast("Removed " + pieceName(p), {label:"Undo", fn:function(){ restore(snap); }}); });
$("doneSel").addEventListener("click", function(){ S.sel = -1; renderStage(); });
$("recentClear").addEventListener("click", function(){ S.recent = []; renderRecent(); });
$("stripWrap").addEventListener("scroll", function(){ syncWin(); }, {passive:true});
$("map").addEventListener("click", function(e){ var r = this.getBoundingClientRect(), s = Math.floor((e.clientX - r.left) / r.width * B.size); scrollToSlot(Math.max(0, Math.min(B.size-1, s)), true); });
$("miniBtn").addEventListener("click", function(){ toStage(); });
var qt = null;
$("q").addEventListener("input", function(){ var v = this.value; clearTimeout(qt); qt = setTimeout(function(){ S.q = v; S.page = 1; GT = {fade:1}; renderGrid(); }, 120); });
["focus", "pointerdown", "input"].forEach(function(ev){ $("q").addEventListener(ev, function(){ kwLoad(); kwSpin(); }, {passive:true}); });
$("q").addEventListener("focus", function(){
if (window.innerWidth >= 900) return;
setTimeout(function(){ var hv = parseFloat(getComputedStyle(document.documentElement).getPropertyValue("--cs-head")) || 52, mini = $("mini");
var off = hv + (mini && mini.classList.contains("on") ? mini.offsetHeight : 0) + 8, top = $("q").getBoundingClientRect().top;
if (top > off + 4) window.scrollBy(0, top - off);
}, 60);
});
Array.prototype.forEach.call(document.querySelectorAll("[data-metal]"), function(b){ b.addEventListener("click", function(){ S.metal = b.dataset.metal; Array.prototype.forEach.call(document.querySelectorAll("[data-metal]"), function(x){ x.setAttribute("aria-pressed", x===b); }); S.page = 1; GT = {fade:1}; renderGrid(); }); });
$("sort").addEventListener("change", function(){ S.sort = this.value; S.page = 1; GT = {fade:1}; renderGrid(); });
["pgNavT", "pgNavB"].forEach(function(id){ var nav = $(id); nav.addEventListener("click", function(e){ var b = e.target && e.target.closest ? e.target.closest("[data-p]") : null; if (b && nav.contains(b)) goPage(+b.getAttribute("data-p"), nav); }); });
var swp = null, swpEnd = 0, gridEl = $("grid");
function swpEdge(dx){ return (dx > 0 && S.page <= 1) || (dx < 0 && S.page >= S.pages); }
function swpDrop(){ var s = swp; swp = null; if (s && s.ax === "x"){ swpEnd = Date.now(); swpBack(s.mv); } }
gridEl.addEventListener("touchstart", function(e){ if (e.touches.length !== 1 || S.pages < 2 || hScroll(e.target, gridEl)){ swp = null; return; } var t = e.touches[0]; swp = {x: t.clientX, y: t.clientY, ax: "", x0: 0, dx: 0, mv: 0, lx: t.clientX, lt: Date.now(), v: 0}; }, {passive:true});
gridEl.addEventListener("touchmove", function(e){
if (!swp) return;
if (e.touches.length > 1){ swpDrop(); return; }
var t = e.touches[0], dx = t.clientX - swp.x, dy = t.clientY - swp.y, now = Date.now();
if (!swp.ax){
if (Math.abs(dx) < 10 && Math.abs(dy) < 10) return;
if (Math.abs(dx) <= Math.abs(dy) * 1.5){ swp = null; return; }
swp.ax = "x"; swp.x0 = t.clientX; gridSettle();
}
var dt = now - swp.lt; if (dt > 0){ swp.v = 0.7 * ((t.clientX - swp.lx) / dt) + 0.3 * swp.v; swp.lx = t.clientX; swp.lt = now; }
swp.dx = dx; swp.dy = dy;
if (Math.abs(dy) > 64 && Math.abs(dy) * 1.2 > Math.abs(dx)){ swpDrop(); return; } // the finger went clearly up or down: a scroll, not a page turn
if (REDUCED) return;
var m = t.clientX - swp.x0; if (swpEdge(dx)) m *= 0.3;
swp.mv = Math.round(m * 10) / 10; gridEl.style.transform = "translateX(" + swp.mv + "px)";
}, {passive:true});
gridEl.addEventListener("touchend", function(){
var s = swp; swp = null; if (!s || s.ax !== "x") return;
swpEnd = Date.now();
var w = gridEl.offsetWidth || 320, dx = s.dx, v = Date.now() - s.lt > 90 ? 0 : s.v;
var go = !swpEdge(dx) && Math.abs(dx) > 1.4 * Math.abs(s.dy || 0) && (Math.abs(dx) > w * 0.2 || (Math.abs(v) > 0.45 && Math.abs(dx) > 24 && (v < 0) === (dx < 0)));
if (go) goPage(S.page + (dx < 0 ? 1 : -1), null, s.mv); else swpBack(s.mv);
}, {passive:true});
gridEl.addEventListener("touchcancel", swpDrop, {passive:true});
gridEl.addEventListener("click", function(e){ if (swpEnd && Date.now() - swpEnd < 400){ e.preventDefault(); e.stopPropagation(); } }, true);
$("review").addEventListener("click", function(){ openBag(); });
$("hdrBag").addEventListener("click", function(){ openBag(); });
$("bScrim").addEventListener("click", closeBag);
$("bClose").addEventListener("click", closeBag);
$("hdrHearts").addEventListener("click", function(){ setScope("saved"); var y = $("pk").getBoundingClientRect().top + window.scrollY - 60; window.scrollTo({top: y, behavior: REDUCED ? "auto" : "smooth"}); });
$("seeAll").addEventListener("click", function(){ renderAllCats(); openSheet("cScrim"); });
$("checkout").addEventListener("click", function(){ closeBag(); toast("Prototype: this would open Shopify checkout"); });
$("vClose").addEventListener("click", function(){ closeSheet("vScrim"); });
$("hClose").addEventListener("click", function(){ closeSheet("hScrim"); });
$("cClose").addEventListener("click", function(){ closeSheet("cScrim"); });
$("mClose").addEventListener("click", function(){ closeSheet("mScrim"); });
$("brTabs").addEventListener("scroll", tabFade, {passive:true});
var topBtn = $("toTop"), topOn = false;
function topCheck(){ var on = window.scrollY > 520 && !document.body.classList.contains("lock"); if (on !== topOn){ topOn = on; topBtn.classList.toggle("on", on); topBtn.tabIndex = on ? 0 : -1; } }
var tcQ = false; window.addEventListener("scroll", function(){ if (tcQ) return; tcQ = true; requestAnimationFrame(function(){ tcQ = false; topCheck(); }); }, {passive:true}); topCheck();
topBtn.addEventListener("click", function(){ window.scrollTo({top:0, behavior: REDUCED ? "auto" : "smooth"}); });
$("fClose").addEventListener("click", function(){ closeSheet("fScrim"); });
$("fReset").addEventListener("click", function(){ HUB = {who:"me", loves:{}, look:{}}; renderHub(); });
$("fShow").addEventListener("click", function(){ closeSheet("fScrim"); S.scope = {t:"foryou"}; S.sub = -1; S.page = 1; GT = {fade:1}; renderPicker(false); setTimeout(function(){ var y = $("pk").getBoundingClientRect().top + window.scrollY - 60; window.scrollTo({top: y, behavior: REDUCED ? "auto" : "smooth"}); }, SHEET_MS); });
$("rClose").addEventListener("click", function(){ closeSheet("rScrim"); });
$("rDone").addEventListener("click", function(){ closeSheet("rScrim"); });
$("rBag").addEventListener("click", function(){ closeSheet("rScrim"); setTimeout(openBag, SHEET_MS); });
$("hLater").addEventListener("click", function(){ closeSheet("hScrim"); toast("Saved on this device"); });
$("hForm").addEventListener("submit", function(e){ e.preventDefault(); closeSheet("hScrim"); toast("Hearts saved. We'll email you if one sells out, comes back or goes on sale."); });
var osQ = false; window.addEventListener("scroll", function(){ if (osQ) return; osQ = true; requestAnimationFrame(function(){ osQ = false; onScroll(); stickCheck(); }); }, {passive:true});
$("stickTab").addEventListener("click", stickOpen);
var rt = null; window.addEventListener("resize", function(){ clearTimeout(rt); rt = setTimeout(function(){ renderStage(); renderGrid(); onScroll(true); }, 150); });
try {
SHEETS.push("e1Scrim");
$("e1Scrim").addEventListener("click", function(e){ if (e.target.id === "e1Scrim") closeSheet("e1Scrim"); });
$("e1Close").addEventListener("click", function(){ closeSheet("e1Scrim"); });
$("e1Bag").addEventListener("click", function(){ closeSheet("e1Scrim"); setTimeout(function(){ openBag(); }, SHEET_MS); });
$("e1Body").addEventListener("click", function(e){ var t = e.target && e.target.closest ? e.target.closest("#e1Tg") : null; if (!t) return; e1ListOpen = !e1ListOpen; try { e1Sheet(); } catch(er){} });
var e1Sum = document.querySelector(".dock .sum");
if (e1Sum){
e1Sum.classList.add("e1-sum"); e1Sum.setAttribute("role", "button"); e1Sum.setAttribute("tabindex", "0"); e1Sum.setAttribute("aria-label", "See your order");
e1Sum.addEventListener("click", function(){ e1OpenSheet(); });
e1Sum.addEventListener("keydown", function(e){ if (e.key === "Enter" || e.key === " " || e.key === "Spacebar"){ e.preventDefault(); e1OpenSheet(); } });
}
} catch(e){}
var renderMeter_E1 = renderMeter;
renderMeter = function(){ renderMeter_E1(); try { e1Cards(); } catch(e){} try { var e1s = $("e1Scrim"); if (e1s && !e1s.hidden) e1Sheet(); } catch(e){} };
try { e1Cards(); } catch(e){}
try {
var renderStage_E2 = renderStage; renderStage = function(){ renderStage_E2(); try { e2RenderLooks(); } catch(e){} };
var renderGrid_E2 = renderGrid; renderGrid = function(){ renderGrid_E2(); try { e2Names(); } catch(e){} };
if ($("e2Scrim")){
SHEETS.push("e2Scrim");
$("e2Scrim").addEventListener("click", function(e){ if (e.target.id === "e2Scrim") closeSheet("e2Scrim"); });
$("e2Close").addEventListener("click", function(){ closeSheet("e2Scrim"); });
$("e2Add").addEventListener("click", e2AddNow);
$("e2Heart").addEventListener("click", e2HeartTap);
}
var e2G = $("grid");
if (e2G){
e2G.addEventListener("click", function(e){ var n = e.target && e.target.closest ? e.target.closest(".n") : null; if (!n || !e2G.contains(n)) return; var card = n.closest(".card"); if (card) e2OpenCard(card); });
e2G.addEventListener("keydown", function(e){ if (e.key !== "Enter" && e.key !== " ") return; var n = e.target && e.target.closest ? e.target.closest(".n") : null; if (!n || !e2G.contains(n)) return; e.preventDefault(); var card = n.closest(".card"); if (card) e2OpenCard(card); });
e2G.addEventListener("pointerdown", function(e){
if (e.isPrimary === false || (e.pointerType === "mouse" && e.button !== 0)) return;
var pic = e.target && e.target.closest ? e.target.closest(".pic") : null, card = pic ? pic.closest(".card") : null;
if (!card || !e2G.contains(card)) return;
if (e2LP) clearTimeout(e2LP.t);
e2LP = {id: e.pointerId, x: e.clientX, y: e.clientY, t: setTimeout(function(){ e2LP = null; if (!document.body.contains(card)) return; e2Fired = true; e2OpenCard(card); }, 450)};
});
e2G.addEventListener("contextmenu", function(e){ if ((e2LP || e2Fired) && e.target && e.target.closest && e.target.closest(".pic")) e.preventDefault(); });
}
document.addEventListener("pointerdown", function(){ e2Swallow = 0; e2Fired = false; }, true);
document.addEventListener("pointermove", function(e){ if (!e2LP || e.pointerId !== e2LP.id) return; var dx = e.clientX - e2LP.x, dy = e.clientY - e2LP.y; if (dx*dx + dy*dy > 64){ clearTimeout(e2LP.t); e2LP = null; } }, {capture: true, passive: true});
var e2End = function(e){ if (e2LP && e.pointerId === e2LP.id){ clearTimeout(e2LP.t); e2LP = null; } if (e2Fired){ e2Fired = false; e2Swallow = Date.now(); } };
document.addEventListener("pointerup", e2End, true);
document.addEventListener("pointercancel", e2End, true);
document.addEventListener("click", function(e){ if (e2Fired || (e2Swallow && Date.now() - e2Swallow < 700)){ e2Fired = false; e2Swallow = 0; e.preventDefault(); e.stopPropagation(); } }, true);
} catch(e){}
try {
SHEETS.push("e3Scrim");
$("e3Scrim").addEventListener("click", function(e){ if (e.target.id === "e3Scrim") e3Close(); });
$("e3PvBtn").addEventListener("click", e3OpenPreview);
$("e3QsBtn").addEventListener("click", function(){ e3Save(); e3SaveState($("e3QsBtn")); });
$("e3SvBtn").addEventListener("click", e3OpenList);
$("e3Back").addEventListener("click", e3BackFn);
$("e3Close").addEventListener("click", e3Close);
$("e3Zoom").addEventListener("click", function(e){ var t = e.target && e.target.closest ? e.target.closest("[data-e3z]") : null; if (!t) return; var z = t.getAttribute("data-e3z"); if (z === e3Zoom) return; e3Zoom = z; e3SegSync(); try { e3Pic(true); } catch(err){} });
window.addEventListener("resize", function(){ clearTimeout(e3RT); e3RT = setTimeout(function(){ try { if (e3IsOpen() && e3Mode !== "list") e3Pic(false); } catch(e){} }, 150); });
e3LooksN = e3Looks().length;
var renderStage_E3 = renderStage; renderStage = function(){ renderStage_E3(); try { e3PvSync(); } catch(e){} };
var renderMeter_E3 = renderMeter; renderMeter = function(){ renderMeter_E3(); try { e3AfterMeter(); } catch(e){} };
} catch(e){}
if (/[?&]audit=1/.test(location.search)) window.__csb = {S:S, get D(){ return D; }, makePiece:makePiece, setAt:setAt, newBracelet:newBracelet, setCur:setCur, update:function(){ update(); }, renderStage:function(){ renderStage(); }};
var REF = {}, SUPPRESS = false, syncT = null, syncing = false, pending = false, booted = false, localRev = 0, syncedRev = 0, early = [], waiters = [], rounds = 0;
var BASE = null, cartAt = 0;
var addPiece0 = addPiece; addPiece = function(p, src){ if (!booted) early.push([p.i, p.vi]); if (window.CS && CS.shake){ CS.flewAt = Date.now(); setTimeout(function(){ CS.shake("bag"); }, 420); } return addPiece0(p, src); };
function vidOf(p){ var it = D.items[p.i]; if (!it) return null; if (it.ph) return "ph:" + it.ph.uid; return p.vi == null ? (it.id || null) : ((it.vv && it.vv[p.vi] && it.vv[p.vi][5]) || null); }
function buildRef(){ D.items.forEach(function(it, i){ if (it.vv) it.vv.forEach(function(v, vi){ if (v[5]) REF[v[5]] = [i, vi]; }); else if (it.id) REF[it.id] = [i, null]; }); }
function cartCounts(c){ var m = {}; (c && c.items || []).forEach(function(it){ var k = REF[it.variant_id] ? it.variant_id : phLine(it) ? phNote(it) : null; if (k) m[k] = (m[k] || 0) + it.quantity; }); return m; }
function builderCounts(){ var m = {}; allPieces().forEach(function(p){ if (phPending(p)) return; var v = vidOf(p); if (v) m[v] = (m[v] || 0) + 1; }); return m; }
function dirty(){ return localRev !== syncedRev; }
function isMine(it){ return !!(it.properties && (it.properties._builder || it.properties._gift)); }
function isOwnBr(it){ return !!(it.properties && it.properties._builder); }
function liveBr(){ return S.br.filter(function(b){ return piecesOf(b).length || b.bag; }); }
var BASEN = null;
function brLines(c){ return (c && c.items || []).filter(function(it){ return it.handle === CSB.bracelet.handle; }); }
function brN(c){ return brLines(c).reduce(function(a, it){ return a + it.quantity; }, 0); }
function agree(c){ BASE = cartCounts(c); BASEN = brN(c); }
function adoptBr(c, full){
var cb = [], ch = false;
brLines(c).forEach(function(it){ for (var q = 0; q < it.quantity; q++) cb.push({m: CSB.bracelet.metal[it.variant_id], own: isOwnBr(it)}); });
var live = liveBr().length, gained = full || BASEN == null ? cb.length - live : cb.length - BASEN;
if (gained < 0 && live > cb.length){
for (var drop = Math.min(-gained, live - cb.length); drop > 0; drop--){
var k = -1; for (var i = S.br.length - 1; i >= 0; i--) if (S.br[i].bag && !piecesOf(S.br[i]).length){ k = i; break; }
if (k < 0) break; S.br.splice(k, 1); ch = true;
}
if (ch) setCur(Math.min(S.cur, S.br.length - 1));
} else if (gained > 0 && cb.length > live){
var pool = liveBr().map(function(b){ return b.base; }), first = [], rest = [];
cb.forEach(function(x){ if (x.own) return; var j = pool.indexOf(x.m); if (j >= 0){ pool.splice(j, 1); rest.push(x.m); } else first.push(x.m); });
first.concat(rest).slice(0, Math.min(gained, cb.length - live)).forEach(function(m){ var nb = newBracelet(m || "silver", B.size); nb.bag = 1; S.br.push(nb); ch = true; });
}
var um = cb.filter(function(x){ return !x.own; }).map(function(x){ return x.m; }), eb = [];
S.br.forEach(function(b){ if (!b.bag || piecesOf(b).length) return; var j = um.indexOf(b.base); if (j >= 0) um.splice(j, 1); else eb.push(b); });
eb.forEach(function(b){ if (um.length){ var m = um.shift(); if (m && b.base !== m){ b.base = m; ch = true; } } });
return ch;
}
function followMetals(c){
var pool = [], ch = false, miss = [];
brLines(c).forEach(function(it){ var m = CSB.bracelet.metal[it.variant_id]; for (var q = 0; q < it.quantity; q++) if (m) pool.push(m); });
liveBr().forEach(function(b){ var j = pool.indexOf(b.base); if (j >= 0) pool.splice(j, 1); else miss.push(b); });
miss.forEach(function(b){ if (pool.length){ var m = pool.shift(); if (b.base !== m){ b.base = m; ch = true; } } });
return ch;
}
function saveState(){ store("csb_state", JSON.stringify({br: S.br, cur: S.cur})); }
function loadState(){
try {
var o = JSON.parse(store("csb_state") || "null"); if (!o || !o.br || !o.br.length) return;
var br = o.br.filter(function(b){ return b && Array.isArray(b.slots) && SIZE_LBL[b.size] && BASE_NAME[b.base] && b.slots.length <= 40; }).slice(0, 12);
if (!br.length) return;
br.forEach(function(b){
b.slots.forEach(function(p, s){ if (p && p.ph && p.ph.uid) b.slots[s] = phPiece(p.ph, true); });
b.slots.forEach(function(p, s){ if (p && (!D.items[p.i] || (p.vi != null && !(D.items[p.i].vv || [])[p.vi]) || vidOf(p) == null)) b.slots[s] = null; });
b.own = b.slots.map(function(){ return -1; }); b.slots.forEach(function(p, s){ if (p) blocked(p, s).forEach(function(c){ if (c < b.size) b.own[c] = s; }); });
});
while (br.length > 1 && !piecesOf(br[br.length - 1]).length && !br[br.length - 1].bag) br.pop();
S.br = br; setCur(Math.min(o.cur || 0, S.br.length - 1));
} catch(e){}
}
var FLAGS = ["csb_tool_seen", "csb_tool_no", "csb_tool_n", "csb_tool_cap", "csb_br_seen", "csb_br_no"];
function toolsWanted(c, n){ return 0; }
function toolCap(){ var cap = store("csb_tool_cap"); return (cap == null || cap === "") ? Infinity : (Number(cap) || 0); }
function observe(c){
var t = totals(), items = c && c.items || [];
if (t.c < 10){ FLAGS.forEach(function(k){ store(k, ""); }); return; }
var tv = CSB.toolVariant;
if (tv){
var mq = items.reduce(function(a, it){ return a + (it.variant_id === tv && isMine(it) ? it.quantity : 0); }, 0), last = Number(store("csb_tool_n") || 0);
if (mq < last) store("csb_tool_cap", String(mq));
store("csb_tool_n", String(mq));
}
var bl = items.filter(function(it){ return it.handle === CSB.bracelet.handle; });
if (bl.some(isMine)) store("csb_br_seen", "1");
else if (!bl.length && store("csb_br_seen") === "1"){ store("csb_br_no", "1"); store("csb_br_seen", ""); }
}
function fromCart(c){
if (!c || syncing || syncT || retryT || (booted && dirty())) return;
SUPPRESS = true;
var want = cartCounts(c), have = builderCounts(), changed = false;
Object.keys(have).forEach(function(v){
var extra = have[v] - (want[v] || 0);
for (var bi = S.br.length - 1; bi >= 0 && extra > 0; bi--){ var b = S.br[bi]; for (var s = b.size - 1; s >= 0 && extra > 0; s--){ var p = b.slots[s]; if (p && !phPending(p) && String(vidOf(p)) === String(v)){ clearAt(b, s); extra--; changed = true; } } }
});
Object.keys(want).forEach(function(v){ var miss = want[v] - (have[v] || 0); for (var k = 0; k < miss; k++){ var np = pieceFor(v); if (np === true){ changed = true; continue; } if (!np) break; placeAny(np); changed = true; } });
while (S.br.length > 1 && !piecesOf(S.br[S.br.length - 1]).length && !S.br[S.br.length - 1].bag && S.cur !== S.br.length - 1) S.br.pop();
if (adoptBr(c, true)) changed = true;
if (followMetals(c)) changed = true;
if (changed || !booted) update();
SUPPRESS = false; saveState();
agree(c);
observe(c);
if (booted){ var pl = plan(c); if ((pl.n || pl.add.length) && JSON.stringify(pl) !== failSig) scheduleSync(); }
}
function scheduleSync(){ if (!STORE || SUPPRESS || !booted) return; localRev++; rounds = 0; saveState(); clearTimeout(syncT); syncT = setTimeout(doSync, 350); }
function post(url, body){
var ac = window.AbortController ? new AbortController() : null, to = ac ? setTimeout(function(){ ac.abort(); }, 15000) : 0;
return fetch(url, {method: "POST", keepalive: true, signal: ac ? ac.signal : undefined, headers: {"Content-Type": "application/json", "Accept": "application/json"}, body: JSON.stringify(body)}).then(function(r){
clearTimeout(to);
return r.text().then(function(t){ var j = null; try { j = JSON.parse(t); } catch(e){}
if (!r.ok || !j){ var err = new Error(j && (j.description || j.message) || ""); err.status = r.status; err.retry = !(r.status === 422 || r.status === 404) || !j; throw err; }
return j; });
}, function(){ clearTimeout(to); var err = new Error(""); err.status = 0; err.retry = true; err.offline = navigator.onLine === false; throw err; });
}
var retries = 0, retryT = null, warned = false, failSig = null;
function braceletPlan(c){
var t = totals(), live = liveBr(), nF = Math.min(t.freeN, live.length);
var lines = (c.items || []).filter(function(it){ return it.handle === CSB.bracelet.handle; });
var mine = lines.filter(isOwnBr);
var ent = store("csb_br_no") === "1" ? [] : live.slice(0, nF).map(function(b){ return {m: b.base, bag: !!b.bag, empty: !piecesOf(b).length}; });
var desired = ent.map(function(e){ return e.m; });
var spare = live.slice(nF).filter(function(b){ return b.bag; }).length;
function take(fn){ for (var i = 0; i < ent.length; i++) if (fn(ent[i])) return ent.splice(i, 1)[0]; return null; }
var out = {add: [], set: []}, after = 0, afterCls = 0;
var others = (c.items || []).filter(function(it){ return /bracelet/.test(it.handle || "") && it.handle !== CSB.bracelet.handle && !/matching/.test(it.handle || "") && !(it.properties && it.properties._pair); });
lines.concat(others).forEach(function(it){
if (isOwnBr(it)) return;
var um = CSB.bracelet.metal[it.variant_id], keep = 0;
for (var q = 0; q < it.quantity; q++){
var e = take(function(x){ return x.bag && x.m === um; }) || take(function(x){ return x.m === um; }) || take(function(x){ return x.bag; });
if (!e && spare > 0) spare--; else if (!e) e = take(function(){ return true; });
if (e) keep++;
}
var gift = it.properties && it.properties._gift && !it.properties._was;
if (gift && keep < it.quantity) out.set.push({key: it.key, quantity: keep});
var n = gift ? keep : it.quantity; after += n; if (it.handle === CSB.bracelet.handle) afterCls += n;
});
mine.forEach(function(it){
var m = CSB.bracelet.metal[it.variant_id], keep = 0;
for (var q = 0; q < it.quantity; q++){ if (take(function(x){ return x.m === m; })) keep++; }
if (keep !== it.quantity) out.set.push({key: it.key, quantity: keep});
after += keep; afterCls += keep;
});
var cartC = 0, cc = cartCounts(c); Object.keys(cc).forEach(function(v){ if (!phGiftK(v)) cartC += cc[v]; });
var room = Math.min(3, Math.floor(cartC / 10)) - after;
ent.forEach(function(e){ if (e.empty || room <= 0) return; var id = CSB.bracelet.variants[e.m]; if (id){ out.add.push({id: id, quantity: 1, properties: {_builder: "1"}}); room--; after++; afterCls++; } });
out.after = afterCls;
var tv = CSB.toolVariant;
if (tv){
var tl = (c.items || []).filter(function(it){ return it.variant_id === tv; }), ml = tl.filter(isMine);
var userT = tl.reduce(function(a, it){ return a + (isMine(it) ? 0 : it.quantity); }, 0), mq = ml.reduce(function(a, it){ return a + it.quantity; }, 0);
var want = Math.min(toolCap(), Math.max(0, toolsWanted(t.c, store("csb_br_no") === "1" ? 1 : desired.length) - userT));
if (mq > want){ var left = want; ml.forEach(function(it){ var k = Math.min(it.quantity, left); left -= k; if (k !== it.quantity) out.set.push({key: it.key, quantity: k}); }); }
else if (mq < want){ if (ml.length) out.set.push({key: ml[0].key, quantity: ml[0].quantity + want - mq}); else out.add.push({id: tv, quantity: want, properties: {_builder: "1"}}); }
out.tool = want;
}
return out;
}
function plan(c){
var want = builderCounts(), have = cartCounts(c), upd = {}, n = 0, byV = {}, padd = [];
(c.items || []).forEach(function(it){ var k = REF[it.variant_id] ? it.variant_id : phLine(it) ? phNote(it) : null; if (k) (byV[k] = byV[k] || []).push(it); });
Object.keys(want).concat(Object.keys(have)).forEach(function(v){
if (v in upd || (v in byV && byV[v].done)) return;
var target = want[v] || 0, cur = have[v] || 0, ls = byV[v] || [];
if (ls.length) ls.done = true;
if (cur === target) return;
if (!ls.length){ if (isPhK(v)){ phReAdd(v, target, padd); return; } upd[v] = target; n++; return; }
if (target > cur){ upd[ls[0].key] = ls[0].quantity + target - cur; n++; return; }
for (var i = ls.length - 1, drop = cur - target; i >= 0 && drop > 0; i--){ var k = Math.min(ls[i].quantity, drop); upd[ls[i].key] = ls[i].quantity - k; drop -= k; n++; }
});
var br = braceletPlan(c);
br.set.forEach(function(x){ upd[x.key] = x.quantity; n++; });
return {upd: upd, n: n, add: br.add.concat(padd), tool: br.tool, brAfter: br.after};
}
function merge(c, hush){
if (!BASE || !c) return;
var remote = cartCounts(c), local = builderCounts(), keys = {}, changed = false;
[BASE, remote, local].forEach(function(o){ Object.keys(o).forEach(function(k){ keys[k] = 1; }); });
SUPPRESS = true;
Object.keys(keys).forEach(function(v){
var b = BASE[v] || 0, r = remote[v] || 0, l = local[v] || 0;
if (r === b) return;
var t = Math.max(0, r + l - b);
if (t < l){ var extra = l - t; for (var bi = S.br.length - 1; bi >= 0 && extra > 0; bi--){ var bb = S.br[bi]; for (var s = bb.size - 1; s >= 0 && extra > 0; s--){ var p = bb.slots[s]; if (p && !phPending(p) && String(vidOf(p)) === String(v)){ clearAt(bb, s); extra--; changed = true; } } } }
else if (t > l){ for (var k = 0; k < t - l; k++){ var np = pieceFor(v); if (np === true){ changed = true; continue; } if (!np) break; placeAny(np); changed = true; } }
});
BASE = remote;
if (adoptBr(c)) changed = true;
BASEN = brN(c);
if (changed){ while (S.br.length > 1 && !piecesOf(S.br[S.br.length - 1]).length && !S.br[S.br.length - 1].bag && S.cur !== S.br.length - 1) S.br.pop(); update(); saveState(); }
SUPPRESS = false;
if (changed && !hush) toast("Your bag changed in another tab. The builder now matches it.");
}
function whenSynced(){ if (!syncing && !syncT && !dirty()) return Promise.resolve(true); return new Promise(function(res){ waiters.push(res); }); }
function flushWaiters(){ if (!syncing && !syncT && !dirty()) waiters.splice(0).forEach(function(f){ f(true); }); }
function say(m, retry){ toast(m, retry ? {label: "Retry", fn: function(){ retries = 0; clearTimeout(retryT); retryT = null; doSync(); }} : null); }
function doSync(fresh){
syncT = null;
if (syncing){ pending = true; return whenSynced(); }
if (window.CS && CS.busyNow && CS.busyNow()){ syncT = setTimeout(function(){ doSync(fresh); }, 250); return whenSynced(); }
var c = window.CS && CS.getCart && CS.getCart(); if (!c){ if (window.CS && CS.loadCart) CS.loadCart().catch(function(){}); return whenSynced(); }
if (!fresh && Date.now() - cartAt > 2500 && window.CS && CS.loadCart){
syncing = true;
CS.loadCart().then(function(fc){ syncing = false; merge(fc); doSync(true); }, function(){ syncing = false; doSync(true); });
return whenSynced();
}
merge(c, true);
var rev = localRev, p = plan(c), want0 = builderCounts(), BASE0 = cartCounts(c);
if (totals().c < 10) FLAGS.forEach(function(k){ store(k, ""); });
if (!p.n && !p.add.length){ syncedRev = rev; agree(c); observe(c); flushWaiters(); return Promise.resolve(true); }
syncing = true;
var ch = Promise.resolve();
if (p.n) ch = ch.then(function(){ return post(CS.routes.update + ".js", {updates: p.upd}); });
if (p.add.length) ch = ch.then(function(){ return post(CS.routes.add + ".js", {items: p.add}); });
ch.then(function(){ return CS.loadCart().catch(function(){ return null; }); }).then(function(c2){
syncing = false; retries = 0; clearTimeout(retryT); retryT = null;
if (c2){
var got = cartCounts(c2), capped = Object.keys(want0).some(function(v){ return !isPhK(v) && (got[v] || 0) < want0[v] && (BASE0[v] || 0) < want0[v]; });
BASE = want0; BASEN = p.brAfter; merge(c2, true);
if (capped) say("Some charms are limited in stock. Your bag has as many as we can send.");
} else { BASE = want0; BASEN = null; cartAt = 0; }
if (warned){ warned = false; toast("Your bag is saved"); }
if (localRev === rev) syncedRev = rev;
if (p.tool != null) store("csb_tool_n", String(p.tool));
if (c2 && !dirty() && !pending){
var again = plan(c2);
if (again.n || again.add.length){
if (rounds++ < 2){ localRev++; return doSync(); }
var w2 = builderCounts(), h2 = cartCounts(c2), over = Object.keys(h2).some(function(v){ return h2[v] > (w2[v] || 0); });
if (!over){
fromCart(c2); say("Some charms are limited in stock. Your bag has as many as we can send.");
} else {
localRev++; say("Your bag didn't save right. Tap Retry.", true);
}
} else { agree(c2); observe(c2); }
}
}, function(e){
syncing = false;
if (e.retry === false){
syncedRev = localRev; failSig = JSON.stringify(p); say(e.message || "That change could not be saved.");
return CS.loadCart().catch(function(){});
}
retries++;
var wait = retries <= 5 ? Math.min(8000, 800 * Math.pow(1.8, retries - 1)) : 15000;
if (retries === 3){ warned = true; say(e.offline ? "You're offline. Your bag will save when you're back." : "Your bag isn't saving right now. We'll keep trying.", true); }
syncing = true;
return CS.loadCart().then(function(fc){ agree(fc); }, function(){ BASE = null; BASEN = null; cartAt = 0; }).then(function(){ syncing = false; clearTimeout(retryT); retryT = setTimeout(function(){ retryT = null; if (!syncing) doSync(); }, wait); });
})
.then(function(){ if (pending){ pending = false; doSync(); } else { flushWaiters(); renderMeter(); if (window.CS && CS.autoGifts) CS.autoGifts(); } });
return whenSynced();
}
function flushSync(){ if (syncT){ clearTimeout(syncT); syncT = null; } if (!syncing && dirty()){ clearTimeout(retryT); retryT = null; doSync(); } return whenSynced(); }
window.addEventListener("online", function(){ if (dirty() && !syncing){ retries = 0; clearTimeout(retryT); retryT = null; doSync(); } });
document.addEventListener("visibilitychange", function(){
if (!booted) return;
if (document.visibilityState === "visible"){ if (dirty()){ if (!syncing){ clearTimeout(retryT); retryT = null; doSync(); } } else if (window.CS && CS.loadCart) CS.loadCart().catch(function(){}); }
else if (syncT) flushSync();
});
window.addEventListener("pagehide", function(){
if (!booted || syncing || !dirty()) return;
var c = window.CS && CS.getCart && CS.getCart(); if (!c || (CS.busyNow && CS.busyNow())) return;
merge(c, true); var p = plan(c);
if (p.tool != null) store("csb_tool_n", String(p.tool));
if (p.n){ post(CS.routes.update + ".js", {updates: p.upd}).catch(function(){}); hid = true; }
});
var hid = false;
window.addEventListener("pageshow", function(e){
if (!e.persisted || !hid) return;
hid = false; clearTimeout(syncT); syncT = null; syncedRev = localRev; BASE = null; BASEN = null;
if (window.CS && CS.loadCart) CS.loadCart().catch(function(){});
});
document.addEventListener("click", function(e){ var t = e.target && e.target.closest && e.target.closest("[data-cs-open='csBag']"); if (t && booted) flushSync(); }, true);
document.addEventListener("submit", function(e){
var f = e.target; if (!booted || !f || !/\/cart\/?$/.test(f.getAttribute("action") || "")) return;
if (!syncT && !syncing && !dirty()) return;
e.preventDefault();
var btn = f.querySelector("[name=checkout]"), lbl = btn ? btn.textContent : "";
if (btn){ btn.disabled = true; btn.textContent = "Saving your bag…"; }
Promise.race([flushSync(), new Promise(function(r){ setTimeout(function(){ r(false); }, 9000); })]).then(function(ok){
if (ok && !dirty()){ var h = document.createElement("input"); h.type = "hidden"; h.name = "checkout"; h.value = ""; f.appendChild(h); HTMLFormElement.prototype.submit.call(f); }
else { if (btn){ btn.disabled = false; btn.textContent = lbl; } say("We couldn't save your bag. Check your connection and try again.", true); }
});
}, true);
bagExtras = function(c, freeN){ return 0; };
var snapT = null;
function snapSoon(){ clearTimeout(snapT); snapT = setTimeout(snapNow, 250); }
function snapNow(){
try {
var out = [];
S.br.forEach(function(b, i){
var n = piecesOf(b).length; if (!n) return;
var d = document.createElement("div"); renderRow(d, 18, b, {});
out.push({name: "Bracelet " + (i+1) + " · " + BASE_NAME[b.base], base: b.base, size: b.size, n: n, sizeLbl: SIZE_LBL[b.size].replace("Wrist ", ""), w: parseFloat(d.style.width), h: parseFloat(d.style.height), html: d.innerHTML});
});
store("csb_snap", JSON.stringify({at: Date.now(), sig: builderCounts(), br: out}));
if (window.CS && CS.renderBag) CS.renderBag();
} catch(e){}
}
function heartToTheme(key, name){
if (!window.CS || !CS.hearts) return;
var p = key.split("#"), i = HIDX[p[0]], vi = p.length > 1 ? +p[1] : null; if (i == null) return;
var it = D.items[i], vid = vi == null ? it.id : it.vv[vi][5], k = vi == null ? it.h : it.h + ":" + vid;
var list = CS.hearts.read().filter(function(x){ return x.k !== k; });
if (S.hearts[key]) list.unshift({k: k, h: it.h, v: vid || null, t: name || designName(i, vi), p: Math.round(priceOf(i, vi) * 100), n: it.vv ? it.vv.length : 1, at: Date.now(), i: ""});
CS.hearts.write(list);
}
function heartsFromTheme(){
if (!window.CS || !CS.hearts) return;
var next = {};
CS.hearts.read().forEach(function(x){
var r = x.v ? REF[x.v] : null, i = r ? r[0] : HIDX[x.h]; if (i == null) return;
var key = r && r[1] != null ? D.items[i].h + "#" + r[1] : D.items[i].h; next[key] = x.at || Date.now();
});
S.hearts = next; store("cs_hearts", JSON.stringify(S.hearts)); updateCounts();
}
openBag = function(){ flushSync(); if (window.CS) CS.open("csBag"); };
window.CSB_SYNC = function(){ return {pending: !!(syncing || syncT || retryT || dirty()), inflight: syncing, charms: totals().c}; };
var renderMeter0 = renderMeter;
renderMeter = function(){
renderMeter0();
if (!STORE || !booted || syncing || syncT || dirty() || !window.CS || !CS.bagTotal) return;
var cc = CS.getCart && CS.getCart(), bt = cc ? cc.total_price : null, T = totals(), c = T.c; if (bt == null || !c) return;
if (Math.abs(bt / 100 - T.paid) < 0.005) return;
var tn = $("dockSum").firstChild;
if (tn && tn.nodeType === 3) tn.nodeValue = (S.br.length > 1 ? S.br.length + " bracelets · " : "") + c + " charm" + (c > 1 ? "s" : "") + " · " + money(bt / 100);
};
window.CSB_TOTAL = function(){ if (!booted || syncing || syncT || dirty() || !window.CS || !CS.getCart) return null; var cc = CS.getCart(); return cc && cc.total_price != null ? cc.total_price / 100 : null; };
var PHC = (window.CSB && CSB.photo) || null, PHM = {}, PHS = {}, PHL = {}, PHI = {}, PHQ = {}, phN = 0, phRT = 0;
var PHB = "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7";
function phLine(it){ return !!(PHC && it && (it.handle === PHC.handle || (PHC.gift && it.handle === PHC.gift))); }
function isPhK(v){ return typeof v === "string" && v.indexOf("ph:") === 0; }
function phUid(it){ var p = it.properties || {}; return p._ccz && p._ccz !== "1" ? String(p._ccz) : String(p.Design || it.key); }
function phGiftK(v){ return isPhK(v) && !!(PHM[v.slice(3)] && PHM[v.slice(3)].gift); }
function phPending(p){ var it = p && D.items[p.i]; return !!(it && it.ph && it.ph.pending); }
function phUrl(u){ u = String(u || ""); return u.indexOf("//") === 0 ? "https:" + u : u; }
function phPrice(m){ if (m.gift) return 0; var c = m.size === "long" ? PHC.priceLong : PHC.price; return (Number(c) || 0) / 100; }
function phNote(it){
var p = it.properties || {}, u = phUid(it), vt = String(it.variant_title || ""), m = PHM[u] || (PHM[u] = {uid: u});
m.metal = /gold/i.test(vt) ? "Gold" : "Silver"; m.size = /long/i.test(vt) ? "long" : "standard";
m.design = phUrl(p.Design) || m.design || ""; m.words = p.Words ? String(p.Words).split(" / ") : null; m.mode = m.words ? "words" : "photo"; m.font = p._cczf || m.font || ""; m.align = p._ccza || "";
m.gift = !!(PHC.gift && it.handle === PHC.gift); m.variant = (PHC.variants || {})[vt] || m.variant || it.variant_id;
m.props = {}; Object.keys(p).forEach(function(k){ m.props[k] = p[k]; });
var e = PHI[u];
if (e){
var x = D.items[e.i].ph, edited = !!(x.design && m.design && x.design !== m.design) || String(x.words || "") !== String(m.words || "") || (m.font && x.font !== m.font) || (x.align || "") !== (m.align || "");
if (x.gift !== m.gift || (!x.design && m.design) || (edited && !x.pending)){
if (edited && !x.pending){ x.design = m.design; x.words = m.words; x.mode = m.mode; x.font = m.font; x.align = m.align; PHL[u] = null; }
x.gift = m.gift; x.design = x.design || m.design; D.items[e.i].p = phPrice(x); phPaint(u);
}
}
return "ph:" + u;
}
function phRegister(m){
var e = PHI[m.uid];
if (!e){
var long = m.size === "long", W = long ? 400 : 200, sid = "ph" + (++phN);
e = PHI[m.uid] = {i: D.items.length, a: D.A.length, sid: sid};
D.items.push({h: "ph:" + m.uid, t: "Photo charm", n: "photo charm", p: 0, c: [], g: [], st: [], z: 1, ph: {}});
D.A.push([sid, 0, 0, W, 175, 0, 0, W, 175, long ? 3 : 0, 1, 0, 0]);
if (D.sh) D.sh[sid] = 175;
}
var it = D.items[e.i], x = it.ph;
["uid", "metal", "size", "mode", "design", "font", "variant"].forEach(function(k){ if (m[k] != null && m[k] !== "") x[k] = m[k]; });
x.words = m.words || x.words || null; if (m.align != null) x.align = m.align; x.gift = !!m.gift; x.pending = !!m.pending;
it.p = phPrice(x); it.t = x.words && x.words.length ? "Photo charm · " + x.words.join(" ") : "Photo charm";
phPaint(m.uid);
return e;
}
function phPiece(m, restored){ if (restored) m.pending = false; var e = phRegister(m), a = E(e.a); return {i: e.i, vi: null, a: e.a, kind: a[9], span: 1, ph: D.items[e.i].ph}; }
function pieceFor(v){
if (!isPhK(v)){ var r = REF[v]; return r ? makePiece(r[0], r[1]) : null; }
var u = v.slice(3), e = PHI[u], it = e && D.items[e.i], m = PHM[u];
if (it && it.ph.pending && allPieces().some(function(p){ return p.i === e.i; })){ it.ph.pending = false; if (m){ it.ph.design = m.design || it.ph.design; it.ph.gift = m.gift; it.p = phPrice(it.ph); } return true; }
return m ? phPiece(m) : null;
}
function phReAdd(v, target, out){
var m = PHM[v.slice(3)]; if (!m || !m.design || !target) return;
var props = {}; Object.keys(m.props || {}).forEach(function(k){ props[k] = m.props[k]; }); props.Design = m.design;
out.push({id: (PHC.variants || {})[(m.metal) + " / " + (m.size === "long" ? "Long" : "Standard")] || m.variant, quantity: target, properties: props});
}
function whenCCZ(fn){ if (window.CCZ && CCZ.flat) fn(); else document.addEventListener("ccz:ready", function f(){ document.removeEventListener("ccz:ready", f); fn(); }); }
function phRepaint(){ clearTimeout(phRT); phRT = setTimeout(function(){ if (!D) return; renderStage(); if (typeof snapSoon === "function") snapSoon(); }, 40); }
function phPaint(u){
var e = PHI[u], it = e && D.items[e.i]; if (!it) return;
var m = it.ph, look = PHL[u], sig = (m.design || "") + "|" + (look ? 1 : 0) + "|" + (m.words || []).join("/") + "|" + m.font + "|" + (m.align || "");
if (e.sig === sig || PHQ[u]) return;
PHQ[u] = 1;
function done(src){
CCZ.flat({metal: m.metal, size: m.size, mode: m.mode, words: m.words, font: m.font, align: m.align, look: src}, function(cv){
var sh = document.createElement("canvas"); sh.width = SW; sh.height = 175; sh.getContext("2d").drawImage(cv, 0, 0);
var url = ""; try { url = sh.toDataURL("image/webp", 0.9); if (url.indexOf("data:image/webp") !== 0) url = sh.toDataURL("image/png"); } catch(x){ url = ""; }
delete PHQ[u]; if (url){ e.sig = sig; PHS[e.sid] = url; phRepaint(); }
});
}
whenCCZ(function(){
if (m.mode === "words") CCZ.fontReady(m.font).then(function(){ done(null); });
else if (look) done(look);
else if (m.design){ var im = new Image(); im.crossOrigin = "anonymous"; im.onload = function(){ done(im); }; im.onerror = function(){ done(null); }; im.src = m.design; }
else done(null);
});
}
var inScope0 = inScope; inScope = function(it, i){ return !it.ph && inScope0(it, i); };
var makePiece0 = makePiece; makePiece = function(i, vi){ var it = D.items[i]; if (it && it.ph) return phPiece(it.ph); return makePiece0(i, vi); };
charmCount = function(){ var n = 0; allPieces().forEach(function(p){ var it = D.items[p.i]; if (!(it && it.ph && it.ph.gift)) n++; }); return n; };
function phCardOn(){
if (!PHC || !window.CCZ_CFG || (S.page || 1) > 1) return false;
var q = String(S.q || "").trim().toLowerCase();
if (q) return /(^|\s)(photo|picture|pic|custom|personal|engrav|name|word|text|initial|date|memorial|portrait|your)/.test(q);
return S.scope.t === "all" || S.scope.t === "new";
}
var renderGrid0 = renderGrid; renderGrid = function(){ renderGrid0(); phCard(); };
function phCard(){
var g = $("grid"); if (!g || !phCardOn()) return;
var card = g.querySelector(".phcard");
if (!card){
card = document.createElement("div"); card.className = "card phcard";
card.innerHTML = '<div class="pic"><img class="phimg" src="' + PHC.img + '" alt="" width="300" height="300">' +
'<span class="phx" aria-hidden="true"><span class="k"></span><b>Your photo, on a charm</b><small>Or a name, engraved</small><span class="go">Design yours</span></span><span class="phon"></span>' +
'<button type="button" class="tap" aria-label="Make a photo charm: your photo or words"></button></div><div class="n">Photo Charm</div>' +
'<div class="pr"><span class="php"></span><div class="acts"><button type="button" class="add" aria-label="Make a photo charm">' + SV.plus + '</button></div></div>';
Array.prototype.forEach.call(card.querySelectorAll("button"), function(b){ b.addEventListener("click", function(){ phOpen(card.querySelector(".phimg")); }); });
}
if (g.firstChild !== card) g.insertBefore(card, g.firstChild);
var on = 0, gift = 0, base = e1Base(), need = PHC.need || 15;
allPieces().forEach(function(p){ var it = D.items[p.i]; if (it && it.ph){ on++; if (it.ph.gift) gift++; } });
var free = !!(PHC.gift && base >= need && !gift);
var k = card.querySelector(".k"), pr = card.querySelector(".php"), o = card.querySelector(".phon");
k.textContent = free ? "Free now" : "New"; k.classList.toggle("fr", free);
var ph = free ? '<s>' + money(PHC.price / 100) + '</s> <b class="phfr">Free</b>' : money(PHC.price / 100) + (PHC.gift && !gift ? '<small class="phf">free with ' + need + ' charms</small>' : '');
if (pr._h !== ph){ pr._h = ph; pr.innerHTML = ph; }
var oh = on ? '<span class="onb">' + SV.tick + 'In bag' + (on > 1 ? ' \u00d7' + on : '') + '</span>' : "";
if (o._h !== oh){ o._h = oh; o.innerHTML = oh; }
}
function e1Base(){ var n = 0; if (!D) return 0; allPieces().forEach(function(p){ var it = D.items[p.i]; if (!(it && it.ph)) n++; }); return n; }
function phPhase(c){ if (!PHC || !PHC.gift || !D) return false; var b = e1Base(); return c === b && b >= 10 && b < (PHC.need || 15) && !phOnBr(); }
function phAddMsg(c){ if (!PHC || !PHC.gift || !D || phOnBr()) return 0; var b = e1Base(), need = PHC.need || 15; if (c !== b) return 0; if (b < need) return 1; if (b === need) return need + " charms. A photo charm is free now"; return 0; }
function phSheetLine(gx, lx){
if (!PHC || !PHC.gift || !D) return;
var gift = 0, b = e1Base(), need = PHC.need || 15, was = money(PHC.price / 100);
allPieces().forEach(function(p){ var it = D.items[p.i]; if (it && it.ph && it.ph.gift) gift++; });
if (gift) e1Line(gx, {img: PHC.img, name: "Photo charm", sub: "Free with your " + need + " charms", check: true, free: true, was: was});
else if (b >= need) e1Line(gx, {img: PHC.img, name: "Photo charm", sub: "Unlocked: make yours from the first card", lock: true, was: was});
else e1Line(lx, {img: PHC.img, name: "Photo charm", sub: "Add " + (need - b) + " more charm" + (need - b === 1 ? "" : "s") + " · your photo or words", bar: b / need * 100, lock: true, was: was});
}
function phOnBr(){ var n = 0; if (!D) return 0; allPieces().forEach(function(p){ var it = D.items[p.i]; if (it && it.ph) n++; }); return n; }
function phOpen(src){
var o = {ctx: "builder", metal: B.base === "gold" ? "Gold" : "Silver", cta: "Add to bracelet", onStart: function(m){ phStart(m, src); }, onDone: phDone};
if (window.CCZ && CCZ.open) CCZ.open(o); else if (window.CS && CS.designer) CS.designer(o);
}
function phStart(m, src){
PHL[m.uid] = m.look || null;
addPiece(phPiece({uid: m.uid, metal: m.metal, size: m.size, mode: m.mode, words: m.words, font: m.font, align: m.align || "", gift: m.gift, variant: m.variant, pending: true, design: ""}), src);
}
function phDone(m, line, err){
var e = PHI[m.uid], it = e && D.items[e.i]; if (!it) return;
if (err || !line){
S.br.forEach(function(b){ for (var s = 0; s < b.size; s++){ var p = b.slots[s]; if (p && p.i === e.i) clearAt(b, s); } });
update(); toast(err || "Your photo charm could not be added. Please try again."); return;
}
phNote(line);
if (it.ph.pending){
it.ph.pending = false; it.ph.design = PHM[m.uid].design; it.ph.gift = PHM[m.uid].gift; it.p = phPrice(it.ph);
if (BASE){ var k = "ph:" + m.uid; BASE[k] = Math.max(BASE[k] || 0, line.quantity); }
saveState(); update();
}
}
function storeBoot(){
var R = Math.round((Number(CSB.ratio) || 1) * 200) / 200;
var rnd = function(x){ return Math.round(x * R * 100 + 1e-6) / 100; };
var FXR = Number(window.Shopify && Shopify.currency && Shopify.currency.rate) || 1;
var K = Math.round((Number(CSB.ratio) || 1) / FXR * 200) / 200;
var loc = function(x){ var m = Math.round(x * K * 100 + 1e-6) / 100; return Math.round(m * FXR * 100 + 1e-6) / 100; };
if (Math.abs(K * FXR - 1) > 0.0001){ D.items.forEach(function(it){ it.p = loc(it.p); if (it.vv) it.vv.forEach(function(v){ if (v[6] != null) v[6] = loc(v[6]); }); }); (D.sale || []).forEach(function(x){ x[2] = loc(x[2]); }); SALE = null; Object.keys(BASE_PRICE).forEach(function(k){ BASE_PRICE[k] = loc(BASE_PRICE[k]); }); }
var bpz = CSB.bracelet && CSB.bracelet.price; if (bpz) Object.keys(bpz).forEach(function(k){ if (bpz[k] > 0) BASE_PRICE[k] = bpz[k]; });
if (store("csb_flags_v") !== "3"){ FLAGS.concat(["csb_tool_added"]).forEach(function(k){ store(k, ""); }); store("csb_flags_v", "3"); }
buildRef(); S.asked = true; loadState();
if (CSB.edit && ((CSB.edit.keys && CSB.edit.keys.length) || (CSB.edit.ids && CSB.edit.ids.length))){
var wd = CSB.edit.keys && CSB.edit.keys.length ? CSB.edit.keys.map(function(k){
var i = k && HIDX[k.h]; if (i == null) return null;
var it = D.items[i]; if (!it.vv) return [i, -1];
var vn = String(k.v || "").toLowerCase(), vi = -1;
if (!vn) return [i, 0];
it.vv.forEach(function(v, j){ if (vi < 0 && (String(v[0]).toLowerCase() === vn || String(v[1]).toLowerCase() === vn)) vi = j; });
return vi < 0 ? null : [i, vi];
}).filter(Boolean) : CSB.edit.ids.map(function(v){ return REF[v]; }).filter(Boolean).map(function(r){ return [r[0], r[1] == null ? -1 : r[1]]; });
if (wd.length) D.edit = {t: CSB.edit.t || D.edit.t, b: CSB.edit.b || D.edit.b, d: wd};
}
var go = function(c){
document.removeEventListener("cs:cart", first); cartAt = Date.now();
heartsFromTheme(); fromCart(c); booted = true; window.CSB_READY = true;
var re = early.splice(0); if (re.length){ re.forEach(function(e){ placeAny(makePiece(e[0], e[1])); }); update(); }
else { var pl = plan(c); if (pl.n || pl.add.length) scheduleSync(); }
var q = new URLSearchParams(location.search).get("add");
if (q){
var parts = q.split(":"), i = HIDX[parts[0]], v = Number(parts[1]), r = REF[v];
if (r){ var on = allPieces().some(function(p){ return String(vidOf(p)) === String(v); }); if (!on) addPiece(makePiece(r[0], r[1])); }
else if (i != null){ var it = D.items[i]; if (it.vv && it.vv.length > 1) startAdd(i, null); else if (vidOf({i: i, vi: it.vv && it.vv.length ? 0 : null})) startAdd(i, null); }
try { var u = new URL(location.href); u.searchParams.delete("add"); history.replaceState(null, "", u.toString()); } catch(e){}
}
if (location.hash === "#for-you") setTimeout(openHub, 300);
};
var first = function(e){ go(e.detail.cart); };
if (window.CS && CS.getCart && CS.getCart()) go(CS.getCart()); else document.addEventListener("cs:cart", first);
document.addEventListener("cs:cart", function(e){ cartAt = Date.now(); if (booted){ fromCart(e.detail.cart); renderMeter(); } });
document.addEventListener("cs:hearts", function(){ if (booted && !SUPPRESS) heartsFromTheme(); });
}
var loadTries = 0;
function loadData(){
$("grid").innerHTML = ""; $("stage").classList.add("ld");
fetch(STORE ? CSB.data : "charms.json", {priority: "high"}).then(function(r){ if (!r.ok) throw new Error("HTTP " + r.status); return r.json(); }).then(function(d){
if (D) return;
D = d; SW = d.sw || 1024; D.items.forEach(function(it, i){ HIDX[it.h] = i; }); (d.z || []).forEach(function(i){ if (d.items[i]) d.items[i].z = 1; }); (d.zv || []).forEach(function(r){ var it = d.items[r[0]]; if (it){ ZV[r[0] + ":" + r[1]] = 1; it.zh = 1; } }); buildIdx();
fit($("seeAllLink"), D.plain.silver, 56, 0.8);
var nd = D.items.reduce(function(a, it, i){ return a + (it.z ? 0 : it.vv ? it.vv.filter(function(v, k){ return !ZV[i + ":" + k]; }).length : 1); }, 0);
$("designCount").textContent = nd.toLocaleString() + " designs";
$("q").placeholder = "Search " + nd.toLocaleString() + " designs, like cat, Leo or cherry";
$("stage").classList.remove("ld");
restoreView();
if (location.hash === "#sets"){ S.scope = {t: "sets"}; S.sub = -1; S.page = 1; setTimeout(toSets, 250); }
if (location.hash === "#sale"){ S.scope = {t: "sale"}; S.sub = -1; S.page = 1; setTimeout(toSets, 250); }
if (location.hash === "#new"){ S.scope = {t: "new"}; S.sub = -1; S.page = 1; setTimeout(toSets, 250); }
renderPicker(false); if (STORE) storeBoot(); else update(); scrollToSlot(Math.floor(B.size/2) - 1, false); onScroll();
}, function(){
loadTries++; $("stage").classList.remove("ld");
var box = document.createElement("div"); box.className = "empty"; box.appendChild(document.createTextNode("Charms could not load. Check your connection and try again."));
var b = document.createElement("button"); b.type = "button"; b.className = "btn"; b.style.marginTop = "12px"; b.textContent = "Try again"; b.addEventListener("click", loadData);
box.appendChild(document.createElement("br")); box.appendChild(b); $("grid").innerHTML = ""; $("grid").appendChild(box);
if (loadTries < 3) setTimeout(function(){ if (!D) loadData(); }, 2500 * loadTries);
});
}
loadData();
})();
